
import { i19a as en_usi19a } from './src/en_us/'

import { i19about as en_usi19about } from './src/en_us/'

import { i19aboutCvvMsg as en_usi19aboutCvvMsg } from './src/en_us/'

import { i19aboveOf as en_usi19aboveOf } from './src/en_us/'

import { i19acceptAttachedFile as en_usi19acceptAttachedFile } from './src/en_us/'

import { i19acceptCustomOptionByCustomer as en_usi19acceptCustomOptionByCustomer } from './src/en_us/'

import { i19activate as en_usi19activate } from './src/en_us/'

import { i19active as en_usi19active } from './src/en_us/'

import { i19add as en_usi19add } from './src/en_us/'

import { i19addApp as en_usi19addApp } from './src/en_us/'

import { i19addCart as en_usi19addCart } from './src/en_us/'

import { i19addClient as en_usi19addClient } from './src/en_us/'

import { i19addDiscountCoupon as en_usi19addDiscountCoupon } from './src/en_us/'

import { i19addGiftList as en_usi19addGiftList } from './src/en_us/'

import { i19addGrid as en_usi19addGrid } from './src/en_us/'

import { i19additional as en_usi19additional } from './src/en_us/'

import { i19additionalComments as en_usi19additionalComments } from './src/en_us/'

import { i19additionalCost as en_usi19additionalCost } from './src/en_us/'

import { i19additionalCostOption as en_usi19additionalCostOption } from './src/en_us/'

import { i19additionalInfo as en_usi19additionalInfo } from './src/en_us/'

import { i19additionalNotes as en_usi19additionalNotes } from './src/en_us/'

import { i19address as en_usi19address } from './src/en_us/'

import { i19addresses as en_usi19addresses } from './src/en_us/'

import { i19addressesName as en_usi19addressesName } from './src/en_us/'

import { i19addMoreProducts as en_usi19addMoreProducts } from './src/en_us/'

import { i19addPreference as en_usi19addPreference } from './src/en_us/'

import { i19addProduct as en_usi19addProduct } from './src/en_us/'

import { i19addToCart as en_usi19addToCart } from './src/en_us/'

import { i19addToFavorites as en_usi19addToFavorites } from './src/en_us/'

import { i19addToPrice as en_usi19addToPrice } from './src/en_us/'

import { i19addVariants as en_usi19addVariants } from './src/en_us/'

import { i19add$1ToEarn as en_usi19add$1ToEarn } from './src/en_us/'

import { i19adminSettings as en_usi19adminSettings } from './src/en_us/'

import { i19adRelevance as en_usi19adRelevance } from './src/en_us/'

import { i19adType as en_usi19adType } from './src/en_us/'

import { i19advanced as en_usi19advanced } from './src/en_us/'

import { i19adwords as en_usi19adwords } from './src/en_us/'

import { i19adwordsRemarketing as en_usi19adwordsRemarketing } from './src/en_us/'

import { i19adwordsRemarketingCode as en_usi19adwordsRemarketingCode } from './src/en_us/'

import { i19affiliateCoede as en_usi19affiliateCoede } from './src/en_us/'

import { i19afterApproval as en_usi19afterApproval } from './src/en_us/'

import { i19afterPayment as en_usi19afterPayment } from './src/en_us/'

import { i19all as en_usi19all } from './src/en_us/'

import { i19allCategories as en_usi19allCategories } from './src/en_us/'

import { i19allOptions as en_usi19allOptions } from './src/en_us/'

import { i19alt as en_usi19alt } from './src/en_us/'

import { i19amount as en_usi19amount } from './src/en_us/'

import { i19another as en_usi19another } from './src/en_us/'

import { i19anyPaymentMethodMsg as en_usi19anyPaymentMethodMsg } from './src/en_us/'

import { i19api as en_usi19api } from './src/en_us/'

import { i19app as en_usi19app } from './src/en_us/'

import { i19appAlreadyInstalledMsg as en_usi19appAlreadyInstalledMsg } from './src/en_us/'

import { i19appConfiguration as en_usi19appConfiguration } from './src/en_us/'

import { i19apps as en_usi19apps } from './src/en_us/'

import { i19appDevelopers as en_usi19appDevelopers } from './src/en_us/'

import { i19application as en_usi19application } from './src/en_us/'

import { i19applications as en_usi19applications } from './src/en_us/'

import { i19applyDiscount as en_usi19applyDiscount } from './src/en_us/'

import { i19applyFilters as en_usi19applyFilters } from './src/en_us/'

import { i19areYouWantToDeleteAppQn as en_usi19areYouWantToDeleteAppQn } from './src/en_us/'

import { i19associateImage as en_usi19associateImage } from './src/en_us/'

import { i19associateImages as en_usi19associateImages } from './src/en_us/'

import { i19asOf as en_usi19asOf } from './src/en_us/'

import { i19at as en_usi19at } from './src/en_us/'

import { i19atSight as en_usi19atSight } from './src/en_us/'

import { i19attachment as en_usi19attachment } from './src/en_us/'

import { i19attention as en_usi19attention } from './src/en_us/'

import { i19authentication as en_usi19authentication } from './src/en_us/'

import { i19author as en_usi19author } from './src/en_us/'

import { i19authorizedStores as en_usi19authorizedStores } from './src/en_us/'

import { i19automaticallyTrackInventory as en_usi19automaticallyTrackInventory } from './src/en_us/'

import { i19available as en_usi19available } from './src/en_us/'

import { i19availablePurchase as en_usi19availablePurchase } from './src/en_us/'

import { i19availableApps as en_usi19availableApps } from './src/en_us/'

import { i19average as en_usi19average } from './src/en_us/'

import { i19averageTicket as en_usi19averageTicket } from './src/en_us/'

import { i19back as en_usi19back } from './src/en_us/'

import { i19backToCart as en_usi19backToCart } from './src/en_us/'

import { i19backToProduct as en_usi19backToProduct } from './src/en_us/'

import { i19bag as en_usi19bag } from './src/en_us/'

import { i19balanceOrPoints as en_usi19balanceOrPoints } from './src/en_us/'

import { i19banner as en_usi19banner } from './src/en_us/'

import { i19banners as en_usi19banners } from './src/en_us/'

import { i19bannersCollection as en_usi19bannersCollection } from './src/en_us/'

import { i19barcodes as en_usi19barcodes } from './src/en_us/'

import { i19basePrice as en_usi19basePrice } from './src/en_us/'

import { i19bearersDocument as en_usi19bearersDocument } from './src/en_us/'

import { i19best as en_usi19best } from './src/en_us/'

import { i19bestSellers as en_usi19bestSellers } from './src/en_us/'

import { i19biannual as en_usi19biannual } from './src/en_us/'

import { i19billingAddress as en_usi19billingAddress } from './src/en_us/'

import { i19bimonthly as en_usi19bimonthly } from './src/en_us/'

import { i19birthdate as en_usi19birthdate } from './src/en_us/'

import { i19biweekly as en_usi19biweekly } from './src/en_us/'

import { i19block as en_usi19block } from './src/en_us/'

import { i19borough as en_usi19borough } from './src/en_us/'

import { i19budgetOnly as en_usi19budgetOnly } from './src/en_us/'

import { i19buy as en_usi19buy } from './src/en_us/'

import { i19buyAgain as en_usi19buyAgain } from './src/en_us/'

import { i19buyAlsoMsg as en_usi19buyAlsoMsg } from './src/en_us/'

import { i19buyer as en_usi19buyer } from './src/en_us/'

import { i19buyers as en_usi19buyers } from './src/en_us/'

import { i19buyersProfile as en_usi19buyersProfile } from './src/en_us/'

import { i19buyNow as en_usi19buyNow } from './src/en_us/'

import { i19buyKit as en_usi19buyKit } from './src/en_us/'

import { i19by as en_usi19by } from './src/en_us/'

import { i19brand as en_usi19brand } from './src/en_us/'

import { i19brandBanners as en_usi19brandBanners } from './src/en_us/'

import { i19brandName as en_usi19brandName } from './src/en_us/'

import { i19brandFound as en_usi19brandFound } from './src/en_us/'

import { i19brands as en_usi19brands } from './src/en_us/'

import { i19brandsFound as en_usi19brandsFound } from './src/en_us/'

import { i19brazil as en_usi19brazil } from './src/en_us/'

import { i19browserIp as en_usi19browserIp } from './src/en_us/'

import { i19buyWith as en_usi19buyWith } from './src/en_us/'

import { i19calculateShipping as en_usi19calculateShipping } from './src/en_us/'

import { i19callTo as en_usi19callTo } from './src/en_us/'

import { i19callback as en_usi19callback } from './src/en_us/'

import { i19campaign as en_usi19campaign } from './src/en_us/'

import { i19campaignAppliedMsg as en_usi19campaignAppliedMsg } from './src/en_us/'

import { i19cancel as en_usi19cancel } from './src/en_us/'

import { i19cancelled as en_usi19cancelled } from './src/en_us/'

import { i19cancelledAt as en_usi19cancelledAt } from './src/en_us/'

import { i19cancelOrder as en_usi19cancelOrder } from './src/en_us/'

import { i19cancelReason as en_usi19cancelReason } from './src/en_us/'

import { i19cardNumber as en_usi19cardNumber } from './src/en_us/'

import { i19cartConfirmed as en_usi19cartConfirmed } from './src/en_us/'

import { i19cartDetails as en_usi19cartDetails } from './src/en_us/'

import { i19cartItems as en_usi19cartItems } from './src/en_us/'

import { i19cartReview as en_usi19cartReview } from './src/en_us/'

import { i19cartUpdated as en_usi19cartUpdated } from './src/en_us/'

import { i19categories as en_usi19categories } from './src/en_us/'

import { i19category as en_usi19category } from './src/en_us/'

import { i19categoryBanners as en_usi19categoryBanners } from './src/en_us/'

import { i19categoryFound as en_usi19categoryFound } from './src/en_us/'

import { i19categoryName as en_usi19categoryName } from './src/en_us/'

import { i19cellphone as en_usi19cellphone } from './src/en_us/'

import { i19changePaymentMethod as en_usi19changePaymentMethod } from './src/en_us/'

import { i19changeShippingMethod as en_usi19changeShippingMethod } from './src/en_us/'

import { i19channel as en_usi19channel } from './src/en_us/'

import { i19channelId as en_usi19channelId } from './src/en_us/'

import { i19channels as en_usi19channels } from './src/en_us/'

import { i19channelType as en_usi19channelType } from './src/en_us/'

import { i19checkout as en_usi19checkout } from './src/en_us/'

import { i19checkoutEnabled as en_usi19checkoutEnabled } from './src/en_us/'

import { i19checkoutDone as en_usi19checkoutDone } from './src/en_us/'

import { i19checkoutLink as en_usi19checkoutLink } from './src/en_us/'

import { i19checkoutMobileLink as en_usi19checkoutMobileLink } from './src/en_us/'

import { i19checkoutVisitor as en_usi19checkoutVisitor } from './src/en_us/'

import { i19checkoutVisitorMsg as en_usi19checkoutVisitorMsg } from './src/en_us/'

import { i19chooseSubscriptionPeriod as en_usi19chooseSubscriptionPeriod } from './src/en_us/'

import { i19city as en_usi19city } from './src/en_us/'

import { i19clear as en_usi19clear } from './src/en_us/'

import { i19clearFilters as en_usi19clearFilters } from './src/en_us/'

import { i19click as en_usi19click } from './src/en_us/'

import { i19clickHere as en_usi19clickHere } from './src/en_us/'

import { i19close as en_usi19close } from './src/en_us/'

import { i19closedAt as en_usi19closedAt } from './src/en_us/'

import { i19closeFilters as en_usi19closeFilters } from './src/en_us/'

import { i19code as en_usi19code } from './src/en_us/'

import { i19codeCopied as en_usi19codeCopied } from './src/en_us/'

import { i19collection as en_usi19collection } from './src/en_us/'

import { i19collections as en_usi19collections } from './src/en_us/'

import { i19collectionBanners as en_usi19collectionBanners } from './src/en_us/'

import { i19collectionItems as en_usi19collectionItems } from './src/en_us/'

import { i19collectionName as en_usi19collectionName } from './src/en_us/'

import { i19color as en_usi19color } from './src/en_us/'

import { i19colors as en_usi19colors } from './src/en_us/'

import { i19community as en_usi19community } from './src/en_us/'

import { i19companyRegistration as en_usi19companyRegistration } from './src/en_us/'

import { i19compareAtPrice as en_usi19compareAtPrice } from './src/en_us/'

import { i19compareProducts as en_usi19compareProducts } from './src/en_us/'

import { i19comparedPreviousPeriodMsg as en_usi19comparedPreviousPeriodMsg } from './src/en_us/'

import { i19complement as en_usi19complement } from './src/en_us/'

import { i19complementInformation as en_usi19complementInformation } from './src/en_us/'

import { i19connectionErrorMsg as en_usi19connectionErrorMsg } from './src/en_us/'

import { i19connectionErrorProductMsg as en_usi19connectionErrorProductMsg } from './src/en_us/'

import { i19configuration as en_usi19configuration } from './src/en_us/'

import { i19confirmPassword as en_usi19confirmPassword } from './src/en_us/'

import { i19confirmPurchase as en_usi19confirmPurchase } from './src/en_us/'

import { i19contactPhone as en_usi19contactPhone } from './src/en_us/'

import { i19contactUsMsg as en_usi19contactUsMsg } from './src/en_us/'

import { i19content as en_usi19content } from './src/en_us/'

import { i19continue as en_usi19continue } from './src/en_us/'

import { i19continueLoginOnPopup as en_usi19continueLoginOnPopup } from './src/en_us/'

import { i19continueShopping as en_usi19continueShopping } from './src/en_us/'

import { i19control as en_usi19control } from './src/en_us/'

import { i19copyCode as en_usi19copyCode } from './src/en_us/'

import { i19copyErrorMsg as en_usi19copyErrorMsg } from './src/en_us/'

import { i19copyright as en_usi19copyright } from './src/en_us/'

import { i19corporateName as en_usi19corporateName } from './src/en_us/'

import { i19costDeclaredValue as en_usi19costDeclaredValue } from './src/en_us/'

import { i19costPrice as en_usi19costPrice } from './src/en_us/'

import { i19countryCode as en_usi19countryCode } from './src/en_us/'

import { i19couponAppliedMsg as en_usi19couponAppliedMsg } from './src/en_us/'

import { i19createTransaction as en_usi19createTransaction } from './src/en_us/'

import { i19creation as en_usi19creation } from './src/en_us/'

import { i19credit as en_usi19credit } from './src/en_us/'

import { i19creditCard as en_usi19creditCard } from './src/en_us/'

import { i19creditCardBin as en_usi19creditCardBin } from './src/en_us/'

import { i19creditCardCompany as en_usi19creditCardCompany } from './src/en_us/'

import { i19creditCardHolderName as en_usi19creditCardHolderName } from './src/en_us/'

import { i19creditCardLastDigits as en_usi19creditCardLastDigits } from './src/en_us/'

import { i19creditorFees as en_usi19creditorFees } from './src/en_us/'

import { i19creditorFeesIntermediator as en_usi19creditorFeesIntermediator } from './src/en_us/'

import { i19creditorFeesOperational as en_usi19creditorFeesOperational } from './src/en_us/'

import { i19currencyId as en_usi19currencyId } from './src/en_us/'

import { i19currencySymbol as en_usi19currencySymbol } from './src/en_us/'

import { i19custom as en_usi19custom } from './src/en_us/'

import { i19customer as en_usi19customer } from './src/en_us/'

import { i19customerNotified as en_usi19customerNotified } from './src/en_us/'

import { i19customerService as en_usi19customerService } from './src/en_us/'

import { i19customFields as en_usi19customFields } from './src/en_us/'

import { i19customizationAddToPrice as en_usi19customizationAddToPrice } from './src/en_us/'

import { i19customizationAttachment as en_usi19customizationAttachment } from './src/en_us/'

import { i19customizationChosen as en_usi19customizationChosen } from './src/en_us/'

import { i19customizations as en_usi19customizations } from './src/en_us/'

import { i19customPayment as en_usi19customPayment } from './src/en_us/'

import { i19customValue as en_usi19customValue } from './src/en_us/'

import { i19dashboard as en_usi19dashboard } from './src/en_us/'

import { i19dateTime as en_usi19dateTime } from './src/en_us/'

import { i19danger as en_usi19danger } from './src/en_us/'

import { i19day as en_usi19day } from './src/en_us/'

import { i19dailyAverage as en_usi19dailyAverage } from './src/en_us/'

import { i19days as en_usi19days } from './src/en_us/'

import { i19declare as en_usi19declare } from './src/en_us/'

import { i19declaredValue as en_usi19declaredValue } from './src/en_us/'

import { i19delete as en_usi19delete } from './src/en_us/'

import { i19deleteAll as en_usi19deleteAll } from './src/en_us/'

import { i19delivery as en_usi19delivery } from './src/en_us/'

import { i19deliveryCostOwnHandMsg as en_usi19deliveryCostOwnHandMsg } from './src/en_us/'

import { i19deliveryInMsg as en_usi19deliveryInMsg } from './src/en_us/'

import { i19deliveryReceipt as en_usi19deliveryReceipt } from './src/en_us/'

import { i19deliveryReceiptMsg as en_usi19deliveryReceiptMsg } from './src/en_us/'

import { i19deliveryTrack as en_usi19deliveryTrack } from './src/en_us/'

import { i19deliveryTime as en_usi19deliveryTime } from './src/en_us/'

import { i19deliveryWithOwnHandMsg as en_usi19deliveryWithOwnHandMsg } from './src/en_us/'

import { i19description as en_usi19description } from './src/en_us/'

import { i19desktop as en_usi19desktop } from './src/en_us/'

import { i19details as en_usi19details } from './src/en_us/'

import { i19didYouMean as en_usi19didYouMean } from './src/en_us/'

import { i19digits as en_usi19digits } from './src/en_us/'

import { i19directLinkPayment as en_usi19directLinkPayment } from './src/en_us/'

import { i19disable as en_usi19disable } from './src/en_us/'

import { i19discount as en_usi19discount } from './src/en_us/'

import { i19discountCoupon as en_usi19discountCoupon } from './src/en_us/'

import { i19discountOf as en_usi19discountOf } from './src/en_us/'

import { i19discountValueMsg as en_usi19discountValueMsg } from './src/en_us/'

import { i19displayName as en_usi19displayName } from './src/en_us/'

import { i19docCountry as en_usi19docCountry } from './src/en_us/'

import { i19docNumber as en_usi19docNumber } from './src/en_us/'

import { i19docs as en_usi19docs } from './src/en_us/'

import { i19domain as en_usi19domain } from './src/en_us/'

import { i19doPaymentMsg as en_usi19doPaymentMsg } from './src/en_us/'

import { i19doYouWantToDeleteAppQn as en_usi19doYouWantToDeleteAppQn } from './src/en_us/'

import { i19doYouWantToReinstallAppQn as en_usi19doYouWantToReinstallAppQn } from './src/en_us/'

import { i19download as en_usi19download } from './src/en_us/'

import { i19downloadTable as en_usi19downloadTable } from './src/en_us/'

import { i19edit as en_usi19edit } from './src/en_us/'

import { i19editing as en_usi19editing } from './src/en_us/'

import { i19editAdditionalCost as en_usi19editAdditionalCost } from './src/en_us/'

import { i19editComments as en_usi19editComments } from './src/en_us/'

import { i19editDispatchAndFulfillment as en_usi19editDispatchAndFulfillment } from './src/en_us/'

import { i19editFeatures as en_usi19editFeatures } from './src/en_us/'

import { i19editFilters as en_usi19editFilters } from './src/en_us/'

import { i19editGtinMpn as en_usi19editGtinMpn } from './src/en_us/'

import { i19editHtmlDescription as en_usi19editHtmlDescription } from './src/en_us/'

import { i19editObservationInfo as en_usi19editObservationInfo } from './src/en_us/'

import { i19editPaymentDetails as en_usi19editPaymentDetails } from './src/en_us/'

import { i19editProductDimensions as en_usi19editProductDimensions } from './src/en_us/'

import { i19editSeoFields as en_usi19editSeoFields } from './src/en_us/'

import { i19editStorefront as en_usi19editStorefront } from './src/en_us/'

import { i19editVariation as en_usi19editVariation } from './src/en_us/'

import { i19email as en_usi19email } from './src/en_us/'

import { i19emailAddress as en_usi19emailAddress } from './src/en_us/'

import { i19emailCartTextMsg as en_usi19emailCartTextMsg } from './src/en_us/'

import { i19emailCartTitleMsg as en_usi19emailCartTitleMsg } from './src/en_us/'

import { i19emailDeliveredTextMsg as en_usi19emailDeliveredTextMsg } from './src/en_us/'

import { i19emailDeliveredTitleMsg as en_usi19emailDeliveredTitleMsg } from './src/en_us/'

import { i19emailInfoMsg as en_usi19emailInfoMsg } from './src/en_us/'

import { i19emailMarketing as en_usi19emailMarketing } from './src/en_us/'

import { i19emailMarketingOptInMsg as en_usi19emailMarketingOptInMsg } from './src/en_us/'

import { i19emailProfileNotFound as en_usi19emailProfileNotFound } from './src/en_us/'

import { i19emails as en_usi19emails } from './src/en_us/'

import { i19emailShippedTextMsg as en_usi19emailShippedTextMsg } from './src/en_us/'

import { i19emailShippedTitleMsg as en_usi19emailShippedTitleMsg } from './src/en_us/'

import { i19empty as en_usi19empty } from './src/en_us/'

import { i19emptyCart as en_usi19emptyCart } from './src/en_us/'

import { i19emptyCartMsg as en_usi19emptyCartMsg } from './src/en_us/'

import { i19enabled as en_usi19enabled } from './src/en_us/'

import { i19end as en_usi19end } from './src/en_us/'

import { i19endDate as en_usi19endDate } from './src/en_us/'

import { i19endpoint as en_usi19endpoint } from './src/en_us/'

import { i19endsIn as en_usi19endsIn } from './src/en_us/'

import { i19enterEmailCodeMsg as en_usi19enterEmailCodeMsg } from './src/en_us/'

import { i19enterYourDocNumber as en_usi19enterYourDocNumber } from './src/en_us/'

import { i19enterYourDocNumberMsg as en_usi19enterYourDocNumberMsg } from './src/en_us/'

import { i19enterYourEmail as en_usi19enterYourEmail } from './src/en_us/'

import { i19enterYourEmailMsg as en_usi19enterYourEmailMsg } from './src/en_us/'

import { i19erp as en_usi19erp } from './src/en_us/'

import { i19error as en_usi19error } from './src/en_us/'

import { i19errorMsg as en_usi19errorMsg } from './src/en_us/'

import { i19events as en_usi19events } from './src/en_us/'

import { i19export as en_usi19export } from './src/en_us/'

import { i19exportToCsv as en_usi19exportToCsv } from './src/en_us/'

import { i19extra as en_usi19extra } from './src/en_us/'

import { i19extraCost as en_usi19extraCost } from './src/en_us/'

import { i19external as en_usi19external } from './src/en_us/'

import { i19familyName as en_usi19familyName } from './src/en_us/'

import { i19favorites as en_usi19favorites } from './src/en_us/'

import { i19featuredApps as en_usi19featuredApps } from './src/en_us/'

import { i19female as en_usi19female } from './src/en_us/'

import { i19field as en_usi19field } from './src/en_us/'

import { i19files as en_usi19files } from './src/en_us/'

import { i19filter as en_usi19filter } from './src/en_us/'

import { i19filterProducts as en_usi19filterProducts } from './src/en_us/'

import { i19filterResults as en_usi19filterResults } from './src/en_us/'

import { i19finalPrice as en_usi19finalPrice } from './src/en_us/'

import { i19finalPriceWithAdditional as en_usi19finalPriceWithAdditional } from './src/en_us/'

import { i19financialStatus as en_usi19financialStatus } from './src/en_us/'

import { i19firstSteps as en_usi19firstSteps } from './src/en_us/'

import { i19followingAddress as en_usi19followingAddress } from './src/en_us/'

import { i19for as en_usi19for } from './src/en_us/'

import { i19free as en_usi19free } from './src/en_us/'

import { i19freebie as en_usi19freebie } from './src/en_us/'

import { i19freeShipping as en_usi19freeShipping } from './src/en_us/'

import { i19freeShippingFrom as en_usi19freeShippingFrom } from './src/en_us/'

import { i19freight as en_usi19freight } from './src/en_us/'

import { i19freightCost as en_usi19freightCost } from './src/en_us/'

import { i19from as en_usi19from } from './src/en_us/'

import { i19fulfillmentStatus as en_usi19fulfillmentStatus } from './src/en_us/'

import { i19fullName as en_usi19fullName } from './src/en_us/'

import { i19fullscreen as en_usi19fullscreen } from './src/en_us/'

import { i19gateway as en_usi19gateway } from './src/en_us/'

import { i19gender as en_usi19gender } from './src/en_us/'

import { i19genderX as en_usi19genderX } from './src/en_us/'

import { i19general as en_usi19general } from './src/en_us/'

import { i19generateBillet as en_usi19generateBillet } from './src/en_us/'

import { i19get as en_usi19get } from './src/en_us/'

import { i19giftList as en_usi19giftList } from './src/en_us/'

import { i19giftListAuthors as en_usi19giftListAuthors } from './src/en_us/'

import { i19giftListAuthorsContact as en_usi19giftListAuthorsContact } from './src/en_us/'

import { i19giftListDescription as en_usi19giftListDescription } from './src/en_us/'

import { i19giftListEventDate as en_usi19giftListEventDate } from './src/en_us/'

import { i19giftListInformation as en_usi19giftListInformation } from './src/en_us/'

import { i19giftListNotificationPurchaseMsg as en_usi19giftListNotificationPurchaseMsg } from './src/en_us/'

import { i19giftListPermalink as en_usi19giftListPermalink } from './src/en_us/'

import { i19giftListTitle as en_usi19giftListTitle } from './src/en_us/'

import { i19giftListValidThru as en_usi19giftListValidThru } from './src/en_us/'

import { i19giftListOwnerID as en_usi19giftListOwnerID } from './src/en_us/'

import { i19giftListWaiting as en_usi19giftListWaiting } from './src/en_us/'

import { i19giftTo as en_usi19giftTo } from './src/en_us/'

import { i19giftWrap as en_usi19giftWrap } from './src/en_us/'

import { i19gitRepository as en_usi19gitRepository } from './src/en_us/'

import { i19givenName as en_usi19givenName } from './src/en_us/'

import { i19goToCart as en_usi19goToCart } from './src/en_us/'

import { i19goToStore as en_usi19goToStore } from './src/en_us/'

import { i19goToTop as en_usi19goToTop } from './src/en_us/'

import { i19googleAnalytics as en_usi19googleAnalytics } from './src/en_us/'

import { i19googleProductCategoryId as en_usi19googleProductCategoryId } from './src/en_us/'

import { i19gridId as en_usi19gridId } from './src/en_us/'

import { i19grids as en_usi19grids } from './src/en_us/'

import { i19gridName as en_usi19gridName } from './src/en_us/'

import { i19guestCheckoutMsg as en_usi19guestCheckoutMsg } from './src/en_us/'

import { i19hasCouponOrVoucherQn as en_usi19hasCouponOrVoucherQn } from './src/en_us/'

import { i19height as en_usi19height } from './src/en_us/'

import { i19hello as en_usi19hello } from './src/en_us/'

import { i19helloAgain as en_usi19helloAgain } from './src/en_us/'

import { i19help as en_usi19help } from './src/en_us/'

import { i19helpful as en_usi19helpful } from './src/en_us/'

import { i19high as en_usi19high } from './src/en_us/'

import { i19highestPrice as en_usi19highestPrice } from './src/en_us/'

import { i19highPriority as en_usi19highPriority } from './src/en_us/'

import { i19holderName as en_usi19holderName } from './src/en_us/'

import { i19home as en_usi19home } from './src/en_us/'

import { i19icon as en_usi19icon } from './src/en_us/'

import { i19id as en_usi19id } from './src/en_us/'

import { i19identification as en_usi19identification } from './src/en_us/'

import { i19identifyYourAccount as en_usi19identifyYourAccount } from './src/en_us/'

import { i19idOfShippingLine as en_usi19idOfShippingLine } from './src/en_us/'

import { i19image as en_usi19image } from './src/en_us/'

import { i19images as en_usi19images } from './src/en_us/'

import { i19import as en_usi19import } from './src/en_us/'

import { i19in as en_usi19in } from './src/en_us/'

import { i19inactive as en_usi19inactive } from './src/en_us/'

import { i19incorrect as en_usi19incorrect } from './src/en_us/'

import { i19incorrectFormat as en_usi19incorrectFormat } from './src/en_us/'

import { i19incorrectEmailCodeMsg as en_usi19incorrectEmailCodeMsg } from './src/en_us/'

import { i19info as en_usi19info } from './src/en_us/'

import { i19inscriptionNumber as en_usi19inscriptionNumber } from './src/en_us/'

import { i19insert as en_usi19insert } from './src/en_us/'

import { i19install as en_usi19install } from './src/en_us/'

import { i19installed as en_usi19installed } from './src/en_us/'

import { i19installedApps as en_usi19installedApps } from './src/en_us/'

import { i19installingApp as en_usi19installingApp } from './src/en_us/'

import { i19installment as en_usi19installment } from './src/en_us/'

import { i19installments as en_usi19installments } from './src/en_us/'

import { i19installNow as en_usi19installNow } from './src/en_us/'

import { i19inStock as en_usi19inStock } from './src/en_us/'

import { i19inStockAt as en_usi19inStockAt } from './src/en_us/'

import { i19interestFree as en_usi19interestFree } from './src/en_us/'

import { i19intermediator as en_usi19intermediator } from './src/en_us/'

import { i19invalidCard as en_usi19invalidCard } from './src/en_us/'

import { i19invalidCardMsg as en_usi19invalidCardMsg } from './src/en_us/'

import { i19invalidCouponMsg as en_usi19invalidCouponMsg } from './src/en_us/'

import { i19invalidDomainName as en_usi19invalidDomainName } from './src/en_us/'

import { i19invalidLoginInfoMsg as en_usi19invalidLoginInfoMsg } from './src/en_us/'

import { i19inventory as en_usi19inventory } from './src/en_us/'

import { i19inventoryHistory as en_usi19inventoryHistory } from './src/en_us/'

import { i19invoice as en_usi19invoice } from './src/en_us/'

import { i19invoices as en_usi19invoices } from './src/en_us/'

import { i19iReadAndAccept as en_usi19iReadAndAccept } from './src/en_us/'

import { i19isFilter as en_usi19isFilter } from './src/en_us/'

import { i19isNotYou as en_usi19isNotYou } from './src/en_us/'

import { i19item as en_usi19item } from './src/en_us/'

import { i19items as en_usi19items } from './src/en_us/'

import { i19itemsFound as en_usi19itemsFound } from './src/en_us/'

import { i19jurifical as en_usi19jurifical } from './src/en_us/'

import { i19just as en_usi19just } from './src/en_us/'

import { i19keywords as en_usi19keywords } from './src/en_us/'

import { i19kit as en_usi19kit } from './src/en_us/'

import { i19label as en_usi19label } from './src/en_us/'

import { i19LabelOfCustomization as en_usi19LabelOfCustomization } from './src/en_us/'

import { i19last as en_usi19last } from './src/en_us/'

import { i19lastOptions as en_usi19lastOptions } from './src/en_us/'

import { i19lastPurchase as en_usi19lastPurchase } from './src/en_us/'

import { i19lastSearchedTerms as en_usi19lastSearchedTerms } from './src/en_us/'

import { i19lastVisitedProducts as en_usi19lastVisitedProducts } from './src/en_us/'

import { i19latestOrders as en_usi19latestOrders } from './src/en_us/'

import { i19launch as en_usi19launch } from './src/en_us/'

import { i19launching as en_usi19launching } from './src/en_us/'

import { i19length as en_usi19length } from './src/en_us/'

import { i19lineAddress as en_usi19lineAddress } from './src/en_us/'

import { i19list as en_usi19list } from './src/en_us/'

import { i19listOfInvoices as en_usi19listOfInvoices } from './src/en_us/'

import { i19listOfPayments as en_usi19listOfPayments } from './src/en_us/'

import { i19listSubscriptionInvoices as en_usi19listSubscriptionInvoices } from './src/en_us/'

import { i19load as en_usi19load } from './src/en_us/'

import { i19loadMore as en_usi19loadMore } from './src/en_us/'

import { i19loading as en_usi19loading } from './src/en_us/'

import { i19loadDataErrorMsg as en_usi19loadDataErrorMsg } from './src/en_us/'

import { i19loadProductErrorMsg as en_usi19loadProductErrorMsg } from './src/en_us/'

import { i19locale as en_usi19locale } from './src/en_us/'

import { i19login as en_usi19login } from './src/en_us/'

import { i19loginEnabled as en_usi19loginEnabled } from './src/en_us/'

import { i19loginErrorMsg as en_usi19loginErrorMsg } from './src/en_us/'

import { i19loginForOrderDetailsMsg as en_usi19loginForOrderDetailsMsg } from './src/en_us/'

import { i19logo as en_usi19logo } from './src/en_us/'

import { i19logout as en_usi19logout } from './src/en_us/'

import { i19low as en_usi19low } from './src/en_us/'

import { i19lowestPrice as en_usi19lowestPrice } from './src/en_us/'

import { i19loyaltyPoints as en_usi19loyaltyPoints } from './src/en_us/'

import { i19loyaltyPointsName as en_usi19loyaltyPointsName } from './src/en_us/'

import { i19loyaltyPointsPointsValue as en_usi19loyaltyPointsPointsValue } from './src/en_us/'

import { i19madeBy as en_usi19madeBy } from './src/en_us/'

import { i19mainEmail as en_usi19mainEmail } from './src/en_us/'

import { i19male as en_usi19male } from './src/en_us/'

import { i19manageStock as en_usi19manageStock } from './src/en_us/'

import { i19manageYourPurchaseHistory as en_usi19manageYourPurchaseHistory } from './src/en_us/'

import { i19marketing as en_usi19marketing } from './src/en_us/'

import { i19marketplace as en_usi19marketplace } from './src/en_us/'

import { i19marketplaces as en_usi19marketplaces } from './src/en_us/'

import { i19massEdit as en_usi19massEdit } from './src/en_us/'

import { i19maximum as en_usi19maximum } from './src/en_us/'

import { i19maxQuantity as en_usi19maxQuantity } from './src/en_us/'

import { i19measurement as en_usi19measurement } from './src/en_us/'

import { i19media as en_usi19media } from './src/en_us/'

import { i19mediaGallery as en_usi19mediaGallery } from './src/en_us/'

import { i19menu as en_usi19menu } from './src/en_us/'

import { i19metafields as en_usi19metafields } from './src/en_us/'

import { i19metafieldsMsg as en_usi19metafieldsMsg } from './src/en_us/'

import { i19metaTagDescription as en_usi19metaTagDescription } from './src/en_us/'

import { i19middleName as en_usi19middleName } from './src/en_us/'

import { i19minimum as en_usi19minimum } from './src/en_us/'

import { i19minQuantity as en_usi19minQuantity } from './src/en_us/'

import { i19mlCategoryId as en_usi19mlCategoryId } from './src/en_us/'

import { i19mobile as en_usi19mobile } from './src/en_us/'

import { i19mobileLink as en_usi19mobileLink } from './src/en_us/'

import { i19modules as en_usi19modules } from './src/en_us/'

import { i19month as en_usi19month } from './src/en_us/'

import { i19monthly as en_usi19monthly } from './src/en_us/'

import { i19mostPopular as en_usi19mostPopular } from './src/en_us/'

import { i19mostRelevant as en_usi19mostRelevant } from './src/en_us/'

import { i19motorcycleCourier as en_usi19motorcycleCourier } from './src/en_us/'

import { i19myAccount as en_usi19myAccount } from './src/en_us/'

import { i19myAccountAndOrders as en_usi19myAccountAndOrders } from './src/en_us/'

import { i19myCart as en_usi19myCart } from './src/en_us/'

import { i19myFavorites as en_usi19myFavorites } from './src/en_us/'

import { i19myOrders as en_usi19myOrders } from './src/en_us/'

import { i19myShoppingCart as en_usi19myShoppingCart } from './src/en_us/'

import { i19name as en_usi19name } from './src/en_us/'

import { i19nameOnCard as en_usi19nameOnCard } from './src/en_us/'

import { i19namespace as en_usi19namespace } from './src/en_us/'

import { i19namespaceMsg as en_usi19namespaceMsg } from './src/en_us/'

import { i19nearTo as en_usi19nearTo } from './src/en_us/'

import { i19needHelpQn as en_usi19needHelpQn } from './src/en_us/'

import { i19new as en_usi19new } from './src/en_us/'

import { i19newAddress as en_usi19newAddress } from './src/en_us/'

import { i19newOrders as en_usi19newOrders } from './src/en_us/'

import { i19newPassword as en_usi19newPassword } from './src/en_us/'

import { i19newPriceRange as en_usi19newPriceRange } from './src/en_us/'

import { i19newsletter as en_usi19newsletter } from './src/en_us/'

import { i19newsletterReport as en_usi19newsletterReport } from './src/en_us/'

import { i19newVersionAvailableMsg as en_usi19newVersionAvailableMsg } from './src/en_us/'

import { i19next as en_usi19next } from './src/en_us/'

import { i19nickname as en_usi19nickname } from './src/en_us/'

import { i19no as en_usi19no } from './src/en_us/'

import { i19noAdditional as en_usi19noAdditional } from './src/en_us/'

import { i19noAppsAvailable as en_usi19noAppsAvailable } from './src/en_us/'

import { i19noBrand as en_usi19noBrand } from './src/en_us/'

import { i19noCategory as en_usi19noCategory } from './src/en_us/'

import { i19noCollection as en_usi19noCollection } from './src/en_us/'

import { i19noGrid as en_usi19noGrid } from './src/en_us/'

import { i19noItemSelected as en_usi19noItemSelected } from './src/en_us/'

import { i19noNewOrdersMsg as en_usi19noNewOrdersMsg } from './src/en_us/'

import { i19noNumber as en_usi19noNumber } from './src/en_us/'

import { i19noOrder as en_usi19noOrder } from './src/en_us/'

import { i19noPrice as en_usi19noPrice } from './src/en_us/'

import { i19noProduct as en_usi19noProduct } from './src/en_us/'

import { i19noProfileFoundWithEmail as en_usi19noProfileFoundWithEmail } from './src/en_us/'

import { i19noResultsFor as en_usi19noResultsFor } from './src/en_us/'

import { i19normal as en_usi19normal } from './src/en_us/'

import { i19noSavedFavoritesMsg as en_usi19noSavedFavoritesMsg } from './src/en_us/'

import { i19notConfigured as en_usi19notConfigured } from './src/en_us/'

import { i19notFound as en_usi19notFound } from './src/en_us/'

import { i19notifications as en_usi19notifications } from './src/en_us/'

import { i19notified as en_usi19notified } from './src/en_us/'

import { i19notifiedAdmins as en_usi19notifiedAdmins } from './src/en_us/'

import { i19notifiedAdminsMsg as en_usi19notifiedAdminsMsg } from './src/en_us/'

import { i19notifyAboutOrders as en_usi19notifyAboutOrders } from './src/en_us/'

import { i19notes as en_usi19notes } from './src/en_us/'

import { i19noUser as en_usi19noUser } from './src/en_us/'

import { i19number as en_usi19number } from './src/en_us/'

import { i19oauthOnPopup as en_usi19oauthOnPopup } from './src/en_us/'

import { i19of as en_usi19of } from './src/en_us/'

import { i19ofDiscount as en_usi19ofDiscount } from './src/en_us/'

import { i19offer as en_usi19offer } from './src/en_us/'

import { i19on as en_usi19on } from './src/en_us/'

import { i19onFreight as en_usi19onFreight } from './src/en_us/'

import { i19onFollowingAddress as en_usi19onFollowingAddress } from './src/en_us/'

import { i19only as en_usi19only } from './src/en_us/'

import { i19open as en_usi19open } from './src/en_us/'

import { i19openAt as en_usi19openAt } from './src/en_us/'

import { i19openCart as en_usi19openCart } from './src/en_us/'

import { i19openGallery as en_usi19openGallery } from './src/en_us/'

import { i19operational as en_usi19operational } from './src/en_us/'

import { i19option as en_usi19option } from './src/en_us/'

import { i19optionChosen as en_usi19optionChosen } from './src/en_us/'

import { i19options as en_usi19options } from './src/en_us/'

import { i19or as en_usi19or } from './src/en_us/'

import { i19order as en_usi19order } from './src/en_us/'

import { i19orderDetails as en_usi19orderDetails } from './src/en_us/'

import { i19orders as en_usi19orders } from './src/en_us/'

import { i19orderCreated as en_usi19orderCreated } from './src/en_us/'

import { i19orderConfirmationMsg as en_usi19orderConfirmationMsg } from './src/en_us/'

import { i19ordersCount as en_usi19ordersCount } from './src/en_us/'

import { i19orderCode as en_usi19orderCode } from './src/en_us/'

import { i19orderItems as en_usi19orderItems } from './src/en_us/'

import { i19orderNotesInputMsg as en_usi19orderNotesInputMsg } from './src/en_us/'

import { i19orderNumber as en_usi19orderNumber } from './src/en_us/'

import { i19orderObservations as en_usi19orderObservations } from './src/en_us/'

import { i19orderStatus as en_usi19orderStatus } from './src/en_us/'

import { i19orderValue as en_usi19orderValue } from './src/en_us/'

import { i19ordersTotalValue as en_usi19ordersTotalValue } from './src/en_us/'

import { i19organization as en_usi19organization } from './src/en_us/'

import { i19orProceedWith as en_usi19orProceedWith } from './src/en_us/'

import { i19otherCustomers as en_usi19otherCustomers } from './src/en_us/'

import { i19otherCustomersMsg as en_usi19otherCustomersMsg } from './src/en_us/'

import { i19outOfDate as en_usi19outOfDate } from './src/en_us/'

import { i19outOfStock as en_usi19outOfStock } from './src/en_us/'

import { i19ownDelivery as en_usi19ownDelivery } from './src/en_us/'

import { i19ownHand as en_usi19ownHand } from './src/en_us/'

import { i19ownHandCost as en_usi19ownHandCost } from './src/en_us/'

import { i19package as en_usi19package } from './src/en_us/'

import { i19packageInformation as en_usi19packageInformation } from './src/en_us/'

import { i19packageDimensions as en_usi19packageDimensions } from './src/en_us/'

import { i19packageDimensionsInformation as en_usi19packageDimensionsInformation } from './src/en_us/'

import { i19packageWeight as en_usi19packageWeight } from './src/en_us/'

import { i19pageLoaded as en_usi19pageLoaded } from './src/en_us/'

import { i19paid as en_usi19paid } from './src/en_us/'

import { i19paidTextMsg as en_usi19paidTextMsg } from './src/en_us/'

import { i19parcelIn as en_usi19parcelIn } from './src/en_us/'

import { i19parentCategory as en_usi19parentCategory } from './src/en_us/'

import { i19partner as en_usi19partner } from './src/en_us/'

import { i19partners as en_usi19partners } from './src/en_us/'

import { i19partnersProgram as en_usi19partnersProgram } from './src/en_us/'

import { i19passwordChangedSuccessfully as en_usi19passwordChangedSuccessfully } from './src/en_us/'

import { i19patch as en_usi19patch } from './src/en_us/'

import { i19payer as en_usi19payer } from './src/en_us/'

import { i19payment as en_usi19payment } from './src/en_us/'

import { i19paymentConfirmed as en_usi19paymentConfirmed } from './src/en_us/'

import { i19paymentDetails as en_usi19paymentDetails } from './src/en_us/'

import { i19paymentError as en_usi19paymentError } from './src/en_us/'

import { i19paymentErrorMsg as en_usi19paymentErrorMsg } from './src/en_us/'

import { i19paymentLink as en_usi19paymentLink } from './src/en_us/'

import { i19paymentMethod as en_usi19paymentMethod } from './src/en_us/'

import { i19paymentMethods as en_usi19paymentMethods } from './src/en_us/'

import { i19paymentMethodLabel as en_usi19paymentMethodLabel } from './src/en_us/'

import { i19paymentOptions as en_usi19paymentOptions } from './src/en_us/'

import { i19paymentRealized as en_usi19paymentRealized } from './src/en_us/'

import { i19personalRegistration as en_usi19personalRegistration } from './src/en_us/'

import { i19permalink as en_usi19permalink } from './src/en_us/'

import { i19perUnit as en_usi19perUnit } from './src/en_us/'

import { i19phone as en_usi19phone } from './src/en_us/'

import { i19phones as en_usi19phones } from './src/en_us/'

import { i19photo as en_usi19photo } from './src/en_us/'

import { i19photos as en_usi19photos } from './src/en_us/'

import { i19pickup as en_usi19pickup } from './src/en_us/'

import { i19pickUpAtTheStore as en_usi19pickUpAtTheStore } from './src/en_us/'

import { i19pickUpToday as en_usi19pickUpToday } from './src/en_us/'

import { i19picture as en_usi19picture } from './src/en_us/'

import { i19pictures as en_usi19pictures } from './src/en_us/'

import { i19pointsEarned as en_usi19pointsEarned } from './src/en_us/'

import { i19popularProducts as en_usi19popularProducts } from './src/en_us/'

import { i19popup as en_usi19popup } from './src/en_us/'

import { i19post as en_usi19post } from './src/en_us/'

import { i19posted as en_usi19posted } from './src/en_us/'

import { i19postingDeadline as en_usi19postingDeadline } from './src/en_us/'

import { i19postingIn as en_usi19postingIn } from './src/en_us/'

import { i19pressEnterToSave as en_usi19pressEnterToSave } from './src/en_us/'

import { i19previous as en_usi19previous } from './src/en_us/'

import { i19price as en_usi19price } from './src/en_us/'

import { i19priceAlteration as en_usi19priceAlteration } from './src/en_us/'

import { i19priceEffectiveDate as en_usi19priceEffectiveDate } from './src/en_us/'

import { i19priceEffectiveDateEnd as en_usi19priceEffectiveDateEnd } from './src/en_us/'

import { i19priceEffectiveDateStar as en_usi19priceEffectiveDateStar } from './src/en_us/'

import { i19priceRange as en_usi19priceRange } from './src/en_us/'

import { i19priceTo as en_usi19priceTo } from './src/en_us/'

import { i19pricing as en_usi19pricing } from './src/en_us/'

import { i19printBillet as en_usi19printBillet } from './src/en_us/'

import { i19privacy as en_usi19privacy } from './src/en_us/'

import { i19privacyPolicy as en_usi19privacyPolicy } from './src/en_us/'

import { i19private as en_usi19private } from './src/en_us/'

import { i19privateMetafields as en_usi19privateMetafields } from './src/en_us/'

import { i19privateMetafieldsMsg as en_usi19privateMetafieldsMsg } from './src/en_us/'

import { i19proceed as en_usi19proceed } from './src/en_us/'

import { i19product as en_usi19product } from './src/en_us/'

import { i19productDescription as en_usi19productDescription } from './src/en_us/'

import { i19productId as en_usi19productId } from './src/en_us/'

import { i19productImages as en_usi19productImages } from './src/en_us/'

import { i19productSpecifications as en_usi19productSpecifications } from './src/en_us/'

import { i19productionDeadline as en_usi19productionDeadline } from './src/en_us/'

import { i19productionTime as en_usi19productionTime } from './src/en_us/'

import { i19productionTimeMsg as en_usi19productionTimeMsg } from './src/en_us/'

import { i19productionTimeCumulative as en_usi19productionTimeCumulative } from './src/en_us/'

import { i19productionTimeDaysMsg as en_usi19productionTimeDaysMsg } from './src/en_us/'

import { i19productionTimeWorkingDays as en_usi19productionTimeWorkingDays } from './src/en_us/'

import { i19productName as en_usi19productName } from './src/en_us/'

import { i19products as en_usi19products } from './src/en_us/'

import { i19productsAdded as en_usi19productsAdded } from './src/en_us/'

import { i19productsAddedToCart as en_usi19productsAddedToCart } from './src/en_us/'

import { i19productsPurchased as en_usi19productsPurchased } from './src/en_us/'

import { i19profile as en_usi19profile } from './src/en_us/'

import { i19profileNotFound as en_usi19profileNotFound } from './src/en_us/'

import { i19province as en_usi19province } from './src/en_us/'

import { i19provinceCode as en_usi19provinceCode } from './src/en_us/'

import { i19put as en_usi19put } from './src/en_us/'

import { i19quantity as en_usi19quantity } from './src/en_us/'

import { i19quarterly as en_usi19quarterly } from './src/en_us/'

import { i19quickSetup as en_usi19quickSetup } from './src/en_us/'

import { i19random as en_usi19random } from './src/en_us/'

import { i19rating as en_usi19rating } from './src/en_us/'

import { i19read as en_usi19read } from './src/en_us/'

import { i19receipt as en_usi19receipt } from './src/en_us/'

import { i19receiptPrice as en_usi19receiptPrice } from './src/en_us/'

import { i19receivedOrder as en_usi19receivedOrder } from './src/en_us/'

import { i19receiveNewsletter as en_usi19receiveNewsletter } from './src/en_us/'

import { i19receiveToday as en_usi19receiveToday } from './src/en_us/'

import { i19recipient as en_usi19recipient } from './src/en_us/'

import { i19recommendations as en_usi19recommendations } from './src/en_us/'

import { i19recommendedForYou as en_usi19recommendedForYou } from './src/en_us/'

import { i19recommendedProducts as en_usi19recommendedProducts } from './src/en_us/'

import { i19recurrence as en_usi19recurrence } from './src/en_us/'

import { i19recurrent as en_usi19recurrent } from './src/en_us/'

import { i19redirectToPayment as en_usi19redirectToPayment } from './src/en_us/'

import { i19reference as en_usi19reference } from './src/en_us/'

import { i19referenceCode as en_usi19referenceCode } from './src/en_us/'

import { i19referral as en_usi19referral } from './src/en_us/'

import { i19referringSite as en_usi19referringSite } from './src/en_us/'

import { i19refine as en_usi19refine } from './src/en_us/'

import { i19refineSearch as en_usi19refineSearch } from './src/en_us/'

import { i19reinstall as en_usi19reinstall } from './src/en_us/'

import { i19registerDate as en_usi19registerDate } from './src/en_us/'

import { i19registerProduct as en_usi19registerProduct } from './src/en_us/'

import { i19registerToBuy as en_usi19registerToBuy } from './src/en_us/'

import { i19registerToBuyMsg as en_usi19registerToBuyMsg } from './src/en_us/'

import { i19registration as en_usi19registration } from './src/en_us/'

import { i19relatedApps as en_usi19relatedApps } from './src/en_us/'

import { i19relatedProduct as en_usi19relatedProduct } from './src/en_us/'

import { i19relatedSearch as en_usi19relatedSearch } from './src/en_us/'

import { i19releases as en_usi19releases } from './src/en_us/'

import { i19relevance as en_usi19relevance } from './src/en_us/'

import { i19remove as en_usi19remove } from './src/en_us/'

import { i19removed as en_usi19removed } from './src/en_us/'

import { i19removeFromFavorites as en_usi19removeFromFavorites } from './src/en_us/'

import { i19reopenOrder as en_usi19reopenOrder } from './src/en_us/'

import { i19require as en_usi19require } from './src/en_us/'

import { i19required as en_usi19required } from './src/en_us/'

import { i19requiredEmail as en_usi19requiredEmail } from './src/en_us/'

import { i19requiredEmailMsg as en_usi19requiredEmailMsg } from './src/en_us/'

import { i19requiredField as en_usi19requiredField } from './src/en_us/'

import { i19resource as en_usi19resource } from './src/en_us/'

import { i19resourceId as en_usi19resourceId } from './src/en_us/'

import { i19results as en_usi19results } from './src/en_us/'

import { i19resultsFor as en_usi19resultsFor } from './src/en_us/'

import { i19retail as en_usi19retail } from './src/en_us/'

import { i19retry as en_usi19retry } from './src/en_us/'

import { i19reviews as en_usi19reviews } from './src/en_us/'

import { i19safeEnvMsg as en_usi19safeEnvMsg } from './src/en_us/'

import { i19sales as en_usi19sales } from './src/en_us/'

import { i19salesPrice as en_usi19salesPrice } from './src/en_us/'

import { i19salesChannels as en_usi19salesChannels } from './src/en_us/'

import { i19save as en_usi19save } from './src/en_us/'

import { i19saveBrand as en_usi19saveBrand } from './src/en_us/'

import { i19saveCard as en_usi19saveCard } from './src/en_us/'

import { i19saveCart as en_usi19saveCart } from './src/en_us/'

import { i19saveCategory as en_usi19saveCategory } from './src/en_us/'

import { i19saveClient as en_usi19saveClient } from './src/en_us/'

import { i19saved as en_usi19saved } from './src/en_us/'

import { i19savedWithSuccess as en_usi19savedWithSuccess } from './src/en_us/'

import { i19saveCollection as en_usi19saveCollection } from './src/en_us/'

import { i19saveGrid as en_usi19saveGrid } from './src/en_us/'

import { i19saveProduct as en_usi19saveProduct } from './src/en_us/'

import { i19saveText as en_usi19saveText } from './src/en_us/'

import { i19scheduledDelivery as en_usi19scheduledDelivery } from './src/en_us/'

import { i19search as en_usi19search } from './src/en_us/'

import { i19searchAgain as en_usi19searchAgain } from './src/en_us/'

import { i19searchEngineListing as en_usi19searchEngineListing } from './src/en_us/'

import { i19searchingFor as en_usi19searchingFor } from './src/en_us/'

import { i19searchItems as en_usi19searchItems } from './src/en_us/'

import { i19searchOfflineErrorMsg as en_usi19searchOfflineErrorMsg } from './src/en_us/'

import { i19searchProducts as en_usi19searchProducts } from './src/en_us/'

import { i19securityCode as en_usi19securityCode } from './src/en_us/'

import { i19seeAll as en_usi19seeAll } from './src/en_us/'

import { i19seeAllApps as en_usi19seeAllApps } from './src/en_us/'

import { i19seeAllThemes as en_usi19seeAllThemes } from './src/en_us/'

import { i19seeAll$1Category as en_usi19seeAll$1Category } from './src/en_us/'

import { i19seeCart as en_usi19seeCart } from './src/en_us/'

import { i19seeMore as en_usi19seeMore } from './src/en_us/'

import { i19seeMoreCategories as en_usi19seeMoreCategories } from './src/en_us/'

import { i19seeMoreInfo as en_usi19seeMoreInfo } from './src/en_us/'

import { i19seeOrder as en_usi19seeOrder } from './src/en_us/'

import { i19seeShoppingCart as en_usi19seeShoppingCart } from './src/en_us/'

import { i19select as en_usi19select } from './src/en_us/'

import { i19selected as en_usi19selected } from './src/en_us/'

import { i19selectedOffers as en_usi19selectedOffers } from './src/en_us/'

import { i19selectedOptions as en_usi19selectedOptions } from './src/en_us/'

import { i19selectVariation as en_usi19selectVariation } from './src/en_us/'

import { i19selectVariationMsg as en_usi19selectVariationMsg } from './src/en_us/'

import { i19seller as en_usi19seller } from './src/en_us/'

import { i19sellerRecommendations as en_usi19sellerRecommendations } from './src/en_us/'

import { i19sellerRecommendationsProducts as en_usi19sellerRecommendationsProducts } from './src/en_us/'

import { i19sellerRecommendationsTitle as en_usi19sellerRecommendationsTitle } from './src/en_us/'

import { i19sellerStatus as en_usi19sellerStatus } from './src/en_us/'

import { i19send as en_usi19send } from './src/en_us/'

import { i19sender as en_usi19sender } from './src/en_us/'

import { i19senderFrom as en_usi19senderFrom } from './src/en_us/'

import { i19sendLoginCodeByEmail as en_usi19sendLoginCodeByEmail } from './src/en_us/'

import { i19seo as en_usi19seo } from './src/en_us/'

import { i19setDomainMsg as en_usi19setDomainMsg } from './src/en_us/'

import { i19setStoreDomain as en_usi19setStoreDomain } from './src/en_us/'

import { i19settings as en_usi19settings } from './src/en_us/'

import { i19setUp as en_usi19setUp } from './src/en_us/'

import { i19share as en_usi19share } from './src/en_us/'

import { i19shareOnFacebook as en_usi19shareOnFacebook } from './src/en_us/'

import { i19shareOnWhatsapp as en_usi19shareOnWhatsapp } from './src/en_us/'

import { i19shipped as en_usi19shipped } from './src/en_us/'

import { i19shippedBy as en_usi19shippedBy } from './src/en_us/'

import { i19shipping as en_usi19shipping } from './src/en_us/'

import { i19shippingAdditionalPrice as en_usi19shippingAdditionalPrice } from './src/en_us/'

import { i19shippingAddress as en_usi19shippingAddress } from './src/en_us/'

import { i19shippingCustomFields as en_usi19shippingCustomFields } from './src/en_us/'

import { i19shippingDiscount as en_usi19shippingDiscount } from './src/en_us/'

import { i19shippingInvoices as en_usi19shippingInvoices } from './src/en_us/'

import { i19shippingMethod as en_usi19shippingMethod } from './src/en_us/'

import { i19shippingMethodLabel as en_usi19shippingMethodLabel } from './src/en_us/'

import { i19shippingNotes as en_usi19shippingNotes } from './src/en_us/'

import { i19shippingNotesMsg as en_usi19shippingNotesMsg } from './src/en_us/'

import { i19shippingStatus as en_usi19shippingStatus } from './src/en_us/'

import { i19shippingTag as en_usi19shippingTag } from './src/en_us/'

import { i19shippingTags as en_usi19shippingTags } from './src/en_us/'

import { i19shippingTaxes as en_usi19shippingTaxes } from './src/en_us/'

import { i19shippingTaxesMsg as en_usi19shippingTaxesMsg } from './src/en_us/'

import { i19shippingTo as en_usi19shippingTo } from './src/en_us/'

import { i19shippingTotalCost as en_usi19shippingTotalCost } from './src/en_us/'

import { i19shopByCategory as en_usi19shopByCategory } from './src/en_us/'

import { i19shopByFranchise as en_usi19shopByFranchise } from './src/en_us/'

import { i19shopNow as en_usi19shopNow } from './src/en_us/'

import { i19shoppingCart as en_usi19shoppingCart } from './src/en_us/'

import { i19short as en_usi19short } from './src/en_us/'

import { i19shortDescription as en_usi19shortDescription } from './src/en_us/'

import { i19show as en_usi19show } from './src/en_us/'

import { i19showDescription as en_usi19showDescription } from './src/en_us/'

import { i19showReview as en_usi19showReview } from './src/en_us/'

import { i19signIn as en_usi19signIn } from './src/en_us/'

import { i19signInWith as en_usi19signInWith } from './src/en_us/'

import { i19signInWithAnotherEmail as en_usi19signInWithAnotherEmail } from './src/en_us/'

import { i19signUp as en_usi19signUp } from './src/en_us/'

import { i19signUpWith as en_usi19signUpWith } from './src/en_us/'

import { i19signature as en_usi19signature } from './src/en_us/'

import { i19size as en_usi19size } from './src/en_us/'

import { i19sizeGuide as en_usi19sizeGuide } from './src/en_us/'

import { i19sku as en_usi19sku } from './src/en_us/'

import { i19slug as en_usi19slug } from './src/en_us/'

import { i19socialLogin as en_usi19socialLogin } from './src/en_us/'

import { i19socialMedia as en_usi19socialMedia } from './src/en_us/'

import { i19source as en_usi19source } from './src/en_us/'

import { i19sourceName as en_usi19sourceName } from './src/en_us/'

import { i19sort as en_usi19sort } from './src/en_us/'

import { i19sortBy as en_usi19sortBy } from './src/en_us/'

import { i19subscribe as en_usi19subscribe } from './src/en_us/'

import { i19subscription as en_usi19subscription } from './src/en_us/'

import { i19subscriptionInvoices as en_usi19subscriptionInvoices } from './src/en_us/'

import { i19subscriptions as en_usi19subscriptions } from './src/en_us/'

import { i19submit as en_usi19submit } from './src/en_us/'

import { i19suggestedProducts as en_usi19suggestedProducts } from './src/en_us/'

import { i19specifications as en_usi19specifications } from './src/en_us/'

import { i19staffNotes as en_usi19staffNotes } from './src/en_us/'

import { i19staffSignature as en_usi19staffSignature } from './src/en_us/'

import { i19star as en_usi19star } from './src/en_us/'

import { i19startDate as en_usi19startDate } from './src/en_us/'

import { i19state as en_usi19state } from './src/en_us/'

import { i19status as en_usi19status } from './src/en_us/'

import { i19statusLink as en_usi19statusLink } from './src/en_us/'

import { i19statusMobileLink as en_usi19statusMobileLink } from './src/en_us/'

import { i19street as en_usi19street } from './src/en_us/'

import { i19store as en_usi19store } from './src/en_us/'

import { i19storefront as en_usi19storefront } from './src/en_us/'

import { i19subresource as en_usi19subresource } from './src/en_us/'

import { i19subresourceId as en_usi19subresourceId } from './src/en_us/'

import { i19subtitle as en_usi19subtitle } from './src/en_us/'

import { i19subtotal as en_usi19subtotal } from './src/en_us/'

import { i19success as en_usi19success } from './src/en_us/'

import { i19successfullyInstalled as en_usi19successfullyInstalled } from './src/en_us/'

import { i19successfullyUninstalled as en_usi19successfullyUninstalled } from './src/en_us/'

import { i19summary as en_usi19summary } from './src/en_us/'

import { i19support as en_usi19support } from './src/en_us/'

import { i19table as en_usi19table } from './src/en_us/'

import { i19tax as en_usi19tax } from './src/en_us/'

import { i19taxExempt as en_usi19taxExempt } from './src/en_us/'

import { i19termSearched as en_usi19termSearched } from './src/en_us/'

import { i19test as en_usi19test } from './src/en_us/'

import { i19thanks as en_usi19thanks } from './src/en_us/'

import { i19thanksForPurchase as en_usi19thanksForPurchase } from './src/en_us/'

import { i19theme as en_usi19theme } from './src/en_us/'

import { i19themes as en_usi19themes } from './src/en_us/'

import { i19ticketCode as en_usi19ticketCode } from './src/en_us/'

import { i19title as en_usi19title } from './src/en_us/'

import { i19titleTag as en_usi19titleTag } from './src/en_us/'

import { i19to as en_usi19to } from './src/en_us/'

import { i19toEarn as en_usi19toEarn } from './src/en_us/'

import { i19toPay as en_usi19toPay } from './src/en_us/'

import { i19today as en_usi19today } from './src/en_us/'

import { i19token as en_usi19token } from './src/en_us/'

import { i19total as en_usi19total } from './src/en_us/'

import { i19totalAmount as en_usi19totalAmount } from './src/en_us/'

import { i19totalCancelled as en_usi19totalCancelled } from './src/en_us/'

import { i19totalCancelledMsg as en_usi19totalCancelledMsg } from './src/en_us/'

import { i19totalResultsFor as en_usi19totalResultsFor } from './src/en_us/'

import { i19totalSpent as en_usi19totalSpent } from './src/en_us/'

import { i19trackDelivery as en_usi19trackDelivery } from './src/en_us/'

import { i19trackingCodes as en_usi19trackingCodes } from './src/en_us/'

import { i19transactionCode as en_usi19transactionCode } from './src/en_us/'

import { i19transactionId as en_usi19transactionId } from './src/en_us/'

import { i19transactionItems as en_usi19transactionItems } from './src/en_us/'

import { i19transactionStatus as en_usi19transactionStatus } from './src/en_us/'

import { i19transactionStatusMsg as en_usi19transactionStatusMsg } from './src/en_us/'

import { i19transactionType as en_usi19transactionType } from './src/en_us/'

import { i19trendingApps as en_usi19trendingApps } from './src/en_us/'

import { i19triggers as en_usi19triggers } from './src/en_us/'

import { i19triggersMsg as en_usi19triggersMsg } from './src/en_us/'

import { i19tryAgain as en_usi19tryAgain } from './src/en_us/'

import { i19type as en_usi19type } from './src/en_us/'

import { i19unable as en_usi19unable } from './src/en_us/'

import { i19unableToInstallApp as en_usi19unableToInstallApp } from './src/en_us/'

import { i19unableToUninstallApp as en_usi19unableToUninstallApp } from './src/en_us/'

import { i19unavailable as en_usi19unavailable } from './src/en_us/'

import { i19uninstall as en_usi19uninstall } from './src/en_us/'

import { i19uninstallingApp as en_usi19uninstallingApp } from './src/en_us/'

import { i19uninstallingAppWithSuccess as en_usi19uninstallingAppWithSuccess } from './src/en_us/'

import { i19units as en_usi19units } from './src/en_us/'

import { i19unitsInStock as en_usi19unitsInStock } from './src/en_us/'

import { i19unlimited as en_usi19unlimited } from './src/en_us/'

import { i19untilTomorrow as en_usi19untilTomorrow } from './src/en_us/'

import { i19unsubscribe as en_usi19unsubscribe } from './src/en_us/'

import { i19update as en_usi19update } from './src/en_us/'

import { i19updatedAt as en_usi19updatedAt } from './src/en_us/'

import { i19upload as en_usi19upload } from './src/en_us/'

import { i19uploadLogo as en_usi19uploadLogo } from './src/en_us/'

import { i19uploadTable as en_usi19uploadTable } from './src/en_us/'

import { i19upTo as en_usi19upTo } from './src/en_us/'

import { i19user as en_usi19user } from './src/en_us/'

import { i19userFound as en_usi19userFound } from './src/en_us/'

import { i19username as en_usi19username } from './src/en_us/'

import { i19usersFound as en_usi19usersFound } from './src/en_us/'

import { i19use$1LoyaltyPoints as en_usi19use$1LoyaltyPoints } from './src/en_us/'

import { i19utm as en_usi19utm } from './src/en_us/'

import { i19utmCampaign as en_usi19utmCampaign } from './src/en_us/'

import { i19utmContent as en_usi19utmContent } from './src/en_us/'

import { i19utmMedium as en_usi19utmMedium } from './src/en_us/'

import { i19utmSource as en_usi19utmSource } from './src/en_us/'

import { i19utmTerm as en_usi19utmTerm } from './src/en_us/'

import { i19url as en_usi19url } from './src/en_us/'

import { i19valid as en_usi19valid } from './src/en_us/'

import { i19validate as en_usi19validate } from './src/en_us/'

import { i19validThru as en_usi19validThru } from './src/en_us/'

import { i19value as en_usi19value } from './src/en_us/'

import { i19variation as en_usi19variation } from './src/en_us/'

import { i19variationId as en_usi19variationId } from './src/en_us/'

import { i19variationName as en_usi19variationName } from './src/en_us/'

import { i19variations as en_usi19variations } from './src/en_us/'

import { i19verified as en_usi19verified } from './src/en_us/'

import { i19version as en_usi19version } from './src/en_us/'

import { i19versionDate as en_usi19versionDate } from './src/en_us/'

import { i19video as en_usi19video } from './src/en_us/'

import { i19videos as en_usi19videos } from './src/en_us/'

import { i19visible as en_usi19visible } from './src/en_us/'

import { i19visibleProducts as en_usi19visibleProducts } from './src/en_us/'

import { i19visitor as en_usi19visitor } from './src/en_us/'

import { i19visitorCheckout as en_usi19visitorCheckout } from './src/en_us/'

import { i19warning as en_usi19warning } from './src/en_us/'

import { i19warningToReinstallAppMsg as en_usi19warningToReinstallAppMsg } from './src/en_us/'

import { i19wasAnErrorOnLoginMsg as en_usi19wasAnErrorOnLoginMsg } from './src/en_us/'

import { i19webhooks as en_usi19webhooks } from './src/en_us/'

import { i19webhooksMsg as en_usi19webhooksMsg } from './src/en_us/'

import { i19webhooksApiMsg as en_usi19webhooksApiMsg } from './src/en_us/'

import { i19webhooksApiExternalApiMsg as en_usi19webhooksApiExternalApiMsg } from './src/en_us/'

import { i19webhooksApiStoreApiMsg as en_usi19webhooksApiStoreApiMsg } from './src/en_us/'

import { i19webhooksMapBodyMsg as en_usi19webhooksMapBodyMsg } from './src/en_us/'

import { i19webhooksSendBodyMsg as en_usi19webhooksSendBodyMsg } from './src/en_us/'

import { i19weekly as en_usi19weekly } from './src/en_us/'

import { i19weight as en_usi19weight } from './src/en_us/'

import { i19weFrom as en_usi19weFrom } from './src/en_us/'

import { i19welcome as en_usi19welcome } from './src/en_us/'

import { i19welcomeTextMsg as en_usi19welcomeTextMsg } from './src/en_us/'

import { i19weRecommendToYou as en_usi19weRecommendToYou } from './src/en_us/'

import { i19weUseYourDataToMsg as en_usi19weUseYourDataToMsg } from './src/en_us/'

import { i19widgets as en_usi19widgets } from './src/en_us/'

import { i19width as en_usi19width } from './src/en_us/'

import { i19willReceiveMsg as en_usi19willReceiveMsg } from './src/en_us/'

import { i19with as en_usi19with } from './src/en_us/'

import { i19withoutInstallmentRates as en_usi19withoutInstallmentRates } from './src/en_us/'

import { i19write as en_usi19write } from './src/en_us/'

import { i19writeReview as en_usi19writeReview } from './src/en_us/'

import { i19workingDays as en_usi19workingDays } from './src/en_us/'

import { i19year as en_usi19year } from './src/en_us/'

import { i19yearly as en_usi19yearly } from './src/en_us/'

import { i19years as en_usi19years } from './src/en_us/'

import { i19yes as en_usi19yes } from './src/en_us/'

import { i19youEarn as en_usi19youEarn } from './src/en_us/'

import { i19yourInstalledApps as en_usi19yourInstalledApps } from './src/en_us/'

import { i19zipCode as en_usi19zipCode } from './src/en_us/'

import { i19zipCodeRange as en_usi19zipCodeRange } from './src/en_us/'

import { i19CancelReason as en_usi19CancelReason } from './src/en_us/'

import { i19ChannelType as en_usi19ChannelType } from './src/en_us/'

import { i19CommodityType as en_usi19CommodityType } from './src/en_us/'

import { i19ProductCondition as en_usi19ProductCondition } from './src/en_us/'

import { i19DiscountApplyAt as en_usi19DiscountApplyAt } from './src/en_us/'

import { i19DiscountType as en_usi19DiscountType } from './src/en_us/'

import { i19FinancialStatus as en_usi19FinancialStatus } from './src/en_us/'

import { i19FinancialStatusMsg as en_usi19FinancialStatusMsg } from './src/en_us/'

import { i19FulfillmentStatus as en_usi19FulfillmentStatus } from './src/en_us/'

import { i19FulfillmentStatusMsg as en_usi19FulfillmentStatusMsg } from './src/en_us/'

import { i19Gender as en_usi19Gender } from './src/en_us/'

import { i19InscriptionType as en_usi19InscriptionType } from './src/en_us/'

import { i19OrderStatus as en_usi19OrderStatus } from './src/en_us/'

import { i19PaymentMethodCodes as en_usi19PaymentMethodCodes } from './src/en_us/'

import { i19PaymentsHistoryStatus as en_usi19PaymentsHistoryStatus } from './src/en_us/'

import { i19PhoneType as en_usi19PhoneType } from './src/en_us/'

import { i19RegistryType as en_usi19RegistryType } from './src/en_us/'

import { i19ShippingLinesStatus as en_usi19ShippingLinesStatus } from './src/en_us/'

import { i19StateRegister as en_usi19StateRegister } from './src/en_us/'

import { i19TransactionsType as en_usi19TransactionsType } from './src/en_us/'

import { i19ApiActions as en_usi19ApiActions } from './src/en_us/'

import { i19StoreApiResources as en_usi19StoreApiResources } from './src/en_us/'

import { i19a as pt_bri19a } from './src/pt_br/'

import { i19about as pt_bri19about } from './src/pt_br/'

import { i19aboutCvvMsg as pt_bri19aboutCvvMsg } from './src/pt_br/'

import { i19aboveOf as pt_bri19aboveOf } from './src/pt_br/'

import { i19acceptAttachedFile as pt_bri19acceptAttachedFile } from './src/pt_br/'

import { i19acceptCustomOptionByCustomer as pt_bri19acceptCustomOptionByCustomer } from './src/pt_br/'

import { i19activate as pt_bri19activate } from './src/pt_br/'

import { i19active as pt_bri19active } from './src/pt_br/'

import { i19add as pt_bri19add } from './src/pt_br/'

import { i19addApp as pt_bri19addApp } from './src/pt_br/'

import { i19addCart as pt_bri19addCart } from './src/pt_br/'

import { i19addClient as pt_bri19addClient } from './src/pt_br/'

import { i19addDiscountCoupon as pt_bri19addDiscountCoupon } from './src/pt_br/'

import { i19addGiftList as pt_bri19addGiftList } from './src/pt_br/'

import { i19addGrid as pt_bri19addGrid } from './src/pt_br/'

import { i19additional as pt_bri19additional } from './src/pt_br/'

import { i19additionalComments as pt_bri19additionalComments } from './src/pt_br/'

import { i19additionalCost as pt_bri19additionalCost } from './src/pt_br/'

import { i19additionalCostOption as pt_bri19additionalCostOption } from './src/pt_br/'

import { i19additionalInfo as pt_bri19additionalInfo } from './src/pt_br/'

import { i19additionalNotes as pt_bri19additionalNotes } from './src/pt_br/'

import { i19address as pt_bri19address } from './src/pt_br/'

import { i19addresses as pt_bri19addresses } from './src/pt_br/'

import { i19addressesName as pt_bri19addressesName } from './src/pt_br/'

import { i19addMoreProducts as pt_bri19addMoreProducts } from './src/pt_br/'

import { i19addPreference as pt_bri19addPreference } from './src/pt_br/'

import { i19addProduct as pt_bri19addProduct } from './src/pt_br/'

import { i19addToCart as pt_bri19addToCart } from './src/pt_br/'

import { i19addToFavorites as pt_bri19addToFavorites } from './src/pt_br/'

import { i19addToPrice as pt_bri19addToPrice } from './src/pt_br/'

import { i19addVariants as pt_bri19addVariants } from './src/pt_br/'

import { i19add$1ToEarn as pt_bri19add$1ToEarn } from './src/pt_br/'

import { i19adminSettings as pt_bri19adminSettings } from './src/pt_br/'

import { i19adRelevance as pt_bri19adRelevance } from './src/pt_br/'

import { i19adType as pt_bri19adType } from './src/pt_br/'

import { i19advanced as pt_bri19advanced } from './src/pt_br/'

import { i19adwords as pt_bri19adwords } from './src/pt_br/'

import { i19adwordsRemarketing as pt_bri19adwordsRemarketing } from './src/pt_br/'

import { i19adwordsRemarketingCode as pt_bri19adwordsRemarketingCode } from './src/pt_br/'

import { i19affiliateCoede as pt_bri19affiliateCoede } from './src/pt_br/'

import { i19afterApproval as pt_bri19afterApproval } from './src/pt_br/'

import { i19afterPayment as pt_bri19afterPayment } from './src/pt_br/'

import { i19all as pt_bri19all } from './src/pt_br/'

import { i19allCategories as pt_bri19allCategories } from './src/pt_br/'

import { i19allOptions as pt_bri19allOptions } from './src/pt_br/'

import { i19alt as pt_bri19alt } from './src/pt_br/'

import { i19amount as pt_bri19amount } from './src/pt_br/'

import { i19another as pt_bri19another } from './src/pt_br/'

import { i19anyPaymentMethodMsg as pt_bri19anyPaymentMethodMsg } from './src/pt_br/'

import { i19api as pt_bri19api } from './src/pt_br/'

import { i19app as pt_bri19app } from './src/pt_br/'

import { i19appAlreadyInstalledMsg as pt_bri19appAlreadyInstalledMsg } from './src/pt_br/'

import { i19appConfiguration as pt_bri19appConfiguration } from './src/pt_br/'

import { i19apps as pt_bri19apps } from './src/pt_br/'

import { i19appDevelopers as pt_bri19appDevelopers } from './src/pt_br/'

import { i19application as pt_bri19application } from './src/pt_br/'

import { i19applications as pt_bri19applications } from './src/pt_br/'

import { i19applyDiscount as pt_bri19applyDiscount } from './src/pt_br/'

import { i19applyFilters as pt_bri19applyFilters } from './src/pt_br/'

import { i19areYouWantToDeleteAppQn as pt_bri19areYouWantToDeleteAppQn } from './src/pt_br/'

import { i19associateImage as pt_bri19associateImage } from './src/pt_br/'

import { i19associateImages as pt_bri19associateImages } from './src/pt_br/'

import { i19asOf as pt_bri19asOf } from './src/pt_br/'

import { i19at as pt_bri19at } from './src/pt_br/'

import { i19atSight as pt_bri19atSight } from './src/pt_br/'

import { i19attachment as pt_bri19attachment } from './src/pt_br/'

import { i19attention as pt_bri19attention } from './src/pt_br/'

import { i19authentication as pt_bri19authentication } from './src/pt_br/'

import { i19author as pt_bri19author } from './src/pt_br/'

import { i19authorizedStores as pt_bri19authorizedStores } from './src/pt_br/'

import { i19automaticallyTrackInventory as pt_bri19automaticallyTrackInventory } from './src/pt_br/'

import { i19available as pt_bri19available } from './src/pt_br/'

import { i19availablePurchase as pt_bri19availablePurchase } from './src/pt_br/'

import { i19availableApps as pt_bri19availableApps } from './src/pt_br/'

import { i19average as pt_bri19average } from './src/pt_br/'

import { i19averageTicket as pt_bri19averageTicket } from './src/pt_br/'

import { i19back as pt_bri19back } from './src/pt_br/'

import { i19backToCart as pt_bri19backToCart } from './src/pt_br/'

import { i19backToProduct as pt_bri19backToProduct } from './src/pt_br/'

import { i19bag as pt_bri19bag } from './src/pt_br/'

import { i19balanceOrPoints as pt_bri19balanceOrPoints } from './src/pt_br/'

import { i19banner as pt_bri19banner } from './src/pt_br/'

import { i19banners as pt_bri19banners } from './src/pt_br/'

import { i19bannersCollection as pt_bri19bannersCollection } from './src/pt_br/'

import { i19barcodes as pt_bri19barcodes } from './src/pt_br/'

import { i19basePrice as pt_bri19basePrice } from './src/pt_br/'

import { i19bearersDocument as pt_bri19bearersDocument } from './src/pt_br/'

import { i19best as pt_bri19best } from './src/pt_br/'

import { i19bestSellers as pt_bri19bestSellers } from './src/pt_br/'

import { i19biannual as pt_bri19biannual } from './src/pt_br/'

import { i19billingAddress as pt_bri19billingAddress } from './src/pt_br/'

import { i19bimonthly as pt_bri19bimonthly } from './src/pt_br/'

import { i19birthdate as pt_bri19birthdate } from './src/pt_br/'

import { i19biweekly as pt_bri19biweekly } from './src/pt_br/'

import { i19block as pt_bri19block } from './src/pt_br/'

import { i19borough as pt_bri19borough } from './src/pt_br/'

import { i19budgetOnly as pt_bri19budgetOnly } from './src/pt_br/'

import { i19buy as pt_bri19buy } from './src/pt_br/'

import { i19buyAgain as pt_bri19buyAgain } from './src/pt_br/'

import { i19buyAlsoMsg as pt_bri19buyAlsoMsg } from './src/pt_br/'

import { i19buyer as pt_bri19buyer } from './src/pt_br/'

import { i19buyers as pt_bri19buyers } from './src/pt_br/'

import { i19buyersProfile as pt_bri19buyersProfile } from './src/pt_br/'

import { i19buyNow as pt_bri19buyNow } from './src/pt_br/'

import { i19buyKit as pt_bri19buyKit } from './src/pt_br/'

import { i19by as pt_bri19by } from './src/pt_br/'

import { i19brand as pt_bri19brand } from './src/pt_br/'

import { i19brandBanners as pt_bri19brandBanners } from './src/pt_br/'

import { i19brandName as pt_bri19brandName } from './src/pt_br/'

import { i19brandFound as pt_bri19brandFound } from './src/pt_br/'

import { i19brands as pt_bri19brands } from './src/pt_br/'

import { i19brandsFound as pt_bri19brandsFound } from './src/pt_br/'

import { i19brazil as pt_bri19brazil } from './src/pt_br/'

import { i19browserIp as pt_bri19browserIp } from './src/pt_br/'

import { i19buyWith as pt_bri19buyWith } from './src/pt_br/'

import { i19calculateShipping as pt_bri19calculateShipping } from './src/pt_br/'

import { i19callTo as pt_bri19callTo } from './src/pt_br/'

import { i19callback as pt_bri19callback } from './src/pt_br/'

import { i19campaign as pt_bri19campaign } from './src/pt_br/'

import { i19campaignAppliedMsg as pt_bri19campaignAppliedMsg } from './src/pt_br/'

import { i19cancel as pt_bri19cancel } from './src/pt_br/'

import { i19cancelled as pt_bri19cancelled } from './src/pt_br/'

import { i19cancelledAt as pt_bri19cancelledAt } from './src/pt_br/'

import { i19cancelOrder as pt_bri19cancelOrder } from './src/pt_br/'

import { i19cancelReason as pt_bri19cancelReason } from './src/pt_br/'

import { i19cardNumber as pt_bri19cardNumber } from './src/pt_br/'

import { i19cartConfirmed as pt_bri19cartConfirmed } from './src/pt_br/'

import { i19cartDetails as pt_bri19cartDetails } from './src/pt_br/'

import { i19cartItems as pt_bri19cartItems } from './src/pt_br/'

import { i19cartReview as pt_bri19cartReview } from './src/pt_br/'

import { i19cartUpdated as pt_bri19cartUpdated } from './src/pt_br/'

import { i19categories as pt_bri19categories } from './src/pt_br/'

import { i19category as pt_bri19category } from './src/pt_br/'

import { i19categoryBanners as pt_bri19categoryBanners } from './src/pt_br/'

import { i19categoryFound as pt_bri19categoryFound } from './src/pt_br/'

import { i19categoryName as pt_bri19categoryName } from './src/pt_br/'

import { i19cellphone as pt_bri19cellphone } from './src/pt_br/'

import { i19changePaymentMethod as pt_bri19changePaymentMethod } from './src/pt_br/'

import { i19changeShippingMethod as pt_bri19changeShippingMethod } from './src/pt_br/'

import { i19channel as pt_bri19channel } from './src/pt_br/'

import { i19channelId as pt_bri19channelId } from './src/pt_br/'

import { i19channels as pt_bri19channels } from './src/pt_br/'

import { i19channelType as pt_bri19channelType } from './src/pt_br/'

import { i19checkout as pt_bri19checkout } from './src/pt_br/'

import { i19checkoutEnabled as pt_bri19checkoutEnabled } from './src/pt_br/'

import { i19checkoutDone as pt_bri19checkoutDone } from './src/pt_br/'

import { i19checkoutLink as pt_bri19checkoutLink } from './src/pt_br/'

import { i19checkoutMobileLink as pt_bri19checkoutMobileLink } from './src/pt_br/'

import { i19checkoutVisitor as pt_bri19checkoutVisitor } from './src/pt_br/'

import { i19checkoutVisitorMsg as pt_bri19checkoutVisitorMsg } from './src/pt_br/'

import { i19chooseSubscriptionPeriod as pt_bri19chooseSubscriptionPeriod } from './src/pt_br/'

import { i19city as pt_bri19city } from './src/pt_br/'

import { i19clear as pt_bri19clear } from './src/pt_br/'

import { i19clearFilters as pt_bri19clearFilters } from './src/pt_br/'

import { i19click as pt_bri19click } from './src/pt_br/'

import { i19clickHere as pt_bri19clickHere } from './src/pt_br/'

import { i19close as pt_bri19close } from './src/pt_br/'

import { i19closedAt as pt_bri19closedAt } from './src/pt_br/'

import { i19closeFilters as pt_bri19closeFilters } from './src/pt_br/'

import { i19code as pt_bri19code } from './src/pt_br/'

import { i19codeCopied as pt_bri19codeCopied } from './src/pt_br/'

import { i19collection as pt_bri19collection } from './src/pt_br/'

import { i19collections as pt_bri19collections } from './src/pt_br/'

import { i19collectionBanners as pt_bri19collectionBanners } from './src/pt_br/'

import { i19collectionItems as pt_bri19collectionItems } from './src/pt_br/'

import { i19collectionName as pt_bri19collectionName } from './src/pt_br/'

import { i19color as pt_bri19color } from './src/pt_br/'

import { i19colors as pt_bri19colors } from './src/pt_br/'

import { i19community as pt_bri19community } from './src/pt_br/'

import { i19companyRegistration as pt_bri19companyRegistration } from './src/pt_br/'

import { i19compareAtPrice as pt_bri19compareAtPrice } from './src/pt_br/'

import { i19compareProducts as pt_bri19compareProducts } from './src/pt_br/'

import { i19comparedPreviousPeriodMsg as pt_bri19comparedPreviousPeriodMsg } from './src/pt_br/'

import { i19complement as pt_bri19complement } from './src/pt_br/'

import { i19complementInformation as pt_bri19complementInformation } from './src/pt_br/'

import { i19connectionErrorMsg as pt_bri19connectionErrorMsg } from './src/pt_br/'

import { i19connectionErrorProductMsg as pt_bri19connectionErrorProductMsg } from './src/pt_br/'

import { i19configuration as pt_bri19configuration } from './src/pt_br/'

import { i19confirmPassword as pt_bri19confirmPassword } from './src/pt_br/'

import { i19confirmPurchase as pt_bri19confirmPurchase } from './src/pt_br/'

import { i19contactPhone as pt_bri19contactPhone } from './src/pt_br/'

import { i19contactUsMsg as pt_bri19contactUsMsg } from './src/pt_br/'

import { i19content as pt_bri19content } from './src/pt_br/'

import { i19continue as pt_bri19continue } from './src/pt_br/'

import { i19continueLoginOnPopup as pt_bri19continueLoginOnPopup } from './src/pt_br/'

import { i19continueShopping as pt_bri19continueShopping } from './src/pt_br/'

import { i19control as pt_bri19control } from './src/pt_br/'

import { i19copyCode as pt_bri19copyCode } from './src/pt_br/'

import { i19copyErrorMsg as pt_bri19copyErrorMsg } from './src/pt_br/'

import { i19copyright as pt_bri19copyright } from './src/pt_br/'

import { i19corporateName as pt_bri19corporateName } from './src/pt_br/'

import { i19costDeclaredValue as pt_bri19costDeclaredValue } from './src/pt_br/'

import { i19costPrice as pt_bri19costPrice } from './src/pt_br/'

import { i19countryCode as pt_bri19countryCode } from './src/pt_br/'

import { i19couponAppliedMsg as pt_bri19couponAppliedMsg } from './src/pt_br/'

import { i19createTransaction as pt_bri19createTransaction } from './src/pt_br/'

import { i19creation as pt_bri19creation } from './src/pt_br/'

import { i19credit as pt_bri19credit } from './src/pt_br/'

import { i19creditCard as pt_bri19creditCard } from './src/pt_br/'

import { i19creditCardBin as pt_bri19creditCardBin } from './src/pt_br/'

import { i19creditCardCompany as pt_bri19creditCardCompany } from './src/pt_br/'

import { i19creditCardHolderName as pt_bri19creditCardHolderName } from './src/pt_br/'

import { i19creditCardLastDigits as pt_bri19creditCardLastDigits } from './src/pt_br/'

import { i19creditorFees as pt_bri19creditorFees } from './src/pt_br/'

import { i19creditorFeesIntermediator as pt_bri19creditorFeesIntermediator } from './src/pt_br/'

import { i19creditorFeesOperational as pt_bri19creditorFeesOperational } from './src/pt_br/'

import { i19currencyId as pt_bri19currencyId } from './src/pt_br/'

import { i19currencySymbol as pt_bri19currencySymbol } from './src/pt_br/'

import { i19custom as pt_bri19custom } from './src/pt_br/'

import { i19customer as pt_bri19customer } from './src/pt_br/'

import { i19customerNotified as pt_bri19customerNotified } from './src/pt_br/'

import { i19customerService as pt_bri19customerService } from './src/pt_br/'

import { i19customFields as pt_bri19customFields } from './src/pt_br/'

import { i19customizationAddToPrice as pt_bri19customizationAddToPrice } from './src/pt_br/'

import { i19customizationAttachment as pt_bri19customizationAttachment } from './src/pt_br/'

import { i19customizationChosen as pt_bri19customizationChosen } from './src/pt_br/'

import { i19customizations as pt_bri19customizations } from './src/pt_br/'

import { i19customPayment as pt_bri19customPayment } from './src/pt_br/'

import { i19customValue as pt_bri19customValue } from './src/pt_br/'

import { i19danger as pt_bri19danger } from './src/pt_br/'

import { i19dashboard as pt_bri19dashboard } from './src/pt_br/'

import { i19dateTime as pt_bri19dateTime } from './src/pt_br/'

import { i19day as pt_bri19day } from './src/pt_br/'

import { i19dailyAverage as pt_bri19dailyAverage } from './src/pt_br/'

import { i19days as pt_bri19days } from './src/pt_br/'

import { i19declare as pt_bri19declare } from './src/pt_br/'

import { i19declaredValue as pt_bri19declaredValue } from './src/pt_br/'

import { i19delete as pt_bri19delete } from './src/pt_br/'

import { i19deleteAll as pt_bri19deleteAll } from './src/pt_br/'

import { i19delivery as pt_bri19delivery } from './src/pt_br/'

import { i19deliveryCostOwnHandMsg as pt_bri19deliveryCostOwnHandMsg } from './src/pt_br/'

import { i19deliveryInMsg as pt_bri19deliveryInMsg } from './src/pt_br/'

import { i19deliveryReceipt as pt_bri19deliveryReceipt } from './src/pt_br/'

import { i19deliveryReceiptMsg as pt_bri19deliveryReceiptMsg } from './src/pt_br/'

import { i19deliveryTrack as pt_bri19deliveryTrack } from './src/pt_br/'

import { i19deliveryTime as pt_bri19deliveryTime } from './src/pt_br/'

import { i19deliveryWithOwnHandMsg as pt_bri19deliveryWithOwnHandMsg } from './src/pt_br/'

import { i19description as pt_bri19description } from './src/pt_br/'

import { i19desktop as pt_bri19desktop } from './src/pt_br/'

import { i19details as pt_bri19details } from './src/pt_br/'

import { i19didYouMean as pt_bri19didYouMean } from './src/pt_br/'

import { i19digits as pt_bri19digits } from './src/pt_br/'

import { i19directLinkPayment as pt_bri19directLinkPayment } from './src/pt_br/'

import { i19disable as pt_bri19disable } from './src/pt_br/'

import { i19discount as pt_bri19discount } from './src/pt_br/'

import { i19discountCoupon as pt_bri19discountCoupon } from './src/pt_br/'

import { i19discountOf as pt_bri19discountOf } from './src/pt_br/'

import { i19discountValueMsg as pt_bri19discountValueMsg } from './src/pt_br/'

import { i19displayName as pt_bri19displayName } from './src/pt_br/'

import { i19docCountry as pt_bri19docCountry } from './src/pt_br/'

import { i19docNumber as pt_bri19docNumber } from './src/pt_br/'

import { i19docs as pt_bri19docs } from './src/pt_br/'

import { i19domain as pt_bri19domain } from './src/pt_br/'

import { i19doPaymentMsg as pt_bri19doPaymentMsg } from './src/pt_br/'

import { i19doYouWantToDeleteAppQn as pt_bri19doYouWantToDeleteAppQn } from './src/pt_br/'

import { i19doYouWantToReinstallAppQn as pt_bri19doYouWantToReinstallAppQn } from './src/pt_br/'

import { i19download as pt_bri19download } from './src/pt_br/'

import { i19downloadTable as pt_bri19downloadTable } from './src/pt_br/'

import { i19edit as pt_bri19edit } from './src/pt_br/'

import { i19editing as pt_bri19editing } from './src/pt_br/'

import { i19editAdditionalCost as pt_bri19editAdditionalCost } from './src/pt_br/'

import { i19editComments as pt_bri19editComments } from './src/pt_br/'

import { i19editDispatchAndFulfillment as pt_bri19editDispatchAndFulfillment } from './src/pt_br/'

import { i19editFeatures as pt_bri19editFeatures } from './src/pt_br/'

import { i19editFilters as pt_bri19editFilters } from './src/pt_br/'

import { i19editGtinMpn as pt_bri19editGtinMpn } from './src/pt_br/'

import { i19editHtmlDescription as pt_bri19editHtmlDescription } from './src/pt_br/'

import { i19editObservationInfo as pt_bri19editObservationInfo } from './src/pt_br/'

import { i19editPaymentDetails as pt_bri19editPaymentDetails } from './src/pt_br/'

import { i19editProductDimensions as pt_bri19editProductDimensions } from './src/pt_br/'

import { i19editSeoFields as pt_bri19editSeoFields } from './src/pt_br/'

import { i19editStorefront as pt_bri19editStorefront } from './src/pt_br/'

import { i19editVariation as pt_bri19editVariation } from './src/pt_br/'

import { i19email as pt_bri19email } from './src/pt_br/'

import { i19emailAddress as pt_bri19emailAddress } from './src/pt_br/'

import { i19emailCartTextMsg as pt_bri19emailCartTextMsg } from './src/pt_br/'

import { i19emailCartTitleMsg as pt_bri19emailCartTitleMsg } from './src/pt_br/'

import { i19emailDeliveredTextMsg as pt_bri19emailDeliveredTextMsg } from './src/pt_br/'

import { i19emailDeliveredTitleMsg as pt_bri19emailDeliveredTitleMsg } from './src/pt_br/'

import { i19emailInfoMsg as pt_bri19emailInfoMsg } from './src/pt_br/'

import { i19emailMarketing as pt_bri19emailMarketing } from './src/pt_br/'

import { i19emailMarketingOptInMsg as pt_bri19emailMarketingOptInMsg } from './src/pt_br/'

import { i19emailProfileNotFoundMsg as pt_bri19emailProfileNotFoundMsg } from './src/pt_br/'

import { i19emails as pt_bri19emails } from './src/pt_br/'

import { i19emailShippedTextMsg as pt_bri19emailShippedTextMsg } from './src/pt_br/'

import { i19emailShippedTitleMsg as pt_bri19emailShippedTitleMsg } from './src/pt_br/'

import { i19empty as pt_bri19empty } from './src/pt_br/'

import { i19emptyCart as pt_bri19emptyCart } from './src/pt_br/'

import { i19emptyCartMsg as pt_bri19emptyCartMsg } from './src/pt_br/'

import { i19enabled as pt_bri19enabled } from './src/pt_br/'

import { i19end as pt_bri19end } from './src/pt_br/'

import { i19endDate as pt_bri19endDate } from './src/pt_br/'

import { i19endpoint as pt_bri19endpoint } from './src/pt_br/'

import { i19endsIn as pt_bri19endsIn } from './src/pt_br/'

import { i19enterEmailCodeMsg as pt_bri19enterEmailCodeMsg } from './src/pt_br/'

import { i19enterYourDocNumber as pt_bri19enterYourDocNumber } from './src/pt_br/'

import { i19enterYourDocNumberMsg as pt_bri19enterYourDocNumberMsg } from './src/pt_br/'

import { i19enterYourEmail as pt_bri19enterYourEmail } from './src/pt_br/'

import { i19enterYourEmailMsg as pt_bri19enterYourEmailMsg } from './src/pt_br/'

import { i19erp as pt_bri19erp } from './src/pt_br/'

import { i19error as pt_bri19error } from './src/pt_br/'

import { i19errorMsg as pt_bri19errorMsg } from './src/pt_br/'

import { i19events as pt_bri19events } from './src/pt_br/'

import { i19export as pt_bri19export } from './src/pt_br/'

import { i19exportToCsv as pt_bri19exportToCsv } from './src/pt_br/'

import { i19extra as pt_bri19extra } from './src/pt_br/'

import { i19extraCost as pt_bri19extraCost } from './src/pt_br/'

import { i19external as pt_bri19external } from './src/pt_br/'

import { i19familyName as pt_bri19familyName } from './src/pt_br/'

import { i19favorites as pt_bri19favorites } from './src/pt_br/'

import { i19featuredApps as pt_bri19featuredApps } from './src/pt_br/'

import { i19female as pt_bri19female } from './src/pt_br/'

import { i19field as pt_bri19field } from './src/pt_br/'

import { i19files as pt_bri19files } from './src/pt_br/'

import { i19filter as pt_bri19filter } from './src/pt_br/'

import { i19filterProducts as pt_bri19filterProducts } from './src/pt_br/'

import { i19filterResults as pt_bri19filterResults } from './src/pt_br/'

import { i19finalPrice as pt_bri19finalPrice } from './src/pt_br/'

import { i19finalPriceWithAdditional as pt_bri19finalPriceWithAdditional } from './src/pt_br/'

import { i19financialStatus as pt_bri19financialStatus } from './src/pt_br/'

import { i19firstSteps as pt_bri19firstSteps } from './src/pt_br/'

import { i19followingAddress as pt_bri19followingAddress } from './src/pt_br/'

import { i19for as pt_bri19for } from './src/pt_br/'

import { i19free as pt_bri19free } from './src/pt_br/'

import { i19freebie as pt_bri19freebie } from './src/pt_br/'

import { i19freeShipping as pt_bri19freeShipping } from './src/pt_br/'

import { i19freeShippingFrom as pt_bri19freeShippingFrom } from './src/pt_br/'

import { i19freight as pt_bri19freight } from './src/pt_br/'

import { i19freightCost as pt_bri19freightCost } from './src/pt_br/'

import { i19from as pt_bri19from } from './src/pt_br/'

import { i19fulfillmentStatus as pt_bri19fulfillmentStatus } from './src/pt_br/'

import { i19fullName as pt_bri19fullName } from './src/pt_br/'

import { i19fullscreen as pt_bri19fullscreen } from './src/pt_br/'

import { i19gateway as pt_bri19gateway } from './src/pt_br/'

import { i19gender as pt_bri19gender } from './src/pt_br/'

import { i19genderX as pt_bri19genderX } from './src/pt_br/'

import { i19general as pt_bri19general } from './src/pt_br/'

import { i19generateBillet as pt_bri19generateBillet } from './src/pt_br/'

import { i19get as pt_bri19get } from './src/pt_br/'

import { i19giftList as pt_bri19giftList } from './src/pt_br/'

import { i19giftListAuthors as pt_bri19giftListAuthors } from './src/pt_br/'

import { i19giftListAuthorsContact as pt_bri19giftListAuthorsContact } from './src/pt_br/'

import { i19giftListDescription as pt_bri19giftListDescription } from './src/pt_br/'

import { i19giftListEventDate as pt_bri19giftListEventDate } from './src/pt_br/'

import { i19giftListInformation as pt_bri19giftListInformation } from './src/pt_br/'

import { i19giftListNotificationPurchaseMsg as pt_bri19giftListNotificationPurchaseMsg } from './src/pt_br/'

import { i19giftListPermalink as pt_bri19giftListPermalink } from './src/pt_br/'

import { i19giftListTitle as pt_bri19giftListTitle } from './src/pt_br/'

import { i19giftListValidThru as pt_bri19giftListValidThru } from './src/pt_br/'

import { i19giftListOwnerID as pt_bri19giftListOwnerID } from './src/pt_br/'

import { i19giftListWaiting as pt_bri19giftListWaiting } from './src/pt_br/'

import { i19giftTo as pt_bri19giftTo } from './src/pt_br/'

import { i19giftWrap as pt_bri19giftWrap } from './src/pt_br/'

import { i19gitRepository as pt_bri19gitRepository } from './src/pt_br/'

import { i19givenName as pt_bri19givenName } from './src/pt_br/'

import { i19goToCart as pt_bri19goToCart } from './src/pt_br/'

import { i19goToStore as pt_bri19goToStore } from './src/pt_br/'

import { i19goToTop as pt_bri19goToTop } from './src/pt_br/'

import { i19googleAnalytics as pt_bri19googleAnalytics } from './src/pt_br/'

import { i19googleProductCategoryId as pt_bri19googleProductCategoryId } from './src/pt_br/'

import { i19gridId as pt_bri19gridId } from './src/pt_br/'

import { i19grids as pt_bri19grids } from './src/pt_br/'

import { i19gridName as pt_bri19gridName } from './src/pt_br/'

import { i19guestCheckoutMsg as pt_bri19guestCheckoutMsg } from './src/pt_br/'

import { i19hasCouponOrVoucherQn as pt_bri19hasCouponOrVoucherQn } from './src/pt_br/'

import { i19height as pt_bri19height } from './src/pt_br/'

import { i19hello as pt_bri19hello } from './src/pt_br/'

import { i19helloAgain as pt_bri19helloAgain } from './src/pt_br/'

import { i19help as pt_bri19help } from './src/pt_br/'

import { i19helpful as pt_bri19helpful } from './src/pt_br/'

import { i19high as pt_bri19high } from './src/pt_br/'

import { i19highestPrice as pt_bri19highestPrice } from './src/pt_br/'

import { i19highPriority as pt_bri19highPriority } from './src/pt_br/'

import { i19holderName as pt_bri19holderName } from './src/pt_br/'

import { i19home as pt_bri19home } from './src/pt_br/'

import { i19icon as pt_bri19icon } from './src/pt_br/'

import { i19id as pt_bri19id } from './src/pt_br/'

import { i19identification as pt_bri19identification } from './src/pt_br/'

import { i19identifyYourAccount as pt_bri19identifyYourAccount } from './src/pt_br/'

import { i19idOfShippingMethod as pt_bri19idOfShippingMethod } from './src/pt_br/'

import { i19image as pt_bri19image } from './src/pt_br/'

import { i19images as pt_bri19images } from './src/pt_br/'

import { i19import as pt_bri19import } from './src/pt_br/'

import { i19in as pt_bri19in } from './src/pt_br/'

import { i19inactive as pt_bri19inactive } from './src/pt_br/'

import { i19incorrect as pt_bri19incorrect } from './src/pt_br/'

import { i19incorrectFormat as pt_bri19incorrectFormat } from './src/pt_br/'

import { i19incorrectEmailCodeMsg as pt_bri19incorrectEmailCodeMsg } from './src/pt_br/'

import { i19info as pt_bri19info } from './src/pt_br/'

import { i19inscriptionNumber as pt_bri19inscriptionNumber } from './src/pt_br/'

import { i19insert as pt_bri19insert } from './src/pt_br/'

import { i19install as pt_bri19install } from './src/pt_br/'

import { i19installed as pt_bri19installed } from './src/pt_br/'

import { i19installedApps as pt_bri19installedApps } from './src/pt_br/'

import { i19installingApp as pt_bri19installingApp } from './src/pt_br/'

import { i19installment as pt_bri19installment } from './src/pt_br/'

import { i19installments as pt_bri19installments } from './src/pt_br/'

import { i19installNow as pt_bri19installNow } from './src/pt_br/'

import { i19inStock as pt_bri19inStock } from './src/pt_br/'

import { i19inStockAt as pt_bri19inStockAt } from './src/pt_br/'

import { i19interestFree as pt_bri19interestFree } from './src/pt_br/'

import { i19intermediator as pt_bri19intermediator } from './src/pt_br/'

import { i19invalidCard as pt_bri19invalidCard } from './src/pt_br/'

import { i19invalidCardMsg as pt_bri19invalidCardMsg } from './src/pt_br/'

import { i19invalidCouponMsg as pt_bri19invalidCouponMsg } from './src/pt_br/'

import { i19invalidDomainName as pt_bri19invalidDomainName } from './src/pt_br/'

import { i19invalidLoginInfoMsg as pt_bri19invalidLoginInfoMsg } from './src/pt_br/'

import { i19inventory as pt_bri19inventory } from './src/pt_br/'

import { i19inventoryHistory as pt_bri19inventoryHistory } from './src/pt_br/'

import { i19invoice as pt_bri19invoice } from './src/pt_br/'

import { i19invoices as pt_bri19invoices } from './src/pt_br/'

import { i19iReadAndAccept as pt_bri19iReadAndAccept } from './src/pt_br/'

import { i19isFilter as pt_bri19isFilter } from './src/pt_br/'

import { i19isNotYou as pt_bri19isNotYou } from './src/pt_br/'

import { i19item as pt_bri19item } from './src/pt_br/'

import { i19items as pt_bri19items } from './src/pt_br/'

import { i19itemsFound as pt_bri19itemsFound } from './src/pt_br/'

import { i19jurifical as pt_bri19jurifical } from './src/pt_br/'

import { i19just as pt_bri19just } from './src/pt_br/'

import { i19keywords as pt_bri19keywords } from './src/pt_br/'

import { i19kit as pt_bri19kit } from './src/pt_br/'

import { i19label as pt_bri19label } from './src/pt_br/'

import { i19LabelOfCustomization as pt_bri19LabelOfCustomization } from './src/pt_br/'

import { i19last as pt_bri19last } from './src/pt_br/'

import { i19lastOptions as pt_bri19lastOptions } from './src/pt_br/'

import { i19lastPurchase as pt_bri19lastPurchase } from './src/pt_br/'

import { i19lastSearchedTerms as pt_bri19lastSearchedTerms } from './src/pt_br/'

import { i19lastVisitedProducts as pt_bri19lastVisitedProducts } from './src/pt_br/'

import { i19latestOrders as pt_bri19latestOrders } from './src/pt_br/'

import { i19launch as pt_bri19launch } from './src/pt_br/'

import { i19launching as pt_bri19launching } from './src/pt_br/'

import { i19length as pt_bri19length } from './src/pt_br/'

import { i19lineAddress as pt_bri19lineAddress } from './src/pt_br/'

import { i19list as pt_bri19list } from './src/pt_br/'

import { i19listOfInvoices as pt_bri19listOfInvoices } from './src/pt_br/'

import { i19listOfPayments as pt_bri19listOfPayments } from './src/pt_br/'

import { i19listSubscriptionInvoices as pt_bri19listSubscriptionInvoices } from './src/pt_br/'

import { i19load as pt_bri19load } from './src/pt_br/'

import { i19loadMore as pt_bri19loadMore } from './src/pt_br/'

import { i19loading as pt_bri19loading } from './src/pt_br/'

import { i19loadDataErrorMsg as pt_bri19loadDataErrorMsg } from './src/pt_br/'

import { i19loadProductErrorMsg as pt_bri19loadProductErrorMsg } from './src/pt_br/'

import { i19locale as pt_bri19locale } from './src/pt_br/'

import { i19login as pt_bri19login } from './src/pt_br/'

import { i19loginEnabled as pt_bri19loginEnabled } from './src/pt_br/'

import { i19loginErrorMsg as pt_bri19loginErrorMsg } from './src/pt_br/'

import { i19loginForOrderDetailsMsg as pt_bri19loginForOrderDetailsMsg } from './src/pt_br/'

import { i19logo as pt_bri19logo } from './src/pt_br/'

import { i19logout as pt_bri19logout } from './src/pt_br/'

import { i19low as pt_bri19low } from './src/pt_br/'

import { i19lowestPrice as pt_bri19lowestPrice } from './src/pt_br/'

import { i19loyaltyPoints as pt_bri19loyaltyPoints } from './src/pt_br/'

import { i19loyaltyPointsName as pt_bri19loyaltyPointsName } from './src/pt_br/'

import { i19loyaltyPointsPointsValue as pt_bri19loyaltyPointsPointsValue } from './src/pt_br/'

import { i19madeBy as pt_bri19madeBy } from './src/pt_br/'

import { i19mainEmail as pt_bri19mainEmail } from './src/pt_br/'

import { i19male as pt_bri19male } from './src/pt_br/'

import { i19manageStock as pt_bri19manageStock } from './src/pt_br/'

import { i19manageYourPurchaseHistory as pt_bri19manageYourPurchaseHistory } from './src/pt_br/'

import { i19marketing as pt_bri19marketing } from './src/pt_br/'

import { i19marketplace as pt_bri19marketplace } from './src/pt_br/'

import { i19marketplaces as pt_bri19marketplaces } from './src/pt_br/'

import { i19massEdit as pt_bri19massEdit } from './src/pt_br/'

import { i19maximum as pt_bri19maximum } from './src/pt_br/'

import { i19maxQuantity as pt_bri19maxQuantity } from './src/pt_br/'

import { i19media as pt_bri19media } from './src/pt_br/'

import { i19mediaGallery as pt_bri19mediaGallery } from './src/pt_br/'

import { i19measurement as pt_bri19measurement } from './src/pt_br/'

import { i19menu as pt_bri19menu } from './src/pt_br/'

import { i19metafields as pt_bri19metafields } from './src/pt_br/'

import { i19metafieldsMsg as pt_bri19metafieldsMsg } from './src/pt_br/'

import { i19metaTagDescription as pt_bri19metaTagDescription } from './src/pt_br/'

import { i19middleName as pt_bri19middleName } from './src/pt_br/'

import { i19minimum as pt_bri19minimum } from './src/pt_br/'

import { i19minQuantity as pt_bri19minQuantity } from './src/pt_br/'

import { i19mlCategoryId as pt_bri19mlCategoryId } from './src/pt_br/'

import { i19mobile as pt_bri19mobile } from './src/pt_br/'

import { i19mobileLink as pt_bri19mobileLink } from './src/pt_br/'

import { i19modules as pt_bri19modules } from './src/pt_br/'

import { i19month as pt_bri19month } from './src/pt_br/'

import { i19monthly as pt_bri19monthly } from './src/pt_br/'

import { i19mostPopular as pt_bri19mostPopular } from './src/pt_br/'

import { i19mostRelevant as pt_bri19mostRelevant } from './src/pt_br/'

import { i19motorcycleCourier as pt_bri19motorcycleCourier } from './src/pt_br/'

import { i19myAccount as pt_bri19myAccount } from './src/pt_br/'

import { i19myAccountAndOrders as pt_bri19myAccountAndOrders } from './src/pt_br/'

import { i19myCart as pt_bri19myCart } from './src/pt_br/'

import { i19myFavorites as pt_bri19myFavorites } from './src/pt_br/'

import { i19myOrders as pt_bri19myOrders } from './src/pt_br/'

import { i19myShoppingCart as pt_bri19myShoppingCart } from './src/pt_br/'

import { i19name as pt_bri19name } from './src/pt_br/'

import { i19nameOnCard as pt_bri19nameOnCard } from './src/pt_br/'

import { i19namespace as pt_bri19namespace } from './src/pt_br/'

import { i19namespaceMsg as pt_bri19namespaceMsg } from './src/pt_br/'

import { i19nearTo as pt_bri19nearTo } from './src/pt_br/'

import { i19needHelpQn as pt_bri19needHelpQn } from './src/pt_br/'

import { i19new as pt_bri19new } from './src/pt_br/'

import { i19newAddress as pt_bri19newAddress } from './src/pt_br/'

import { i19newOrders as pt_bri19newOrders } from './src/pt_br/'

import { i19newPassword as pt_bri19newPassword } from './src/pt_br/'

import { i19newPriceRange as pt_bri19newPriceRange } from './src/pt_br/'

import { i19newsletter as pt_bri19newsletter } from './src/pt_br/'

import { i19newsletterReport as pt_bri19newsletterReport } from './src/pt_br/'

import { i19newVersionAvailableMsg as pt_bri19newVersionAvailableMsg } from './src/pt_br/'

import { i19next as pt_bri19next } from './src/pt_br/'

import { i19nickname as pt_bri19nickname } from './src/pt_br/'

import { i19no as pt_bri19no } from './src/pt_br/'

import { i19noAdditional as pt_bri19noAdditional } from './src/pt_br/'

import { i19noAppsAvailable as pt_bri19noAppsAvailable } from './src/pt_br/'

import { i19noBrand as pt_bri19noBrand } from './src/pt_br/'

import { i19noCategory as pt_bri19noCategory } from './src/pt_br/'

import { i19noCollection as pt_bri19noCollection } from './src/pt_br/'

import { i19noGrid as pt_bri19noGrid } from './src/pt_br/'

import { i19noItemSelected as pt_bri19noItemSelected } from './src/pt_br/'

import { i19noNewOrdersMsg as pt_bri19noNewOrdersMsg } from './src/pt_br/'

import { i19noNumber as pt_bri19noNumber } from './src/pt_br/'

import { i19noOrder as pt_bri19noOrder } from './src/pt_br/'

import { i19noPrice as pt_bri19noPrice } from './src/pt_br/'

import { i19noProduct as pt_bri19noProduct } from './src/pt_br/'

import { i19noProfileFoundWithEmail as pt_bri19noProfileFoundWithEmail } from './src/pt_br/'

import { i19noResultsFor as pt_bri19noResultsFor } from './src/pt_br/'

import { i19normal as pt_bri19normal } from './src/pt_br/'

import { i19noSavedFavoritesMsg as pt_bri19noSavedFavoritesMsg } from './src/pt_br/'

import { i19notConfigured as pt_bri19notConfigured } from './src/pt_br/'

import { i19notFound as pt_bri19notFound } from './src/pt_br/'

import { i19notifications as pt_bri19notifications } from './src/pt_br/'

import { i19notified as pt_bri19notified } from './src/pt_br/'

import { i19notifiedAdmins as pt_bri19notifiedAdmins } from './src/pt_br/'

import { i19notifiedAdminsMsg as pt_bri19notifiedAdminsMsg } from './src/pt_br/'

import { i19notifyAboutOrders as pt_bri19notifyAboutOrders } from './src/pt_br/'

import { i19notes as pt_bri19notes } from './src/pt_br/'

import { i19noUser as pt_bri19noUser } from './src/pt_br/'

import { i19number as pt_bri19number } from './src/pt_br/'

import { i19oauthOnPopup as pt_bri19oauthOnPopup } from './src/pt_br/'

import { i19of as pt_bri19of } from './src/pt_br/'

import { i19ofDiscount as pt_bri19ofDiscount } from './src/pt_br/'

import { i19offer as pt_bri19offer } from './src/pt_br/'

import { i19on as pt_bri19on } from './src/pt_br/'

import { i19onFreight as pt_bri19onFreight } from './src/pt_br/'

import { i19onFollowingAddress as pt_bri19onFollowingAddress } from './src/pt_br/'

import { i19only as pt_bri19only } from './src/pt_br/'

import { i19open as pt_bri19open } from './src/pt_br/'

import { i19openAt as pt_bri19openAt } from './src/pt_br/'

import { i19openCart as pt_bri19openCart } from './src/pt_br/'

import { i19openGallery as pt_bri19openGallery } from './src/pt_br/'

import { i19operational as pt_bri19operational } from './src/pt_br/'

import { i19option as pt_bri19option } from './src/pt_br/'

import { i19optionChosen as pt_bri19optionChosen } from './src/pt_br/'

import { i19options as pt_bri19options } from './src/pt_br/'

import { i19or as pt_bri19or } from './src/pt_br/'

import { i19order as pt_bri19order } from './src/pt_br/'

import { i19orderDetails as pt_bri19orderDetails } from './src/pt_br/'

import { i19orders as pt_bri19orders } from './src/pt_br/'

import { i19orderCreated as pt_bri19orderCreated } from './src/pt_br/'

import { i19orderConfirmationMsg as pt_bri19orderConfirmationMsg } from './src/pt_br/'

import { i19ordersCount as pt_bri19ordersCount } from './src/pt_br/'

import { i19orderCode as pt_bri19orderCode } from './src/pt_br/'

import { i19orderItems as pt_bri19orderItems } from './src/pt_br/'

import { i19orderNotesInputMsg as pt_bri19orderNotesInputMsg } from './src/pt_br/'

import { i19orderNumber as pt_bri19orderNumber } from './src/pt_br/'

import { i19orderObservations as pt_bri19orderObservations } from './src/pt_br/'

import { i19orderStatus as pt_bri19orderStatus } from './src/pt_br/'

import { i19orderValue as pt_bri19orderValue } from './src/pt_br/'

import { i19ordersTotalValue as pt_bri19ordersTotalValue } from './src/pt_br/'

import { i19organization as pt_bri19organization } from './src/pt_br/'

import { i19orProceedWith as pt_bri19orProceedWith } from './src/pt_br/'

import { i19otherCustomers as pt_bri19otherCustomers } from './src/pt_br/'

import { i19otherCustomersMsg as pt_bri19otherCustomersMsg } from './src/pt_br/'

import { i19outOfDate as pt_bri19outOfDate } from './src/pt_br/'

import { i19outOfStock as pt_bri19outOfStock } from './src/pt_br/'

import { i19ownDelivery as pt_bri19ownDelivery } from './src/pt_br/'

import { i19ownHand as pt_bri19ownHand } from './src/pt_br/'

import { i19ownHandCost as pt_bri19ownHandCost } from './src/pt_br/'

import { i19package as pt_bri19package } from './src/pt_br/'

import { i19packageInformation as pt_bri19packageInformation } from './src/pt_br/'

import { i19packageDimensions as pt_bri19packageDimensions } from './src/pt_br/'

import { i19packageDimensionsInformation as pt_bri19packageDimensionsInformation } from './src/pt_br/'

import { i19packageWeight as pt_bri19packageWeight } from './src/pt_br/'

import { i19pageLoaded as pt_bri19pageLoaded } from './src/pt_br/'

import { i19paid as pt_bri19paid } from './src/pt_br/'

import { i19paidTextMsg as pt_bri19paidTextMsg } from './src/pt_br/'

import { i19parcelIn as pt_bri19parcelIn } from './src/pt_br/'

import { i19parentCategory as pt_bri19parentCategory } from './src/pt_br/'

import { i19partner as pt_bri19partner } from './src/pt_br/'

import { i19partners as pt_bri19partners } from './src/pt_br/'

import { i19partnersProgram as pt_bri19partnersProgram } from './src/pt_br/'

import { i19passwordChangedSuccessfully as pt_bri19passwordChangedSuccessfully } from './src/pt_br/'

import { i19patch as pt_bri19patch } from './src/pt_br/'

import { i19payer as pt_bri19payer } from './src/pt_br/'

import { i19payment as pt_bri19payment } from './src/pt_br/'

import { i19paymentConfirmed as pt_bri19paymentConfirmed } from './src/pt_br/'

import { i19paymentDetails as pt_bri19paymentDetails } from './src/pt_br/'

import { i19paymentError as pt_bri19paymentError } from './src/pt_br/'

import { i19paymentErrorMsg as pt_bri19paymentErrorMsg } from './src/pt_br/'

import { i19paymentLink as pt_bri19paymentLink } from './src/pt_br/'

import { i19paymentMethod as pt_bri19paymentMethod } from './src/pt_br/'

import { i19paymentMethods as pt_bri19paymentMethods } from './src/pt_br/'

import { i19paymentMethodLabel as pt_bri19paymentMethodLabel } from './src/pt_br/'

import { i19paymentOptions as pt_bri19paymentOptions } from './src/pt_br/'

import { i19paymentRealized as pt_bri19paymentRealized } from './src/pt_br/'

import { i19personalRegistration as pt_bri19personalRegistration } from './src/pt_br/'

import { i19permalink as pt_bri19permalink } from './src/pt_br/'

import { i19perUnit as pt_bri19perUnit } from './src/pt_br/'

import { i19phone as pt_bri19phone } from './src/pt_br/'

import { i19phones as pt_bri19phones } from './src/pt_br/'

import { i19photo as pt_bri19photo } from './src/pt_br/'

import { i19photos as pt_bri19photos } from './src/pt_br/'

import { i19pickup as pt_bri19pickup } from './src/pt_br/'

import { i19pickUpAtTheStore as pt_bri19pickUpAtTheStore } from './src/pt_br/'

import { i19pickUpToday as pt_bri19pickUpToday } from './src/pt_br/'

import { i19picture as pt_bri19picture } from './src/pt_br/'

import { i19pictures as pt_bri19pictures } from './src/pt_br/'

import { i19pointsEarned as pt_bri19pointsEarned } from './src/pt_br/'

import { i19popularProducts as pt_bri19popularProducts } from './src/pt_br/'

import { i19popup as pt_bri19popup } from './src/pt_br/'

import { i19post as pt_bri19post } from './src/pt_br/'

import { i19posted as pt_bri19posted } from './src/pt_br/'

import { i19postingDeadline as pt_bri19postingDeadline } from './src/pt_br/'

import { i19postingIn as pt_bri19postingIn } from './src/pt_br/'

import { i19pressEnterToSave as pt_bri19pressEnterToSave } from './src/pt_br/'

import { i19previous as pt_bri19previous } from './src/pt_br/'

import { i19price as pt_bri19price } from './src/pt_br/'

import { i19priceAlteration as pt_bri19priceAlteration } from './src/pt_br/'

import { i19priceEffectiveDate as pt_bri19priceEffectiveDate } from './src/pt_br/'

import { i19priceEffectiveDateEnd as pt_bri19priceEffectiveDateEnd } from './src/pt_br/'

import { i19priceEffectiveDateStar as pt_bri19priceEffectiveDateStar } from './src/pt_br/'

import { i19priceRange as pt_bri19priceRange } from './src/pt_br/'

import { i19priceTo as pt_bri19priceTo } from './src/pt_br/'

import { i19pricing as pt_bri19pricing } from './src/pt_br/'

import { i19printBillet as pt_bri19printBillet } from './src/pt_br/'

import { i19privacy as pt_bri19privacy } from './src/pt_br/'

import { i19privacyPolicy as pt_bri19privacyPolicy } from './src/pt_br/'

import { i19private as pt_bri19private } from './src/pt_br/'

import { i19privateMetafields as pt_bri19privateMetafields } from './src/pt_br/'

import { i19privateMetafieldsMsg as pt_bri19privateMetafieldsMsg } from './src/pt_br/'

import { i19proceed as pt_bri19proceed } from './src/pt_br/'

import { i19product as pt_bri19product } from './src/pt_br/'

import { i19productDescription as pt_bri19productDescription } from './src/pt_br/'

import { i19productId as pt_bri19productId } from './src/pt_br/'

import { i19productImages as pt_bri19productImages } from './src/pt_br/'

import { i19productSpecifications as pt_bri19productSpecifications } from './src/pt_br/'

import { i19productionDeadline as pt_bri19productionDeadline } from './src/pt_br/'

import { i19productionTime as pt_bri19productionTime } from './src/pt_br/'

import { i19productionTimeCumulative as pt_bri19productionTimeCumulative } from './src/pt_br/'

import { i19productionTimeDaysMsg as pt_bri19productionTimeDaysMsg } from './src/pt_br/'

import { i19productionTimeWorkingDays as pt_bri19productionTimeWorkingDays } from './src/pt_br/'

import { i19productName as pt_bri19productName } from './src/pt_br/'

import { i19products as pt_bri19products } from './src/pt_br/'

import { i19productsAdded as pt_bri19productsAdded } from './src/pt_br/'

import { i19productsAddedToCart as pt_bri19productsAddedToCart } from './src/pt_br/'

import { i19productsPurchased as pt_bri19productsPurchased } from './src/pt_br/'

import { i19profile as pt_bri19profile } from './src/pt_br/'

import { i19profileNotFound as pt_bri19profileNotFound } from './src/pt_br/'

import { i19province as pt_bri19province } from './src/pt_br/'

import { i19provinceCode as pt_bri19provinceCode } from './src/pt_br/'

import { i19put as pt_bri19put } from './src/pt_br/'

import { i19quickSetup as pt_bri19quickSetup } from './src/pt_br/'

import { i19quantity as pt_bri19quantity } from './src/pt_br/'

import { i19quarterly as pt_bri19quarterly } from './src/pt_br/'

import { i19random as pt_bri19random } from './src/pt_br/'

import { i19rating as pt_bri19rating } from './src/pt_br/'

import { i19read as pt_bri19read } from './src/pt_br/'

import { i19receipt as pt_bri19receipt } from './src/pt_br/'

import { i19receiptPrice as pt_bri19receiptPrice } from './src/pt_br/'

import { i19receivedOrder as pt_bri19receivedOrder } from './src/pt_br/'

import { i19receiveNewsletter as pt_bri19receiveNewsletter } from './src/pt_br/'

import { i19receiveToday as pt_bri19receiveToday } from './src/pt_br/'

import { i19recipient as pt_bri19recipient } from './src/pt_br/'

import { i19recommendations as pt_bri19recommendations } from './src/pt_br/'

import { i19recommendedForYou as pt_bri19recommendedForYou } from './src/pt_br/'

import { i19recommendedProducts as pt_bri19recommendedProducts } from './src/pt_br/'

import { i19recurrence as pt_bri19recurrence } from './src/pt_br/'

import { i19recurrent as pt_bri19recurrent } from './src/pt_br/'

import { i19redirectToPayment as pt_bri19redirectToPayment } from './src/pt_br/'

import { i19reference as pt_bri19reference } from './src/pt_br/'

import { i19referenceCode as pt_bri19referenceCode } from './src/pt_br/'

import { i19referral as pt_bri19referral } from './src/pt_br/'

import { i19referringSite as pt_bri19referringSite } from './src/pt_br/'

import { i19refine as pt_bri19refine } from './src/pt_br/'

import { i19refineSearch as pt_bri19refineSearch } from './src/pt_br/'

import { i19reinstall as pt_bri19reinstall } from './src/pt_br/'

import { i19registerDate as pt_bri19registerDate } from './src/pt_br/'

import { i19registerProduct as pt_bri19registerProduct } from './src/pt_br/'

import { i19registerToBuy as pt_bri19registerToBuy } from './src/pt_br/'

import { i19registerToBuyMsg as pt_bri19registerToBuyMsg } from './src/pt_br/'

import { i19registration as pt_bri19registration } from './src/pt_br/'

import { i19relatedApps as pt_bri19relatedApps } from './src/pt_br/'

import { i19relatedProduct as pt_bri19relatedProduct } from './src/pt_br/'

import { i19relatedSearch as pt_bri19relatedSearch } from './src/pt_br/'

import { i19releases as pt_bri19releases } from './src/pt_br/'

import { i19relevance as pt_bri19relevance } from './src/pt_br/'

import { i19remove as pt_bri19remove } from './src/pt_br/'

import { i19removed as pt_bri19removed } from './src/pt_br/'

import { i19removeFromFavorites as pt_bri19removeFromFavorites } from './src/pt_br/'

import { i19reopenOrder as pt_bri19reopenOrder } from './src/pt_br/'

import { i19require as pt_bri19require } from './src/pt_br/'

import { i19required as pt_bri19required } from './src/pt_br/'

import { i19requiredEmail as pt_bri19requiredEmail } from './src/pt_br/'

import { i19requiredEmailMsg as pt_bri19requiredEmailMsg } from './src/pt_br/'

import { i19requiredField as pt_bri19requiredField } from './src/pt_br/'

import { i19resource as pt_bri19resource } from './src/pt_br/'

import { i19resourceId as pt_bri19resourceId } from './src/pt_br/'

import { i19results as pt_bri19results } from './src/pt_br/'

import { i19resultsFor as pt_bri19resultsFor } from './src/pt_br/'

import { i19retail as pt_bri19retail } from './src/pt_br/'

import { i19retry as pt_bri19retry } from './src/pt_br/'

import { i19reviews as pt_bri19reviews } from './src/pt_br/'

import { i19safeEnvMsg as pt_bri19safeEnvMsg } from './src/pt_br/'

import { i19sales as pt_bri19sales } from './src/pt_br/'

import { i19salesPrice as pt_bri19salesPrice } from './src/pt_br/'

import { i19salesChannels as pt_bri19salesChannels } from './src/pt_br/'

import { i19save as pt_bri19save } from './src/pt_br/'

import { i19saveBrand as pt_bri19saveBrand } from './src/pt_br/'

import { i19saveCard as pt_bri19saveCard } from './src/pt_br/'

import { i19saveCart as pt_bri19saveCart } from './src/pt_br/'

import { i19saveCategory as pt_bri19saveCategory } from './src/pt_br/'

import { i19saveClient as pt_bri19saveClient } from './src/pt_br/'

import { i19saved as pt_bri19saved } from './src/pt_br/'

import { i19savedWithSuccess as pt_bri19savedWithSuccess } from './src/pt_br/'

import { i19saveCollection as pt_bri19saveCollection } from './src/pt_br/'

import { i19saveGrid as pt_bri19saveGrid } from './src/pt_br/'

import { i19saveProduct as pt_bri19saveProduct } from './src/pt_br/'

import { i19saveText as pt_bri19saveText } from './src/pt_br/'

import { i19scheduledDelivery as pt_bri19scheduledDelivery } from './src/pt_br/'

import { i19search as pt_bri19search } from './src/pt_br/'

import { i19searchAgain as pt_bri19searchAgain } from './src/pt_br/'

import { i19searchEngineListing as pt_bri19searchEngineListing } from './src/pt_br/'

import { i19searchingFor as pt_bri19searchingFor } from './src/pt_br/'

import { i19searchItems as pt_bri19searchItems } from './src/pt_br/'

import { i19searchOfflineErrorMsg as pt_bri19searchOfflineErrorMsg } from './src/pt_br/'

import { i19searchProducts as pt_bri19searchProducts } from './src/pt_br/'

import { i19securityCode as pt_bri19securityCode } from './src/pt_br/'

import { i19seeAll as pt_bri19seeAll } from './src/pt_br/'

import { i19seeAllApps as pt_bri19seeAllApps } from './src/pt_br/'

import { i19seeAllThemes as pt_bri19seeAllThemes } from './src/pt_br/'

import { i19seeAll$1Category as pt_bri19seeAll$1Category } from './src/pt_br/'

import { i19seeCart as pt_bri19seeCart } from './src/pt_br/'

import { i19seeMore as pt_bri19seeMore } from './src/pt_br/'

import { i19seeMoreCategory as pt_bri19seeMoreCategory } from './src/pt_br/'

import { i19seeMoreInfo as pt_bri19seeMoreInfo } from './src/pt_br/'

import { i19seeOrder as pt_bri19seeOrder } from './src/pt_br/'

import { i19seeShoppingCart as pt_bri19seeShoppingCart } from './src/pt_br/'

import { i19select as pt_bri19select } from './src/pt_br/'

import { i19selected as pt_bri19selected } from './src/pt_br/'

import { i19selectedOffers as pt_bri19selectedOffers } from './src/pt_br/'

import { i19selectedOptions as pt_bri19selectedOptions } from './src/pt_br/'

import { i19selectVariation as pt_bri19selectVariation } from './src/pt_br/'

import { i19selectVariationMsg as pt_bri19selectVariationMsg } from './src/pt_br/'

import { i19seller as pt_bri19seller } from './src/pt_br/'

import { i19sellerRecommendations as pt_bri19sellerRecommendations } from './src/pt_br/'

import { i19sellerRecommendationsProducts as pt_bri19sellerRecommendationsProducts } from './src/pt_br/'

import { i19sellerRecommendationsTitle as pt_bri19sellerRecommendationsTitle } from './src/pt_br/'

import { i19sellerStatus as pt_bri19sellerStatus } from './src/pt_br/'

import { i19sellerStatusMsg as pt_bri19sellerStatusMsg } from './src/pt_br/'

import { i19send as pt_bri19send } from './src/pt_br/'

import { i19sender as pt_bri19sender } from './src/pt_br/'

import { i19senderFrom as pt_bri19senderFrom } from './src/pt_br/'

import { i19sendLoginCodeByEmail as pt_bri19sendLoginCodeByEmail } from './src/pt_br/'

import { i19seo as pt_bri19seo } from './src/pt_br/'

import { i19setDomainMsg as pt_bri19setDomainMsg } from './src/pt_br/'

import { i19setStoreDomain as pt_bri19setStoreDomain } from './src/pt_br/'

import { i19settings as pt_bri19settings } from './src/pt_br/'

import { i19setUp as pt_bri19setUp } from './src/pt_br/'

import { i19share as pt_bri19share } from './src/pt_br/'

import { i19shareOnFacebook as pt_bri19shareOnFacebook } from './src/pt_br/'

import { i19shareOnWhatsapp as pt_bri19shareOnWhatsapp } from './src/pt_br/'

import { i19shipped as pt_bri19shipped } from './src/pt_br/'

import { i19shippedBy as pt_bri19shippedBy } from './src/pt_br/'

import { i19shipping as pt_bri19shipping } from './src/pt_br/'

import { i19shippingAdditionalPrice as pt_bri19shippingAdditionalPrice } from './src/pt_br/'

import { i19shippingAddress as pt_bri19shippingAddress } from './src/pt_br/'

import { i19shippingCustomFields as pt_bri19shippingCustomFields } from './src/pt_br/'

import { i19shippingDiscount as pt_bri19shippingDiscount } from './src/pt_br/'

import { i19shippingInvoices as pt_bri19shippingInvoices } from './src/pt_br/'

import { i19shippingMethod as pt_bri19shippingMethod } from './src/pt_br/'

import { i19shippingMethodLabel as pt_bri19shippingMethodLabel } from './src/pt_br/'

import { i19shippingNotes as pt_bri19shippingNotes } from './src/pt_br/'

import { i19shippingNotesMsg as pt_bri19shippingNotesMsg } from './src/pt_br/'

import { i19shippingStatus as pt_bri19shippingStatus } from './src/pt_br/'

import { i19shippingTag as pt_bri19shippingTag } from './src/pt_br/'

import { i19shippingTags as pt_bri19shippingTags } from './src/pt_br/'

import { i19shippingTaxes as pt_bri19shippingTaxes } from './src/pt_br/'

import { i19shippingTaxesMsg as pt_bri19shippingTaxesMsg } from './src/pt_br/'

import { i19shippingTo as pt_bri19shippingTo } from './src/pt_br/'

import { i19shippingTotalCost as pt_bri19shippingTotalCost } from './src/pt_br/'

import { i19shopByCategory as pt_bri19shopByCategory } from './src/pt_br/'

import { i19shopByFranchise as pt_bri19shopByFranchise } from './src/pt_br/'

import { i19shopNow as pt_bri19shopNow } from './src/pt_br/'

import { i19shoppingCart as pt_bri19shoppingCart } from './src/pt_br/'

import { i19short as pt_bri19short } from './src/pt_br/'

import { i19shortDescription as pt_bri19shortDescription } from './src/pt_br/'

import { i19show as pt_bri19show } from './src/pt_br/'

import { i19showDescription as pt_bri19showDescription } from './src/pt_br/'

import { i19showReview as pt_bri19showReview } from './src/pt_br/'

import { i19signIn as pt_bri19signIn } from './src/pt_br/'

import { i19signInWith as pt_bri19signInWith } from './src/pt_br/'

import { i19signInWithAnotherEmail as pt_bri19signInWithAnotherEmail } from './src/pt_br/'

import { i19signUp as pt_bri19signUp } from './src/pt_br/'

import { i19signUpWith as pt_bri19signUpWith } from './src/pt_br/'

import { i19signature as pt_bri19signature } from './src/pt_br/'

import { i19size as pt_bri19size } from './src/pt_br/'

import { i19sizeGuide as pt_bri19sizeGuide } from './src/pt_br/'

import { i19sku as pt_bri19sku } from './src/pt_br/'

import { i19slug as pt_bri19slug } from './src/pt_br/'

import { i19socialLogin as pt_bri19socialLogin } from './src/pt_br/'

import { i19socialMedia as pt_bri19socialMedia } from './src/pt_br/'

import { i19source as pt_bri19source } from './src/pt_br/'

import { i19sourceName as pt_bri19sourceName } from './src/pt_br/'

import { i19sort as pt_bri19sort } from './src/pt_br/'

import { i19sortBy as pt_bri19sortBy } from './src/pt_br/'

import { i19subscribe as pt_bri19subscribe } from './src/pt_br/'

import { i19subscription as pt_bri19subscription } from './src/pt_br/'

import { i19subscriptionInvoices as pt_bri19subscriptionInvoices } from './src/pt_br/'

import { i19subscriptions as pt_bri19subscriptions } from './src/pt_br/'

import { i19submit as pt_bri19submit } from './src/pt_br/'

import { i19suggestedProducts as pt_bri19suggestedProducts } from './src/pt_br/'

import { i19specifications as pt_bri19specifications } from './src/pt_br/'

import { i19staffNotes as pt_bri19staffNotes } from './src/pt_br/'

import { i19staffSignature as pt_bri19staffSignature } from './src/pt_br/'

import { i19star as pt_bri19star } from './src/pt_br/'

import { i19startDate as pt_bri19startDate } from './src/pt_br/'

import { i19state as pt_bri19state } from './src/pt_br/'

import { i19status as pt_bri19status } from './src/pt_br/'

import { i19statusLink as pt_bri19statusLink } from './src/pt_br/'

import { i19statusMobileLink as pt_bri19statusMobileLink } from './src/pt_br/'

import { i19street as pt_bri19street } from './src/pt_br/'

import { i19store as pt_bri19store } from './src/pt_br/'

import { i19storefront as pt_bri19storefront } from './src/pt_br/'

import { i19subresource as pt_bri19subresource } from './src/pt_br/'

import { i19subresourceId as pt_bri19subresourceId } from './src/pt_br/'

import { i19subtitle as pt_bri19subtitle } from './src/pt_br/'

import { i19subtotal as pt_bri19subtotal } from './src/pt_br/'

import { i19success as pt_bri19success } from './src/pt_br/'

import { i19successfullyInstalled as pt_bri19successfullyInstalled } from './src/pt_br/'

import { i19successfullyUninstalled as pt_bri19successfullyUninstalled } from './src/pt_br/'

import { i19summary as pt_bri19summary } from './src/pt_br/'

import { i19support as pt_bri19support } from './src/pt_br/'

import { i19table as pt_bri19table } from './src/pt_br/'

import { i19tax as pt_bri19tax } from './src/pt_br/'

import { i19taxExempt as pt_bri19taxExempt } from './src/pt_br/'

import { i19termSearched as pt_bri19termSearched } from './src/pt_br/'

import { i19test as pt_bri19test } from './src/pt_br/'

import { i19thanks as pt_bri19thanks } from './src/pt_br/'

import { i19thanksForPurchase as pt_bri19thanksForPurchase } from './src/pt_br/'

import { i19theme as pt_bri19theme } from './src/pt_br/'

import { i19themes as pt_bri19themes } from './src/pt_br/'

import { i19ticketCode as pt_bri19ticketCode } from './src/pt_br/'

import { i19title as pt_bri19title } from './src/pt_br/'

import { i19titleTag as pt_bri19titleTag } from './src/pt_br/'

import { i19to as pt_bri19to } from './src/pt_br/'

import { i19toEarn as pt_bri19toEarn } from './src/pt_br/'

import { i19toPay as pt_bri19toPay } from './src/pt_br/'

import { i19today as pt_bri19today } from './src/pt_br/'

import { i19token as pt_bri19token } from './src/pt_br/'

import { i19total as pt_bri19total } from './src/pt_br/'

import { i19totalAmount as pt_bri19totalAmount } from './src/pt_br/'

import { i19totalCancelled as pt_bri19totalCancelled } from './src/pt_br/'

import { i19totalCancelledMsg as pt_bri19totalCancelledMsg } from './src/pt_br/'

import { i19totalResultsFor as pt_bri19totalResultsFor } from './src/pt_br/'

import { i19totalSpent as pt_bri19totalSpent } from './src/pt_br/'

import { i19trackDelivery as pt_bri19trackDelivery } from './src/pt_br/'

import { i19trackingCodes as pt_bri19trackingCodes } from './src/pt_br/'

import { i19transactionCode as pt_bri19transactionCode } from './src/pt_br/'

import { i19transactionId as pt_bri19transactionId } from './src/pt_br/'

import { i19transactionItems as pt_bri19transactionItems } from './src/pt_br/'

import { i19transactionStatus as pt_bri19transactionStatus } from './src/pt_br/'

import { i19transactionStatusMsg as pt_bri19transactionStatusMsg } from './src/pt_br/'

import { i19transactionType as pt_bri19transactionType } from './src/pt_br/'

import { i19trendingApps as pt_bri19trendingApps } from './src/pt_br/'

import { i19triggers as pt_bri19triggers } from './src/pt_br/'

import { i19triggersMsg as pt_bri19triggersMsg } from './src/pt_br/'

import { i19tryAgain as pt_bri19tryAgain } from './src/pt_br/'

import { i19type as pt_bri19type } from './src/pt_br/'

import { i19unable as pt_bri19unable } from './src/pt_br/'

import { i19unableToInstallApp as pt_bri19unableToInstallApp } from './src/pt_br/'

import { i19unableToUninstallApp as pt_bri19unableToUninstallApp } from './src/pt_br/'

import { i19unavailable as pt_bri19unavailable } from './src/pt_br/'

import { i19uninstall as pt_bri19uninstall } from './src/pt_br/'

import { i19uninstallingApp as pt_bri19uninstallingApp } from './src/pt_br/'

import { i19uninstallingAppWithSuccess as pt_bri19uninstallingAppWithSuccess } from './src/pt_br/'

import { i19units as pt_bri19units } from './src/pt_br/'

import { i19unitsInStock as pt_bri19unitsInStock } from './src/pt_br/'

import { i19unlimited as pt_bri19unlimited } from './src/pt_br/'

import { i19untilTomorrow as pt_bri19untilTomorrow } from './src/pt_br/'

import { i19unsubscribe as pt_bri19unsubscribe } from './src/pt_br/'

import { i19update as pt_bri19update } from './src/pt_br/'

import { i19updatedAt as pt_bri19updatedAt } from './src/pt_br/'

import { i19upload as pt_bri19upload } from './src/pt_br/'

import { i19uploadLogo as pt_bri19uploadLogo } from './src/pt_br/'

import { i19uploadTable as pt_bri19uploadTable } from './src/pt_br/'

import { i19upTo as pt_bri19upTo } from './src/pt_br/'

import { i19user as pt_bri19user } from './src/pt_br/'

import { i19userFound as pt_bri19userFound } from './src/pt_br/'

import { i19username as pt_bri19username } from './src/pt_br/'

import { i19usersFound as pt_bri19usersFound } from './src/pt_br/'

import { i19use$1LoyaltyPoints as pt_bri19use$1LoyaltyPoints } from './src/pt_br/'

import { i19utm as pt_bri19utm } from './src/pt_br/'

import { i19utmCampaign as pt_bri19utmCampaign } from './src/pt_br/'

import { i19utmContent as pt_bri19utmContent } from './src/pt_br/'

import { i19utmMedium as pt_bri19utmMedium } from './src/pt_br/'

import { i19utmSource as pt_bri19utmSource } from './src/pt_br/'

import { i19utmTerm as pt_bri19utmTerm } from './src/pt_br/'

import { i19url as pt_bri19url } from './src/pt_br/'

import { i19valid as pt_bri19valid } from './src/pt_br/'

import { i19validate as pt_bri19validate } from './src/pt_br/'

import { i19validThru as pt_bri19validThru } from './src/pt_br/'

import { i19value as pt_bri19value } from './src/pt_br/'

import { i19variation as pt_bri19variation } from './src/pt_br/'

import { i19variationId as pt_bri19variationId } from './src/pt_br/'

import { i19variationName as pt_bri19variationName } from './src/pt_br/'

import { i19variations as pt_bri19variations } from './src/pt_br/'

import { i19verified as pt_bri19verified } from './src/pt_br/'

import { i19version as pt_bri19version } from './src/pt_br/'

import { i19versionDate as pt_bri19versionDate } from './src/pt_br/'

import { i19video as pt_bri19video } from './src/pt_br/'

import { i19videos as pt_bri19videos } from './src/pt_br/'

import { i19visible as pt_bri19visible } from './src/pt_br/'

import { i19visibleProducts as pt_bri19visibleProducts } from './src/pt_br/'

import { i19visitor as pt_bri19visitor } from './src/pt_br/'

import { i19visitorCheckout as pt_bri19visitorCheckout } from './src/pt_br/'

import { i19warning as pt_bri19warning } from './src/pt_br/'

import { i19warningToReinstallAppMsg as pt_bri19warningToReinstallAppMsg } from './src/pt_br/'

import { i19wasAnErrorOnLogin as pt_bri19wasAnErrorOnLogin } from './src/pt_br/'

import { i19webhooks as pt_bri19webhooks } from './src/pt_br/'

import { i19webhooksMsg as pt_bri19webhooksMsg } from './src/pt_br/'

import { i19webhooksApiMsg as pt_bri19webhooksApiMsg } from './src/pt_br/'

import { i19webhooksApiExternalApiMsg as pt_bri19webhooksApiExternalApiMsg } from './src/pt_br/'

import { i19webhooksApiStoreApiMsg as pt_bri19webhooksApiStoreApiMsg } from './src/pt_br/'

import { i19webhooksMapBodyMsg as pt_bri19webhooksMapBodyMsg } from './src/pt_br/'

import { i19webhooksSendBodyMsg as pt_bri19webhooksSendBodyMsg } from './src/pt_br/'

import { i19weekly as pt_bri19weekly } from './src/pt_br/'

import { i19weight as pt_bri19weight } from './src/pt_br/'

import { i19weFrom as pt_bri19weFrom } from './src/pt_br/'

import { i19welcome as pt_bri19welcome } from './src/pt_br/'

import { i19welcomeTextMsg as pt_bri19welcomeTextMsg } from './src/pt_br/'

import { i19weRecommendToYou as pt_bri19weRecommendToYou } from './src/pt_br/'

import { i19weUseYourDataToMsg as pt_bri19weUseYourDataToMsg } from './src/pt_br/'

import { i19widgets as pt_bri19widgets } from './src/pt_br/'

import { i19width as pt_bri19width } from './src/pt_br/'

import { i19willReceiveMsg as pt_bri19willReceiveMsg } from './src/pt_br/'

import { i19with as pt_bri19with } from './src/pt_br/'

import { i19withoutInstallmentRates as pt_bri19withoutInstallmentRates } from './src/pt_br/'

import { i19write as pt_bri19write } from './src/pt_br/'

import { i19writeReview as pt_bri19writeReview } from './src/pt_br/'

import { i19workingDays as pt_bri19workingDays } from './src/pt_br/'

import { i19year as pt_bri19year } from './src/pt_br/'

import { i19yearly as pt_bri19yearly } from './src/pt_br/'

import { i19years as pt_bri19years } from './src/pt_br/'

import { i19yes as pt_bri19yes } from './src/pt_br/'

import { i19youEarn as pt_bri19youEarn } from './src/pt_br/'

import { i19yourInstalledApps as pt_bri19yourInstalledApps } from './src/pt_br/'

import { i19zipCode as pt_bri19zipCode } from './src/pt_br/'

import { i19zipCodeRange as pt_bri19zipCodeRange } from './src/pt_br/'

import { i19CancelReason as pt_bri19CancelReason } from './src/pt_br/'

import { i19ChannelType as pt_bri19ChannelType } from './src/pt_br/'

import { i19CommodityType as pt_bri19CommodityType } from './src/pt_br/'

import { i19ProductCondition as pt_bri19ProductCondition } from './src/pt_br/'

import { i19DiscountApplyAt as pt_bri19DiscountApplyAt } from './src/pt_br/'

import { i19DiscountType as pt_bri19DiscountType } from './src/pt_br/'

import { i19FinancialStatus as pt_bri19FinancialStatus } from './src/pt_br/'

import { i19FinancialStatusMsg as pt_bri19FinancialStatusMsg } from './src/pt_br/'

import { i19FulfillmentStatus as pt_bri19FulfillmentStatus } from './src/pt_br/'

import { i19FulfillmentStatusMsg as pt_bri19FulfillmentStatusMsg } from './src/pt_br/'

import { i19Gender as pt_bri19Gender } from './src/pt_br/'

import { i19InscriptionType as pt_bri19InscriptionType } from './src/pt_br/'

import { i19OrderStatus as pt_bri19OrderStatus } from './src/pt_br/'

import { i19PaymentMethodCodes as pt_bri19PaymentMethodCodes } from './src/pt_br/'

import { i19PaymentsHistoryStatus as pt_bri19PaymentsHistoryStatus } from './src/pt_br/'

import { i19PhoneType as pt_bri19PhoneType } from './src/pt_br/'

import { i19RegistryType as pt_bri19RegistryType } from './src/pt_br/'

import { i19ShippingLinesStatus as pt_bri19ShippingLinesStatus } from './src/pt_br/'

import { i19StateRegister as pt_bri19StateRegister } from './src/pt_br/'

import { i19TransactionsType as pt_bri19TransactionsType } from './src/pt_br/'

import { i19ApiActions as pt_bri19ApiActions } from './src/pt_br/'

import { i19StoreApiResources as pt_bri19StoreApiResources } from './src/pt_br/'

export const i19a = { en_us: en_usi19a, pt_br: pt_bri19a }

export const i19about = { en_us: en_usi19about, pt_br: pt_bri19about }

export const i19aboutCvvMsg = { en_us: en_usi19aboutCvvMsg, pt_br: pt_bri19aboutCvvMsg }

export const i19aboveOf = { en_us: en_usi19aboveOf, pt_br: pt_bri19aboveOf }

export const i19acceptAttachedFile = { en_us: en_usi19acceptAttachedFile, pt_br: pt_bri19acceptAttachedFile }

export const i19acceptCustomOptionByCustomer = { en_us: en_usi19acceptCustomOptionByCustomer, pt_br: pt_bri19acceptCustomOptionByCustomer }

export const i19activate = { en_us: en_usi19activate, pt_br: pt_bri19activate }

export const i19active = { en_us: en_usi19active, pt_br: pt_bri19active }

export const i19add = { en_us: en_usi19add, pt_br: pt_bri19add }

export const i19addApp = { en_us: en_usi19addApp, pt_br: pt_bri19addApp }

export const i19addCart = { en_us: en_usi19addCart, pt_br: pt_bri19addCart }

export const i19addClient = { en_us: en_usi19addClient, pt_br: pt_bri19addClient }

export const i19addDiscountCoupon = { en_us: en_usi19addDiscountCoupon, pt_br: pt_bri19addDiscountCoupon }

export const i19addGiftList = { en_us: en_usi19addGiftList, pt_br: pt_bri19addGiftList }

export const i19addGrid = { en_us: en_usi19addGrid, pt_br: pt_bri19addGrid }

export const i19additional = { en_us: en_usi19additional, pt_br: pt_bri19additional }

export const i19additionalComments = { en_us: en_usi19additionalComments, pt_br: pt_bri19additionalComments }

export const i19additionalCost = { en_us: en_usi19additionalCost, pt_br: pt_bri19additionalCost }

export const i19additionalCostOption = { en_us: en_usi19additionalCostOption, pt_br: pt_bri19additionalCostOption }

export const i19additionalInfo = { en_us: en_usi19additionalInfo, pt_br: pt_bri19additionalInfo }

export const i19additionalNotes = { en_us: en_usi19additionalNotes, pt_br: pt_bri19additionalNotes }

export const i19address = { en_us: en_usi19address, pt_br: pt_bri19address }

export const i19addresses = { en_us: en_usi19addresses, pt_br: pt_bri19addresses }

export const i19addressesName = { en_us: en_usi19addressesName, pt_br: pt_bri19addressesName }

export const i19addMoreProducts = { en_us: en_usi19addMoreProducts, pt_br: pt_bri19addMoreProducts }

export const i19addPreference = { en_us: en_usi19addPreference, pt_br: pt_bri19addPreference }

export const i19addProduct = { en_us: en_usi19addProduct, pt_br: pt_bri19addProduct }

export const i19addToCart = { en_us: en_usi19addToCart, pt_br: pt_bri19addToCart }

export const i19addToFavorites = { en_us: en_usi19addToFavorites, pt_br: pt_bri19addToFavorites }

export const i19addToPrice = { en_us: en_usi19addToPrice, pt_br: pt_bri19addToPrice }

export const i19addVariants = { en_us: en_usi19addVariants, pt_br: pt_bri19addVariants }

export const i19add$1ToEarn = { en_us: en_usi19add$1ToEarn, pt_br: pt_bri19add$1ToEarn }

export const i19adminSettings = { en_us: en_usi19adminSettings, pt_br: pt_bri19adminSettings }

export const i19adRelevance = { en_us: en_usi19adRelevance, pt_br: pt_bri19adRelevance }

export const i19adType = { en_us: en_usi19adType, pt_br: pt_bri19adType }

export const i19advanced = { en_us: en_usi19advanced, pt_br: pt_bri19advanced }

export const i19adwords = { en_us: en_usi19adwords, pt_br: pt_bri19adwords }

export const i19adwordsRemarketing = { en_us: en_usi19adwordsRemarketing, pt_br: pt_bri19adwordsRemarketing }

export const i19adwordsRemarketingCode = { en_us: en_usi19adwordsRemarketingCode, pt_br: pt_bri19adwordsRemarketingCode }

export const i19affiliateCoede = { en_us: en_usi19affiliateCoede, pt_br: pt_bri19affiliateCoede }

export const i19afterApproval = { en_us: en_usi19afterApproval, pt_br: pt_bri19afterApproval }

export const i19afterPayment = { en_us: en_usi19afterPayment, pt_br: pt_bri19afterPayment }

export const i19all = { en_us: en_usi19all, pt_br: pt_bri19all }

export const i19allCategories = { en_us: en_usi19allCategories, pt_br: pt_bri19allCategories }

export const i19allOptions = { en_us: en_usi19allOptions, pt_br: pt_bri19allOptions }

export const i19alt = { en_us: en_usi19alt, pt_br: pt_bri19alt }

export const i19amount = { en_us: en_usi19amount, pt_br: pt_bri19amount }

export const i19another = { en_us: en_usi19another, pt_br: pt_bri19another }

export const i19anyPaymentMethodMsg = { en_us: en_usi19anyPaymentMethodMsg, pt_br: pt_bri19anyPaymentMethodMsg }

export const i19api = { en_us: en_usi19api, pt_br: pt_bri19api }

export const i19app = { en_us: en_usi19app, pt_br: pt_bri19app }

export const i19appAlreadyInstalledMsg = { en_us: en_usi19appAlreadyInstalledMsg, pt_br: pt_bri19appAlreadyInstalledMsg }

export const i19appConfiguration = { en_us: en_usi19appConfiguration, pt_br: pt_bri19appConfiguration }

export const i19apps = { en_us: en_usi19apps, pt_br: pt_bri19apps }

export const i19appDevelopers = { en_us: en_usi19appDevelopers, pt_br: pt_bri19appDevelopers }

export const i19application = { en_us: en_usi19application, pt_br: pt_bri19application }

export const i19applications = { en_us: en_usi19applications, pt_br: pt_bri19applications }

export const i19applyDiscount = { en_us: en_usi19applyDiscount, pt_br: pt_bri19applyDiscount }

export const i19applyFilters = { en_us: en_usi19applyFilters, pt_br: pt_bri19applyFilters }

export const i19areYouWantToDeleteAppQn = { en_us: en_usi19areYouWantToDeleteAppQn, pt_br: pt_bri19areYouWantToDeleteAppQn }

export const i19associateImage = { en_us: en_usi19associateImage, pt_br: pt_bri19associateImage }

export const i19associateImages = { en_us: en_usi19associateImages, pt_br: pt_bri19associateImages }

export const i19asOf = { en_us: en_usi19asOf, pt_br: pt_bri19asOf }

export const i19at = { en_us: en_usi19at, pt_br: pt_bri19at }

export const i19atSight = { en_us: en_usi19atSight, pt_br: pt_bri19atSight }

export const i19attachment = { en_us: en_usi19attachment, pt_br: pt_bri19attachment }

export const i19attention = { en_us: en_usi19attention, pt_br: pt_bri19attention }

export const i19authentication = { en_us: en_usi19authentication, pt_br: pt_bri19authentication }

export const i19author = { en_us: en_usi19author, pt_br: pt_bri19author }

export const i19authorizedStores = { en_us: en_usi19authorizedStores, pt_br: pt_bri19authorizedStores }

export const i19automaticallyTrackInventory = { en_us: en_usi19automaticallyTrackInventory, pt_br: pt_bri19automaticallyTrackInventory }

export const i19available = { en_us: en_usi19available, pt_br: pt_bri19available }

export const i19availablePurchase = { en_us: en_usi19availablePurchase, pt_br: pt_bri19availablePurchase }

export const i19availableApps = { en_us: en_usi19availableApps, pt_br: pt_bri19availableApps }

export const i19average = { en_us: en_usi19average, pt_br: pt_bri19average }

export const i19averageTicket = { en_us: en_usi19averageTicket, pt_br: pt_bri19averageTicket }

export const i19back = { en_us: en_usi19back, pt_br: pt_bri19back }

export const i19backToCart = { en_us: en_usi19backToCart, pt_br: pt_bri19backToCart }

export const i19backToProduct = { en_us: en_usi19backToProduct, pt_br: pt_bri19backToProduct }

export const i19bag = { en_us: en_usi19bag, pt_br: pt_bri19bag }

export const i19balanceOrPoints = { en_us: en_usi19balanceOrPoints, pt_br: pt_bri19balanceOrPoints }

export const i19banner = { en_us: en_usi19banner, pt_br: pt_bri19banner }

export const i19banners = { en_us: en_usi19banners, pt_br: pt_bri19banners }

export const i19bannersCollection = { en_us: en_usi19bannersCollection, pt_br: pt_bri19bannersCollection }

export const i19barcodes = { en_us: en_usi19barcodes, pt_br: pt_bri19barcodes }

export const i19basePrice = { en_us: en_usi19basePrice, pt_br: pt_bri19basePrice }

export const i19bearersDocument = { en_us: en_usi19bearersDocument, pt_br: pt_bri19bearersDocument }

export const i19best = { en_us: en_usi19best, pt_br: pt_bri19best }

export const i19bestSellers = { en_us: en_usi19bestSellers, pt_br: pt_bri19bestSellers }

export const i19biannual = { en_us: en_usi19biannual, pt_br: pt_bri19biannual }

export const i19billingAddress = { en_us: en_usi19billingAddress, pt_br: pt_bri19billingAddress }

export const i19bimonthly = { en_us: en_usi19bimonthly, pt_br: pt_bri19bimonthly }

export const i19birthdate = { en_us: en_usi19birthdate, pt_br: pt_bri19birthdate }

export const i19biweekly = { en_us: en_usi19biweekly, pt_br: pt_bri19biweekly }

export const i19block = { en_us: en_usi19block, pt_br: pt_bri19block }

export const i19borough = { en_us: en_usi19borough, pt_br: pt_bri19borough }

export const i19budgetOnly = { en_us: en_usi19budgetOnly, pt_br: pt_bri19budgetOnly }

export const i19buy = { en_us: en_usi19buy, pt_br: pt_bri19buy }

export const i19buyAgain = { en_us: en_usi19buyAgain, pt_br: pt_bri19buyAgain }

export const i19buyAlsoMsg = { en_us: en_usi19buyAlsoMsg, pt_br: pt_bri19buyAlsoMsg }

export const i19buyer = { en_us: en_usi19buyer, pt_br: pt_bri19buyer }

export const i19buyers = { en_us: en_usi19buyers, pt_br: pt_bri19buyers }

export const i19buyersProfile = { en_us: en_usi19buyersProfile, pt_br: pt_bri19buyersProfile }

export const i19buyNow = { en_us: en_usi19buyNow, pt_br: pt_bri19buyNow }

export const i19buyKit = { en_us: en_usi19buyKit, pt_br: pt_bri19buyKit }

export const i19by = { en_us: en_usi19by, pt_br: pt_bri19by }

export const i19brand = { en_us: en_usi19brand, pt_br: pt_bri19brand }

export const i19brandBanners = { en_us: en_usi19brandBanners, pt_br: pt_bri19brandBanners }

export const i19brandName = { en_us: en_usi19brandName, pt_br: pt_bri19brandName }

export const i19brandFound = { en_us: en_usi19brandFound, pt_br: pt_bri19brandFound }

export const i19brands = { en_us: en_usi19brands, pt_br: pt_bri19brands }

export const i19brandsFound = { en_us: en_usi19brandsFound, pt_br: pt_bri19brandsFound }

export const i19brazil = { en_us: en_usi19brazil, pt_br: pt_bri19brazil }

export const i19browserIp = { en_us: en_usi19browserIp, pt_br: pt_bri19browserIp }

export const i19buyWith = { en_us: en_usi19buyWith, pt_br: pt_bri19buyWith }

export const i19calculateShipping = { en_us: en_usi19calculateShipping, pt_br: pt_bri19calculateShipping }

export const i19callTo = { en_us: en_usi19callTo, pt_br: pt_bri19callTo }

export const i19callback = { en_us: en_usi19callback, pt_br: pt_bri19callback }

export const i19campaign = { en_us: en_usi19campaign, pt_br: pt_bri19campaign }

export const i19campaignAppliedMsg = { en_us: en_usi19campaignAppliedMsg, pt_br: pt_bri19campaignAppliedMsg }

export const i19cancel = { en_us: en_usi19cancel, pt_br: pt_bri19cancel }

export const i19cancelled = { en_us: en_usi19cancelled, pt_br: pt_bri19cancelled }

export const i19cancelledAt = { en_us: en_usi19cancelledAt, pt_br: pt_bri19cancelledAt }

export const i19cancelOrder = { en_us: en_usi19cancelOrder, pt_br: pt_bri19cancelOrder }

export const i19cancelReason = { en_us: en_usi19cancelReason, pt_br: pt_bri19cancelReason }

export const i19cardNumber = { en_us: en_usi19cardNumber, pt_br: pt_bri19cardNumber }

export const i19cartConfirmed = { en_us: en_usi19cartConfirmed, pt_br: pt_bri19cartConfirmed }

export const i19cartDetails = { en_us: en_usi19cartDetails, pt_br: pt_bri19cartDetails }

export const i19cartItems = { en_us: en_usi19cartItems, pt_br: pt_bri19cartItems }

export const i19cartReview = { en_us: en_usi19cartReview, pt_br: pt_bri19cartReview }

export const i19cartUpdated = { en_us: en_usi19cartUpdated, pt_br: pt_bri19cartUpdated }

export const i19categories = { en_us: en_usi19categories, pt_br: pt_bri19categories }

export const i19category = { en_us: en_usi19category, pt_br: pt_bri19category }

export const i19categoryBanners = { en_us: en_usi19categoryBanners, pt_br: pt_bri19categoryBanners }

export const i19categoryFound = { en_us: en_usi19categoryFound, pt_br: pt_bri19categoryFound }

export const i19categoryName = { en_us: en_usi19categoryName, pt_br: pt_bri19categoryName }

export const i19cellphone = { en_us: en_usi19cellphone, pt_br: pt_bri19cellphone }

export const i19changePaymentMethod = { en_us: en_usi19changePaymentMethod, pt_br: pt_bri19changePaymentMethod }

export const i19changeShippingMethod = { en_us: en_usi19changeShippingMethod, pt_br: pt_bri19changeShippingMethod }

export const i19channel = { en_us: en_usi19channel, pt_br: pt_bri19channel }

export const i19channelId = { en_us: en_usi19channelId, pt_br: pt_bri19channelId }

export const i19channels = { en_us: en_usi19channels, pt_br: pt_bri19channels }

export const i19channelType = { en_us: en_usi19channelType, pt_br: pt_bri19channelType }

export const i19checkout = { en_us: en_usi19checkout, pt_br: pt_bri19checkout }

export const i19checkoutEnabled = { en_us: en_usi19checkoutEnabled, pt_br: pt_bri19checkoutEnabled }

export const i19checkoutDone = { en_us: en_usi19checkoutDone, pt_br: pt_bri19checkoutDone }

export const i19checkoutLink = { en_us: en_usi19checkoutLink, pt_br: pt_bri19checkoutLink }

export const i19checkoutMobileLink = { en_us: en_usi19checkoutMobileLink, pt_br: pt_bri19checkoutMobileLink }

export const i19checkoutVisitor = { en_us: en_usi19checkoutVisitor, pt_br: pt_bri19checkoutVisitor }

export const i19checkoutVisitorMsg = { en_us: en_usi19checkoutVisitorMsg, pt_br: pt_bri19checkoutVisitorMsg }

export const i19chooseSubscriptionPeriod = { en_us: en_usi19chooseSubscriptionPeriod, pt_br: pt_bri19chooseSubscriptionPeriod }

export const i19city = { en_us: en_usi19city, pt_br: pt_bri19city }

export const i19clear = { en_us: en_usi19clear, pt_br: pt_bri19clear }

export const i19clearFilters = { en_us: en_usi19clearFilters, pt_br: pt_bri19clearFilters }

export const i19click = { en_us: en_usi19click, pt_br: pt_bri19click }

export const i19clickHere = { en_us: en_usi19clickHere, pt_br: pt_bri19clickHere }

export const i19close = { en_us: en_usi19close, pt_br: pt_bri19close }

export const i19closedAt = { en_us: en_usi19closedAt, pt_br: pt_bri19closedAt }

export const i19closeFilters = { en_us: en_usi19closeFilters, pt_br: pt_bri19closeFilters }

export const i19code = { en_us: en_usi19code, pt_br: pt_bri19code }

export const i19codeCopied = { en_us: en_usi19codeCopied, pt_br: pt_bri19codeCopied }

export const i19collection = { en_us: en_usi19collection, pt_br: pt_bri19collection }

export const i19collections = { en_us: en_usi19collections, pt_br: pt_bri19collections }

export const i19collectionBanners = { en_us: en_usi19collectionBanners, pt_br: pt_bri19collectionBanners }

export const i19collectionItems = { en_us: en_usi19collectionItems, pt_br: pt_bri19collectionItems }

export const i19collectionName = { en_us: en_usi19collectionName, pt_br: pt_bri19collectionName }

export const i19color = { en_us: en_usi19color, pt_br: pt_bri19color }

export const i19colors = { en_us: en_usi19colors, pt_br: pt_bri19colors }

export const i19community = { en_us: en_usi19community, pt_br: pt_bri19community }

export const i19companyRegistration = { en_us: en_usi19companyRegistration, pt_br: pt_bri19companyRegistration }

export const i19compareAtPrice = { en_us: en_usi19compareAtPrice, pt_br: pt_bri19compareAtPrice }

export const i19compareProducts = { en_us: en_usi19compareProducts, pt_br: pt_bri19compareProducts }

export const i19comparedPreviousPeriodMsg = { en_us: en_usi19comparedPreviousPeriodMsg, pt_br: pt_bri19comparedPreviousPeriodMsg }

export const i19complement = { en_us: en_usi19complement, pt_br: pt_bri19complement }

export const i19complementInformation = { en_us: en_usi19complementInformation, pt_br: pt_bri19complementInformation }

export const i19connectionErrorMsg = { en_us: en_usi19connectionErrorMsg, pt_br: pt_bri19connectionErrorMsg }

export const i19connectionErrorProductMsg = { en_us: en_usi19connectionErrorProductMsg, pt_br: pt_bri19connectionErrorProductMsg }

export const i19configuration = { en_us: en_usi19configuration, pt_br: pt_bri19configuration }

export const i19confirmPassword = { en_us: en_usi19confirmPassword, pt_br: pt_bri19confirmPassword }

export const i19confirmPurchase = { en_us: en_usi19confirmPurchase, pt_br: pt_bri19confirmPurchase }

export const i19contactPhone = { en_us: en_usi19contactPhone, pt_br: pt_bri19contactPhone }

export const i19contactUsMsg = { en_us: en_usi19contactUsMsg, pt_br: pt_bri19contactUsMsg }

export const i19content = { en_us: en_usi19content, pt_br: pt_bri19content }

export const i19continue = { en_us: en_usi19continue, pt_br: pt_bri19continue }

export const i19continueLoginOnPopup = { en_us: en_usi19continueLoginOnPopup, pt_br: pt_bri19continueLoginOnPopup }

export const i19continueShopping = { en_us: en_usi19continueShopping, pt_br: pt_bri19continueShopping }

export const i19control = { en_us: en_usi19control, pt_br: pt_bri19control }

export const i19copyCode = { en_us: en_usi19copyCode, pt_br: pt_bri19copyCode }

export const i19copyErrorMsg = { en_us: en_usi19copyErrorMsg, pt_br: pt_bri19copyErrorMsg }

export const i19copyright = { en_us: en_usi19copyright, pt_br: pt_bri19copyright }

export const i19corporateName = { en_us: en_usi19corporateName, pt_br: pt_bri19corporateName }

export const i19costDeclaredValue = { en_us: en_usi19costDeclaredValue, pt_br: pt_bri19costDeclaredValue }

export const i19costPrice = { en_us: en_usi19costPrice, pt_br: pt_bri19costPrice }

export const i19countryCode = { en_us: en_usi19countryCode, pt_br: pt_bri19countryCode }

export const i19couponAppliedMsg = { en_us: en_usi19couponAppliedMsg, pt_br: pt_bri19couponAppliedMsg }

export const i19createTransaction = { en_us: en_usi19createTransaction, pt_br: pt_bri19createTransaction }

export const i19creation = { en_us: en_usi19creation, pt_br: pt_bri19creation }

export const i19credit = { en_us: en_usi19credit, pt_br: pt_bri19credit }

export const i19creditCard = { en_us: en_usi19creditCard, pt_br: pt_bri19creditCard }

export const i19creditCardBin = { en_us: en_usi19creditCardBin, pt_br: pt_bri19creditCardBin }

export const i19creditCardCompany = { en_us: en_usi19creditCardCompany, pt_br: pt_bri19creditCardCompany }

export const i19creditCardHolderName = { en_us: en_usi19creditCardHolderName, pt_br: pt_bri19creditCardHolderName }

export const i19creditCardLastDigits = { en_us: en_usi19creditCardLastDigits, pt_br: pt_bri19creditCardLastDigits }

export const i19creditorFees = { en_us: en_usi19creditorFees, pt_br: pt_bri19creditorFees }

export const i19creditorFeesIntermediator = { en_us: en_usi19creditorFeesIntermediator, pt_br: pt_bri19creditorFeesIntermediator }

export const i19creditorFeesOperational = { en_us: en_usi19creditorFeesOperational, pt_br: pt_bri19creditorFeesOperational }

export const i19currencyId = { en_us: en_usi19currencyId, pt_br: pt_bri19currencyId }

export const i19currencySymbol = { en_us: en_usi19currencySymbol, pt_br: pt_bri19currencySymbol }

export const i19custom = { en_us: en_usi19custom, pt_br: pt_bri19custom }

export const i19customer = { en_us: en_usi19customer, pt_br: pt_bri19customer }

export const i19customerNotified = { en_us: en_usi19customerNotified, pt_br: pt_bri19customerNotified }

export const i19customerService = { en_us: en_usi19customerService, pt_br: pt_bri19customerService }

export const i19customFields = { en_us: en_usi19customFields, pt_br: pt_bri19customFields }

export const i19customizationAddToPrice = { en_us: en_usi19customizationAddToPrice, pt_br: pt_bri19customizationAddToPrice }

export const i19customizationAttachment = { en_us: en_usi19customizationAttachment, pt_br: pt_bri19customizationAttachment }

export const i19customizationChosen = { en_us: en_usi19customizationChosen, pt_br: pt_bri19customizationChosen }

export const i19customizations = { en_us: en_usi19customizations, pt_br: pt_bri19customizations }

export const i19customPayment = { en_us: en_usi19customPayment, pt_br: pt_bri19customPayment }

export const i19customValue = { en_us: en_usi19customValue, pt_br: pt_bri19customValue }

export const i19dashboard = { en_us: en_usi19dashboard, pt_br: pt_bri19dashboard }

export const i19dateTime = { en_us: en_usi19dateTime, pt_br: pt_bri19dateTime }

export const i19danger = { en_us: en_usi19danger, pt_br: pt_bri19danger }

export const i19day = { en_us: en_usi19day, pt_br: pt_bri19day }

export const i19dailyAverage = { en_us: en_usi19dailyAverage, pt_br: pt_bri19dailyAverage }

export const i19days = { en_us: en_usi19days, pt_br: pt_bri19days }

export const i19declare = { en_us: en_usi19declare, pt_br: pt_bri19declare }

export const i19declaredValue = { en_us: en_usi19declaredValue, pt_br: pt_bri19declaredValue }

export const i19delete = { en_us: en_usi19delete, pt_br: pt_bri19delete }

export const i19deleteAll = { en_us: en_usi19deleteAll, pt_br: pt_bri19deleteAll }

export const i19delivery = { en_us: en_usi19delivery, pt_br: pt_bri19delivery }

export const i19deliveryCostOwnHandMsg = { en_us: en_usi19deliveryCostOwnHandMsg, pt_br: pt_bri19deliveryCostOwnHandMsg }

export const i19deliveryInMsg = { en_us: en_usi19deliveryInMsg, pt_br: pt_bri19deliveryInMsg }

export const i19deliveryReceipt = { en_us: en_usi19deliveryReceipt, pt_br: pt_bri19deliveryReceipt }

export const i19deliveryReceiptMsg = { en_us: en_usi19deliveryReceiptMsg, pt_br: pt_bri19deliveryReceiptMsg }

export const i19deliveryTrack = { en_us: en_usi19deliveryTrack, pt_br: pt_bri19deliveryTrack }

export const i19deliveryTime = { en_us: en_usi19deliveryTime, pt_br: pt_bri19deliveryTime }

export const i19deliveryWithOwnHandMsg = { en_us: en_usi19deliveryWithOwnHandMsg, pt_br: pt_bri19deliveryWithOwnHandMsg }

export const i19description = { en_us: en_usi19description, pt_br: pt_bri19description }

export const i19desktop = { en_us: en_usi19desktop, pt_br: pt_bri19desktop }

export const i19details = { en_us: en_usi19details, pt_br: pt_bri19details }

export const i19didYouMean = { en_us: en_usi19didYouMean, pt_br: pt_bri19didYouMean }

export const i19digits = { en_us: en_usi19digits, pt_br: pt_bri19digits }

export const i19directLinkPayment = { en_us: en_usi19directLinkPayment, pt_br: pt_bri19directLinkPayment }

export const i19disable = { en_us: en_usi19disable, pt_br: pt_bri19disable }

export const i19discount = { en_us: en_usi19discount, pt_br: pt_bri19discount }

export const i19discountCoupon = { en_us: en_usi19discountCoupon, pt_br: pt_bri19discountCoupon }

export const i19discountOf = { en_us: en_usi19discountOf, pt_br: pt_bri19discountOf }

export const i19discountValueMsg = { en_us: en_usi19discountValueMsg, pt_br: pt_bri19discountValueMsg }

export const i19displayName = { en_us: en_usi19displayName, pt_br: pt_bri19displayName }

export const i19docCountry = { en_us: en_usi19docCountry, pt_br: pt_bri19docCountry }

export const i19docNumber = { en_us: en_usi19docNumber, pt_br: pt_bri19docNumber }

export const i19docs = { en_us: en_usi19docs, pt_br: pt_bri19docs }

export const i19domain = { en_us: en_usi19domain, pt_br: pt_bri19domain }

export const i19doPaymentMsg = { en_us: en_usi19doPaymentMsg, pt_br: pt_bri19doPaymentMsg }

export const i19doYouWantToDeleteAppQn = { en_us: en_usi19doYouWantToDeleteAppQn, pt_br: pt_bri19doYouWantToDeleteAppQn }

export const i19doYouWantToReinstallAppQn = { en_us: en_usi19doYouWantToReinstallAppQn, pt_br: pt_bri19doYouWantToReinstallAppQn }

export const i19download = { en_us: en_usi19download, pt_br: pt_bri19download }

export const i19downloadTable = { en_us: en_usi19downloadTable, pt_br: pt_bri19downloadTable }

export const i19edit = { en_us: en_usi19edit, pt_br: pt_bri19edit }

export const i19editing = { en_us: en_usi19editing, pt_br: pt_bri19editing }

export const i19editAdditionalCost = { en_us: en_usi19editAdditionalCost, pt_br: pt_bri19editAdditionalCost }

export const i19editComments = { en_us: en_usi19editComments, pt_br: pt_bri19editComments }

export const i19editDispatchAndFulfillment = { en_us: en_usi19editDispatchAndFulfillment, pt_br: pt_bri19editDispatchAndFulfillment }

export const i19editFeatures = { en_us: en_usi19editFeatures, pt_br: pt_bri19editFeatures }

export const i19editFilters = { en_us: en_usi19editFilters, pt_br: pt_bri19editFilters }

export const i19editGtinMpn = { en_us: en_usi19editGtinMpn, pt_br: pt_bri19editGtinMpn }

export const i19editHtmlDescription = { en_us: en_usi19editHtmlDescription, pt_br: pt_bri19editHtmlDescription }

export const i19editObservationInfo = { en_us: en_usi19editObservationInfo, pt_br: pt_bri19editObservationInfo }

export const i19editPaymentDetails = { en_us: en_usi19editPaymentDetails, pt_br: pt_bri19editPaymentDetails }

export const i19editProductDimensions = { en_us: en_usi19editProductDimensions, pt_br: pt_bri19editProductDimensions }

export const i19editSeoFields = { en_us: en_usi19editSeoFields, pt_br: pt_bri19editSeoFields }

export const i19editStorefront = { en_us: en_usi19editStorefront, pt_br: pt_bri19editStorefront }

export const i19editVariation = { en_us: en_usi19editVariation, pt_br: pt_bri19editVariation }

export const i19email = { en_us: en_usi19email, pt_br: pt_bri19email }

export const i19emailAddress = { en_us: en_usi19emailAddress, pt_br: pt_bri19emailAddress }

export const i19emailCartTextMsg = { en_us: en_usi19emailCartTextMsg, pt_br: pt_bri19emailCartTextMsg }

export const i19emailCartTitleMsg = { en_us: en_usi19emailCartTitleMsg, pt_br: pt_bri19emailCartTitleMsg }

export const i19emailDeliveredTextMsg = { en_us: en_usi19emailDeliveredTextMsg, pt_br: pt_bri19emailDeliveredTextMsg }

export const i19emailDeliveredTitleMsg = { en_us: en_usi19emailDeliveredTitleMsg, pt_br: pt_bri19emailDeliveredTitleMsg }

export const i19emailInfoMsg = { en_us: en_usi19emailInfoMsg, pt_br: pt_bri19emailInfoMsg }

export const i19emailMarketing = { en_us: en_usi19emailMarketing, pt_br: pt_bri19emailMarketing }

export const i19emailMarketingOptInMsg = { en_us: en_usi19emailMarketingOptInMsg, pt_br: pt_bri19emailMarketingOptInMsg }

export const i19emailProfileNotFound = { en_us: en_usi19emailProfileNotFound }

export const i19emails = { en_us: en_usi19emails, pt_br: pt_bri19emails }

export const i19emailShippedTextMsg = { en_us: en_usi19emailShippedTextMsg, pt_br: pt_bri19emailShippedTextMsg }

export const i19emailShippedTitleMsg = { en_us: en_usi19emailShippedTitleMsg, pt_br: pt_bri19emailShippedTitleMsg }

export const i19empty = { en_us: en_usi19empty, pt_br: pt_bri19empty }

export const i19emptyCart = { en_us: en_usi19emptyCart, pt_br: pt_bri19emptyCart }

export const i19emptyCartMsg = { en_us: en_usi19emptyCartMsg, pt_br: pt_bri19emptyCartMsg }

export const i19enabled = { en_us: en_usi19enabled, pt_br: pt_bri19enabled }

export const i19end = { en_us: en_usi19end, pt_br: pt_bri19end }

export const i19endDate = { en_us: en_usi19endDate, pt_br: pt_bri19endDate }

export const i19endpoint = { en_us: en_usi19endpoint, pt_br: pt_bri19endpoint }

export const i19endsIn = { en_us: en_usi19endsIn, pt_br: pt_bri19endsIn }

export const i19enterEmailCodeMsg = { en_us: en_usi19enterEmailCodeMsg, pt_br: pt_bri19enterEmailCodeMsg }

export const i19enterYourDocNumber = { en_us: en_usi19enterYourDocNumber, pt_br: pt_bri19enterYourDocNumber }

export const i19enterYourDocNumberMsg = { en_us: en_usi19enterYourDocNumberMsg, pt_br: pt_bri19enterYourDocNumberMsg }

export const i19enterYourEmail = { en_us: en_usi19enterYourEmail, pt_br: pt_bri19enterYourEmail }

export const i19enterYourEmailMsg = { en_us: en_usi19enterYourEmailMsg, pt_br: pt_bri19enterYourEmailMsg }

export const i19erp = { en_us: en_usi19erp, pt_br: pt_bri19erp }

export const i19error = { en_us: en_usi19error, pt_br: pt_bri19error }

export const i19errorMsg = { en_us: en_usi19errorMsg, pt_br: pt_bri19errorMsg }

export const i19events = { en_us: en_usi19events, pt_br: pt_bri19events }

export const i19export = { en_us: en_usi19export, pt_br: pt_bri19export }

export const i19exportToCsv = { en_us: en_usi19exportToCsv, pt_br: pt_bri19exportToCsv }

export const i19extra = { en_us: en_usi19extra, pt_br: pt_bri19extra }

export const i19extraCost = { en_us: en_usi19extraCost, pt_br: pt_bri19extraCost }

export const i19external = { en_us: en_usi19external, pt_br: pt_bri19external }

export const i19familyName = { en_us: en_usi19familyName, pt_br: pt_bri19familyName }

export const i19favorites = { en_us: en_usi19favorites, pt_br: pt_bri19favorites }

export const i19featuredApps = { en_us: en_usi19featuredApps, pt_br: pt_bri19featuredApps }

export const i19female = { en_us: en_usi19female, pt_br: pt_bri19female }

export const i19field = { en_us: en_usi19field, pt_br: pt_bri19field }

export const i19files = { en_us: en_usi19files, pt_br: pt_bri19files }

export const i19filter = { en_us: en_usi19filter, pt_br: pt_bri19filter }

export const i19filterProducts = { en_us: en_usi19filterProducts, pt_br: pt_bri19filterProducts }

export const i19filterResults = { en_us: en_usi19filterResults, pt_br: pt_bri19filterResults }

export const i19finalPrice = { en_us: en_usi19finalPrice, pt_br: pt_bri19finalPrice }

export const i19finalPriceWithAdditional = { en_us: en_usi19finalPriceWithAdditional, pt_br: pt_bri19finalPriceWithAdditional }

export const i19financialStatus = { en_us: en_usi19financialStatus, pt_br: pt_bri19financialStatus }

export const i19firstSteps = { en_us: en_usi19firstSteps, pt_br: pt_bri19firstSteps }

export const i19followingAddress = { en_us: en_usi19followingAddress, pt_br: pt_bri19followingAddress }

export const i19for = { en_us: en_usi19for, pt_br: pt_bri19for }

export const i19free = { en_us: en_usi19free, pt_br: pt_bri19free }

export const i19freebie = { en_us: en_usi19freebie, pt_br: pt_bri19freebie }

export const i19freeShipping = { en_us: en_usi19freeShipping, pt_br: pt_bri19freeShipping }

export const i19freeShippingFrom = { en_us: en_usi19freeShippingFrom, pt_br: pt_bri19freeShippingFrom }

export const i19freight = { en_us: en_usi19freight, pt_br: pt_bri19freight }

export const i19freightCost = { en_us: en_usi19freightCost, pt_br: pt_bri19freightCost }

export const i19from = { en_us: en_usi19from, pt_br: pt_bri19from }

export const i19fulfillmentStatus = { en_us: en_usi19fulfillmentStatus, pt_br: pt_bri19fulfillmentStatus }

export const i19fullName = { en_us: en_usi19fullName, pt_br: pt_bri19fullName }

export const i19fullscreen = { en_us: en_usi19fullscreen, pt_br: pt_bri19fullscreen }

export const i19gateway = { en_us: en_usi19gateway, pt_br: pt_bri19gateway }

export const i19gender = { en_us: en_usi19gender, pt_br: pt_bri19gender }

export const i19genderX = { en_us: en_usi19genderX, pt_br: pt_bri19genderX }

export const i19general = { en_us: en_usi19general, pt_br: pt_bri19general }

export const i19generateBillet = { en_us: en_usi19generateBillet, pt_br: pt_bri19generateBillet }

export const i19get = { en_us: en_usi19get, pt_br: pt_bri19get }

export const i19giftList = { en_us: en_usi19giftList, pt_br: pt_bri19giftList }

export const i19giftListAuthors = { en_us: en_usi19giftListAuthors, pt_br: pt_bri19giftListAuthors }

export const i19giftListAuthorsContact = { en_us: en_usi19giftListAuthorsContact, pt_br: pt_bri19giftListAuthorsContact }

export const i19giftListDescription = { en_us: en_usi19giftListDescription, pt_br: pt_bri19giftListDescription }

export const i19giftListEventDate = { en_us: en_usi19giftListEventDate, pt_br: pt_bri19giftListEventDate }

export const i19giftListInformation = { en_us: en_usi19giftListInformation, pt_br: pt_bri19giftListInformation }

export const i19giftListNotificationPurchaseMsg = { en_us: en_usi19giftListNotificationPurchaseMsg, pt_br: pt_bri19giftListNotificationPurchaseMsg }

export const i19giftListPermalink = { en_us: en_usi19giftListPermalink, pt_br: pt_bri19giftListPermalink }

export const i19giftListTitle = { en_us: en_usi19giftListTitle, pt_br: pt_bri19giftListTitle }

export const i19giftListValidThru = { en_us: en_usi19giftListValidThru, pt_br: pt_bri19giftListValidThru }

export const i19giftListOwnerID = { en_us: en_usi19giftListOwnerID, pt_br: pt_bri19giftListOwnerID }

export const i19giftListWaiting = { en_us: en_usi19giftListWaiting, pt_br: pt_bri19giftListWaiting }

export const i19giftTo = { en_us: en_usi19giftTo, pt_br: pt_bri19giftTo }

export const i19giftWrap = { en_us: en_usi19giftWrap, pt_br: pt_bri19giftWrap }

export const i19gitRepository = { en_us: en_usi19gitRepository, pt_br: pt_bri19gitRepository }

export const i19givenName = { en_us: en_usi19givenName, pt_br: pt_bri19givenName }

export const i19goToCart = { en_us: en_usi19goToCart, pt_br: pt_bri19goToCart }

export const i19goToStore = { en_us: en_usi19goToStore, pt_br: pt_bri19goToStore }

export const i19goToTop = { en_us: en_usi19goToTop, pt_br: pt_bri19goToTop }

export const i19googleAnalytics = { en_us: en_usi19googleAnalytics, pt_br: pt_bri19googleAnalytics }

export const i19googleProductCategoryId = { en_us: en_usi19googleProductCategoryId, pt_br: pt_bri19googleProductCategoryId }

export const i19gridId = { en_us: en_usi19gridId, pt_br: pt_bri19gridId }

export const i19grids = { en_us: en_usi19grids, pt_br: pt_bri19grids }

export const i19gridName = { en_us: en_usi19gridName, pt_br: pt_bri19gridName }

export const i19guestCheckoutMsg = { en_us: en_usi19guestCheckoutMsg, pt_br: pt_bri19guestCheckoutMsg }

export const i19hasCouponOrVoucherQn = { en_us: en_usi19hasCouponOrVoucherQn, pt_br: pt_bri19hasCouponOrVoucherQn }

export const i19height = { en_us: en_usi19height, pt_br: pt_bri19height }

export const i19hello = { en_us: en_usi19hello, pt_br: pt_bri19hello }

export const i19helloAgain = { en_us: en_usi19helloAgain, pt_br: pt_bri19helloAgain }

export const i19help = { en_us: en_usi19help, pt_br: pt_bri19help }

export const i19helpful = { en_us: en_usi19helpful, pt_br: pt_bri19helpful }

export const i19high = { en_us: en_usi19high, pt_br: pt_bri19high }

export const i19highestPrice = { en_us: en_usi19highestPrice, pt_br: pt_bri19highestPrice }

export const i19highPriority = { en_us: en_usi19highPriority, pt_br: pt_bri19highPriority }

export const i19holderName = { en_us: en_usi19holderName, pt_br: pt_bri19holderName }

export const i19home = { en_us: en_usi19home, pt_br: pt_bri19home }

export const i19icon = { en_us: en_usi19icon, pt_br: pt_bri19icon }

export const i19id = { en_us: en_usi19id, pt_br: pt_bri19id }

export const i19identification = { en_us: en_usi19identification, pt_br: pt_bri19identification }

export const i19identifyYourAccount = { en_us: en_usi19identifyYourAccount, pt_br: pt_bri19identifyYourAccount }

export const i19idOfShippingLine = { en_us: en_usi19idOfShippingLine }

export const i19image = { en_us: en_usi19image, pt_br: pt_bri19image }

export const i19images = { en_us: en_usi19images, pt_br: pt_bri19images }

export const i19import = { en_us: en_usi19import, pt_br: pt_bri19import }

export const i19in = { en_us: en_usi19in, pt_br: pt_bri19in }

export const i19inactive = { en_us: en_usi19inactive, pt_br: pt_bri19inactive }

export const i19incorrect = { en_us: en_usi19incorrect, pt_br: pt_bri19incorrect }

export const i19incorrectFormat = { en_us: en_usi19incorrectFormat, pt_br: pt_bri19incorrectFormat }

export const i19incorrectEmailCodeMsg = { en_us: en_usi19incorrectEmailCodeMsg, pt_br: pt_bri19incorrectEmailCodeMsg }

export const i19info = { en_us: en_usi19info, pt_br: pt_bri19info }

export const i19inscriptionNumber = { en_us: en_usi19inscriptionNumber, pt_br: pt_bri19inscriptionNumber }

export const i19insert = { en_us: en_usi19insert, pt_br: pt_bri19insert }

export const i19install = { en_us: en_usi19install, pt_br: pt_bri19install }

export const i19installed = { en_us: en_usi19installed, pt_br: pt_bri19installed }

export const i19installedApps = { en_us: en_usi19installedApps, pt_br: pt_bri19installedApps }

export const i19installingApp = { en_us: en_usi19installingApp, pt_br: pt_bri19installingApp }

export const i19installment = { en_us: en_usi19installment, pt_br: pt_bri19installment }

export const i19installments = { en_us: en_usi19installments, pt_br: pt_bri19installments }

export const i19installNow = { en_us: en_usi19installNow, pt_br: pt_bri19installNow }

export const i19inStock = { en_us: en_usi19inStock, pt_br: pt_bri19inStock }

export const i19inStockAt = { en_us: en_usi19inStockAt, pt_br: pt_bri19inStockAt }

export const i19interestFree = { en_us: en_usi19interestFree, pt_br: pt_bri19interestFree }

export const i19intermediator = { en_us: en_usi19intermediator, pt_br: pt_bri19intermediator }

export const i19invalidCard = { en_us: en_usi19invalidCard, pt_br: pt_bri19invalidCard }

export const i19invalidCardMsg = { en_us: en_usi19invalidCardMsg, pt_br: pt_bri19invalidCardMsg }

export const i19invalidCouponMsg = { en_us: en_usi19invalidCouponMsg, pt_br: pt_bri19invalidCouponMsg }

export const i19invalidDomainName = { en_us: en_usi19invalidDomainName, pt_br: pt_bri19invalidDomainName }

export const i19invalidLoginInfoMsg = { en_us: en_usi19invalidLoginInfoMsg, pt_br: pt_bri19invalidLoginInfoMsg }

export const i19inventory = { en_us: en_usi19inventory, pt_br: pt_bri19inventory }

export const i19inventoryHistory = { en_us: en_usi19inventoryHistory, pt_br: pt_bri19inventoryHistory }

export const i19invoice = { en_us: en_usi19invoice, pt_br: pt_bri19invoice }

export const i19invoices = { en_us: en_usi19invoices, pt_br: pt_bri19invoices }

export const i19iReadAndAccept = { en_us: en_usi19iReadAndAccept, pt_br: pt_bri19iReadAndAccept }

export const i19isFilter = { en_us: en_usi19isFilter, pt_br: pt_bri19isFilter }

export const i19isNotYou = { en_us: en_usi19isNotYou, pt_br: pt_bri19isNotYou }

export const i19item = { en_us: en_usi19item, pt_br: pt_bri19item }

export const i19items = { en_us: en_usi19items, pt_br: pt_bri19items }

export const i19itemsFound = { en_us: en_usi19itemsFound, pt_br: pt_bri19itemsFound }

export const i19jurifical = { en_us: en_usi19jurifical, pt_br: pt_bri19jurifical }

export const i19just = { en_us: en_usi19just, pt_br: pt_bri19just }

export const i19keywords = { en_us: en_usi19keywords, pt_br: pt_bri19keywords }

export const i19kit = { en_us: en_usi19kit, pt_br: pt_bri19kit }

export const i19label = { en_us: en_usi19label, pt_br: pt_bri19label }

export const i19LabelOfCustomization = { en_us: en_usi19LabelOfCustomization, pt_br: pt_bri19LabelOfCustomization }

export const i19last = { en_us: en_usi19last, pt_br: pt_bri19last }

export const i19lastOptions = { en_us: en_usi19lastOptions, pt_br: pt_bri19lastOptions }

export const i19lastPurchase = { en_us: en_usi19lastPurchase, pt_br: pt_bri19lastPurchase }

export const i19lastSearchedTerms = { en_us: en_usi19lastSearchedTerms, pt_br: pt_bri19lastSearchedTerms }

export const i19lastVisitedProducts = { en_us: en_usi19lastVisitedProducts, pt_br: pt_bri19lastVisitedProducts }

export const i19latestOrders = { en_us: en_usi19latestOrders, pt_br: pt_bri19latestOrders }

export const i19launch = { en_us: en_usi19launch, pt_br: pt_bri19launch }

export const i19launching = { en_us: en_usi19launching, pt_br: pt_bri19launching }

export const i19length = { en_us: en_usi19length, pt_br: pt_bri19length }

export const i19lineAddress = { en_us: en_usi19lineAddress, pt_br: pt_bri19lineAddress }

export const i19list = { en_us: en_usi19list, pt_br: pt_bri19list }

export const i19listOfInvoices = { en_us: en_usi19listOfInvoices, pt_br: pt_bri19listOfInvoices }

export const i19listOfPayments = { en_us: en_usi19listOfPayments, pt_br: pt_bri19listOfPayments }

export const i19listSubscriptionInvoices = { en_us: en_usi19listSubscriptionInvoices, pt_br: pt_bri19listSubscriptionInvoices }

export const i19load = { en_us: en_usi19load, pt_br: pt_bri19load }

export const i19loadMore = { en_us: en_usi19loadMore, pt_br: pt_bri19loadMore }

export const i19loading = { en_us: en_usi19loading, pt_br: pt_bri19loading }

export const i19loadDataErrorMsg = { en_us: en_usi19loadDataErrorMsg, pt_br: pt_bri19loadDataErrorMsg }

export const i19loadProductErrorMsg = { en_us: en_usi19loadProductErrorMsg, pt_br: pt_bri19loadProductErrorMsg }

export const i19locale = { en_us: en_usi19locale, pt_br: pt_bri19locale }

export const i19login = { en_us: en_usi19login, pt_br: pt_bri19login }

export const i19loginEnabled = { en_us: en_usi19loginEnabled, pt_br: pt_bri19loginEnabled }

export const i19loginErrorMsg = { en_us: en_usi19loginErrorMsg, pt_br: pt_bri19loginErrorMsg }

export const i19loginForOrderDetailsMsg = { en_us: en_usi19loginForOrderDetailsMsg, pt_br: pt_bri19loginForOrderDetailsMsg }

export const i19logo = { en_us: en_usi19logo, pt_br: pt_bri19logo }

export const i19logout = { en_us: en_usi19logout, pt_br: pt_bri19logout }

export const i19low = { en_us: en_usi19low, pt_br: pt_bri19low }

export const i19lowestPrice = { en_us: en_usi19lowestPrice, pt_br: pt_bri19lowestPrice }

export const i19loyaltyPoints = { en_us: en_usi19loyaltyPoints, pt_br: pt_bri19loyaltyPoints }

export const i19loyaltyPointsName = { en_us: en_usi19loyaltyPointsName, pt_br: pt_bri19loyaltyPointsName }

export const i19loyaltyPointsPointsValue = { en_us: en_usi19loyaltyPointsPointsValue, pt_br: pt_bri19loyaltyPointsPointsValue }

export const i19madeBy = { en_us: en_usi19madeBy, pt_br: pt_bri19madeBy }

export const i19mainEmail = { en_us: en_usi19mainEmail, pt_br: pt_bri19mainEmail }

export const i19male = { en_us: en_usi19male, pt_br: pt_bri19male }

export const i19manageStock = { en_us: en_usi19manageStock, pt_br: pt_bri19manageStock }

export const i19manageYourPurchaseHistory = { en_us: en_usi19manageYourPurchaseHistory, pt_br: pt_bri19manageYourPurchaseHistory }

export const i19marketing = { en_us: en_usi19marketing, pt_br: pt_bri19marketing }

export const i19marketplace = { en_us: en_usi19marketplace, pt_br: pt_bri19marketplace }

export const i19marketplaces = { en_us: en_usi19marketplaces, pt_br: pt_bri19marketplaces }

export const i19massEdit = { en_us: en_usi19massEdit, pt_br: pt_bri19massEdit }

export const i19maximum = { en_us: en_usi19maximum, pt_br: pt_bri19maximum }

export const i19maxQuantity = { en_us: en_usi19maxQuantity, pt_br: pt_bri19maxQuantity }

export const i19measurement = { en_us: en_usi19measurement, pt_br: pt_bri19measurement }

export const i19media = { en_us: en_usi19media, pt_br: pt_bri19media }

export const i19mediaGallery = { en_us: en_usi19mediaGallery, pt_br: pt_bri19mediaGallery }

export const i19menu = { en_us: en_usi19menu, pt_br: pt_bri19menu }

export const i19metafields = { en_us: en_usi19metafields, pt_br: pt_bri19metafields }

export const i19metafieldsMsg = { en_us: en_usi19metafieldsMsg, pt_br: pt_bri19metafieldsMsg }

export const i19metaTagDescription = { en_us: en_usi19metaTagDescription, pt_br: pt_bri19metaTagDescription }

export const i19middleName = { en_us: en_usi19middleName, pt_br: pt_bri19middleName }

export const i19minimum = { en_us: en_usi19minimum, pt_br: pt_bri19minimum }

export const i19minQuantity = { en_us: en_usi19minQuantity, pt_br: pt_bri19minQuantity }

export const i19mlCategoryId = { en_us: en_usi19mlCategoryId, pt_br: pt_bri19mlCategoryId }

export const i19mobile = { en_us: en_usi19mobile, pt_br: pt_bri19mobile }

export const i19mobileLink = { en_us: en_usi19mobileLink, pt_br: pt_bri19mobileLink }

export const i19modules = { en_us: en_usi19modules, pt_br: pt_bri19modules }

export const i19month = { en_us: en_usi19month, pt_br: pt_bri19month }

export const i19monthly = { en_us: en_usi19monthly, pt_br: pt_bri19monthly }

export const i19mostPopular = { en_us: en_usi19mostPopular, pt_br: pt_bri19mostPopular }

export const i19mostRelevant = { en_us: en_usi19mostRelevant, pt_br: pt_bri19mostRelevant }

export const i19motorcycleCourier = { en_us: en_usi19motorcycleCourier, pt_br: pt_bri19motorcycleCourier }

export const i19myAccount = { en_us: en_usi19myAccount, pt_br: pt_bri19myAccount }

export const i19myAccountAndOrders = { en_us: en_usi19myAccountAndOrders, pt_br: pt_bri19myAccountAndOrders }

export const i19myCart = { en_us: en_usi19myCart, pt_br: pt_bri19myCart }

export const i19myFavorites = { en_us: en_usi19myFavorites, pt_br: pt_bri19myFavorites }

export const i19myOrders = { en_us: en_usi19myOrders, pt_br: pt_bri19myOrders }

export const i19myShoppingCart = { en_us: en_usi19myShoppingCart, pt_br: pt_bri19myShoppingCart }

export const i19name = { en_us: en_usi19name, pt_br: pt_bri19name }

export const i19nameOnCard = { en_us: en_usi19nameOnCard, pt_br: pt_bri19nameOnCard }

export const i19namespace = { en_us: en_usi19namespace, pt_br: pt_bri19namespace }

export const i19namespaceMsg = { en_us: en_usi19namespaceMsg, pt_br: pt_bri19namespaceMsg }

export const i19nearTo = { en_us: en_usi19nearTo, pt_br: pt_bri19nearTo }

export const i19needHelpQn = { en_us: en_usi19needHelpQn, pt_br: pt_bri19needHelpQn }

export const i19new = { en_us: en_usi19new, pt_br: pt_bri19new }

export const i19newAddress = { en_us: en_usi19newAddress, pt_br: pt_bri19newAddress }

export const i19newOrders = { en_us: en_usi19newOrders, pt_br: pt_bri19newOrders }

export const i19newPassword = { en_us: en_usi19newPassword, pt_br: pt_bri19newPassword }

export const i19newPriceRange = { en_us: en_usi19newPriceRange, pt_br: pt_bri19newPriceRange }

export const i19newsletter = { en_us: en_usi19newsletter, pt_br: pt_bri19newsletter }

export const i19newsletterReport = { en_us: en_usi19newsletterReport, pt_br: pt_bri19newsletterReport }

export const i19newVersionAvailableMsg = { en_us: en_usi19newVersionAvailableMsg, pt_br: pt_bri19newVersionAvailableMsg }

export const i19next = { en_us: en_usi19next, pt_br: pt_bri19next }

export const i19nickname = { en_us: en_usi19nickname, pt_br: pt_bri19nickname }

export const i19no = { en_us: en_usi19no, pt_br: pt_bri19no }

export const i19noAdditional = { en_us: en_usi19noAdditional, pt_br: pt_bri19noAdditional }

export const i19noAppsAvailable = { en_us: en_usi19noAppsAvailable, pt_br: pt_bri19noAppsAvailable }

export const i19noBrand = { en_us: en_usi19noBrand, pt_br: pt_bri19noBrand }

export const i19noCategory = { en_us: en_usi19noCategory, pt_br: pt_bri19noCategory }

export const i19noCollection = { en_us: en_usi19noCollection, pt_br: pt_bri19noCollection }

export const i19noGrid = { en_us: en_usi19noGrid, pt_br: pt_bri19noGrid }

export const i19noItemSelected = { en_us: en_usi19noItemSelected, pt_br: pt_bri19noItemSelected }

export const i19noNewOrdersMsg = { en_us: en_usi19noNewOrdersMsg, pt_br: pt_bri19noNewOrdersMsg }

export const i19noNumber = { en_us: en_usi19noNumber, pt_br: pt_bri19noNumber }

export const i19noOrder = { en_us: en_usi19noOrder, pt_br: pt_bri19noOrder }

export const i19noPrice = { en_us: en_usi19noPrice, pt_br: pt_bri19noPrice }

export const i19noProduct = { en_us: en_usi19noProduct, pt_br: pt_bri19noProduct }

export const i19noProfileFoundWithEmail = { en_us: en_usi19noProfileFoundWithEmail, pt_br: pt_bri19noProfileFoundWithEmail }

export const i19noResultsFor = { en_us: en_usi19noResultsFor, pt_br: pt_bri19noResultsFor }

export const i19normal = { en_us: en_usi19normal, pt_br: pt_bri19normal }

export const i19noSavedFavoritesMsg = { en_us: en_usi19noSavedFavoritesMsg, pt_br: pt_bri19noSavedFavoritesMsg }

export const i19notConfigured = { en_us: en_usi19notConfigured, pt_br: pt_bri19notConfigured }

export const i19notFound = { en_us: en_usi19notFound, pt_br: pt_bri19notFound }

export const i19notifications = { en_us: en_usi19notifications, pt_br: pt_bri19notifications }

export const i19notified = { en_us: en_usi19notified, pt_br: pt_bri19notified }

export const i19notifiedAdmins = { en_us: en_usi19notifiedAdmins, pt_br: pt_bri19notifiedAdmins }

export const i19notifiedAdminsMsg = { en_us: en_usi19notifiedAdminsMsg, pt_br: pt_bri19notifiedAdminsMsg }

export const i19notifyAboutOrders = { en_us: en_usi19notifyAboutOrders, pt_br: pt_bri19notifyAboutOrders }

export const i19notes = { en_us: en_usi19notes, pt_br: pt_bri19notes }

export const i19noUser = { en_us: en_usi19noUser, pt_br: pt_bri19noUser }

export const i19number = { en_us: en_usi19number, pt_br: pt_bri19number }

export const i19oauthOnPopup = { en_us: en_usi19oauthOnPopup, pt_br: pt_bri19oauthOnPopup }

export const i19of = { en_us: en_usi19of, pt_br: pt_bri19of }

export const i19ofDiscount = { en_us: en_usi19ofDiscount, pt_br: pt_bri19ofDiscount }

export const i19offer = { en_us: en_usi19offer, pt_br: pt_bri19offer }

export const i19on = { en_us: en_usi19on, pt_br: pt_bri19on }

export const i19onFreight = { en_us: en_usi19onFreight, pt_br: pt_bri19onFreight }

export const i19onFollowingAddress = { en_us: en_usi19onFollowingAddress, pt_br: pt_bri19onFollowingAddress }

export const i19only = { en_us: en_usi19only, pt_br: pt_bri19only }

export const i19open = { en_us: en_usi19open, pt_br: pt_bri19open }

export const i19openAt = { en_us: en_usi19openAt, pt_br: pt_bri19openAt }

export const i19openCart = { en_us: en_usi19openCart, pt_br: pt_bri19openCart }

export const i19openGallery = { en_us: en_usi19openGallery, pt_br: pt_bri19openGallery }

export const i19operational = { en_us: en_usi19operational, pt_br: pt_bri19operational }

export const i19option = { en_us: en_usi19option, pt_br: pt_bri19option }

export const i19optionChosen = { en_us: en_usi19optionChosen, pt_br: pt_bri19optionChosen }

export const i19options = { en_us: en_usi19options, pt_br: pt_bri19options }

export const i19or = { en_us: en_usi19or, pt_br: pt_bri19or }

export const i19order = { en_us: en_usi19order, pt_br: pt_bri19order }

export const i19orderDetails = { en_us: en_usi19orderDetails, pt_br: pt_bri19orderDetails }

export const i19orders = { en_us: en_usi19orders, pt_br: pt_bri19orders }

export const i19orderCreated = { en_us: en_usi19orderCreated, pt_br: pt_bri19orderCreated }

export const i19orderConfirmationMsg = { en_us: en_usi19orderConfirmationMsg, pt_br: pt_bri19orderConfirmationMsg }

export const i19ordersCount = { en_us: en_usi19ordersCount, pt_br: pt_bri19ordersCount }

export const i19orderCode = { en_us: en_usi19orderCode, pt_br: pt_bri19orderCode }

export const i19orderItems = { en_us: en_usi19orderItems, pt_br: pt_bri19orderItems }

export const i19orderNotesInputMsg = { en_us: en_usi19orderNotesInputMsg, pt_br: pt_bri19orderNotesInputMsg }

export const i19orderNumber = { en_us: en_usi19orderNumber, pt_br: pt_bri19orderNumber }

export const i19orderObservations = { en_us: en_usi19orderObservations, pt_br: pt_bri19orderObservations }

export const i19orderStatus = { en_us: en_usi19orderStatus, pt_br: pt_bri19orderStatus }

export const i19orderValue = { en_us: en_usi19orderValue, pt_br: pt_bri19orderValue }

export const i19ordersTotalValue = { en_us: en_usi19ordersTotalValue, pt_br: pt_bri19ordersTotalValue }

export const i19organization = { en_us: en_usi19organization, pt_br: pt_bri19organization }

export const i19orProceedWith = { en_us: en_usi19orProceedWith, pt_br: pt_bri19orProceedWith }

export const i19otherCustomers = { en_us: en_usi19otherCustomers, pt_br: pt_bri19otherCustomers }

export const i19otherCustomersMsg = { en_us: en_usi19otherCustomersMsg, pt_br: pt_bri19otherCustomersMsg }

export const i19outOfDate = { en_us: en_usi19outOfDate, pt_br: pt_bri19outOfDate }

export const i19outOfStock = { en_us: en_usi19outOfStock, pt_br: pt_bri19outOfStock }

export const i19ownDelivery = { en_us: en_usi19ownDelivery, pt_br: pt_bri19ownDelivery }

export const i19ownHand = { en_us: en_usi19ownHand, pt_br: pt_bri19ownHand }

export const i19ownHandCost = { en_us: en_usi19ownHandCost, pt_br: pt_bri19ownHandCost }

export const i19package = { en_us: en_usi19package, pt_br: pt_bri19package }

export const i19packageInformation = { en_us: en_usi19packageInformation, pt_br: pt_bri19packageInformation }

export const i19packageDimensions = { en_us: en_usi19packageDimensions, pt_br: pt_bri19packageDimensions }

export const i19packageDimensionsInformation = { en_us: en_usi19packageDimensionsInformation, pt_br: pt_bri19packageDimensionsInformation }

export const i19packageWeight = { en_us: en_usi19packageWeight, pt_br: pt_bri19packageWeight }

export const i19pageLoaded = { en_us: en_usi19pageLoaded, pt_br: pt_bri19pageLoaded }

export const i19paid = { en_us: en_usi19paid, pt_br: pt_bri19paid }

export const i19paidTextMsg = { en_us: en_usi19paidTextMsg, pt_br: pt_bri19paidTextMsg }

export const i19parcelIn = { en_us: en_usi19parcelIn, pt_br: pt_bri19parcelIn }

export const i19parentCategory = { en_us: en_usi19parentCategory, pt_br: pt_bri19parentCategory }

export const i19partner = { en_us: en_usi19partner, pt_br: pt_bri19partner }

export const i19partners = { en_us: en_usi19partners, pt_br: pt_bri19partners }

export const i19partnersProgram = { en_us: en_usi19partnersProgram, pt_br: pt_bri19partnersProgram }

export const i19passwordChangedSuccessfully = { en_us: en_usi19passwordChangedSuccessfully, pt_br: pt_bri19passwordChangedSuccessfully }

export const i19patch = { en_us: en_usi19patch, pt_br: pt_bri19patch }

export const i19payer = { en_us: en_usi19payer, pt_br: pt_bri19payer }

export const i19payment = { en_us: en_usi19payment, pt_br: pt_bri19payment }

export const i19paymentConfirmed = { en_us: en_usi19paymentConfirmed, pt_br: pt_bri19paymentConfirmed }

export const i19paymentDetails = { en_us: en_usi19paymentDetails, pt_br: pt_bri19paymentDetails }

export const i19paymentError = { en_us: en_usi19paymentError, pt_br: pt_bri19paymentError }

export const i19paymentErrorMsg = { en_us: en_usi19paymentErrorMsg, pt_br: pt_bri19paymentErrorMsg }

export const i19paymentLink = { en_us: en_usi19paymentLink, pt_br: pt_bri19paymentLink }

export const i19paymentMethod = { en_us: en_usi19paymentMethod, pt_br: pt_bri19paymentMethod }

export const i19paymentMethods = { en_us: en_usi19paymentMethods, pt_br: pt_bri19paymentMethods }

export const i19paymentMethodLabel = { en_us: en_usi19paymentMethodLabel, pt_br: pt_bri19paymentMethodLabel }

export const i19paymentOptions = { en_us: en_usi19paymentOptions, pt_br: pt_bri19paymentOptions }

export const i19paymentRealized = { en_us: en_usi19paymentRealized, pt_br: pt_bri19paymentRealized }

export const i19personalRegistration = { en_us: en_usi19personalRegistration, pt_br: pt_bri19personalRegistration }

export const i19permalink = { en_us: en_usi19permalink, pt_br: pt_bri19permalink }

export const i19perUnit = { en_us: en_usi19perUnit, pt_br: pt_bri19perUnit }

export const i19phone = { en_us: en_usi19phone, pt_br: pt_bri19phone }

export const i19phones = { en_us: en_usi19phones, pt_br: pt_bri19phones }

export const i19photo = { en_us: en_usi19photo, pt_br: pt_bri19photo }

export const i19photos = { en_us: en_usi19photos, pt_br: pt_bri19photos }

export const i19pickup = { en_us: en_usi19pickup, pt_br: pt_bri19pickup }

export const i19pickUpAtTheStore = { en_us: en_usi19pickUpAtTheStore, pt_br: pt_bri19pickUpAtTheStore }

export const i19pickUpToday = { en_us: en_usi19pickUpToday, pt_br: pt_bri19pickUpToday }

export const i19picture = { en_us: en_usi19picture, pt_br: pt_bri19picture }

export const i19pictures = { en_us: en_usi19pictures, pt_br: pt_bri19pictures }

export const i19pointsEarned = { en_us: en_usi19pointsEarned, pt_br: pt_bri19pointsEarned }

export const i19popularProducts = { en_us: en_usi19popularProducts, pt_br: pt_bri19popularProducts }

export const i19popup = { en_us: en_usi19popup, pt_br: pt_bri19popup }

export const i19post = { en_us: en_usi19post, pt_br: pt_bri19post }

export const i19posted = { en_us: en_usi19posted, pt_br: pt_bri19posted }

export const i19postingDeadline = { en_us: en_usi19postingDeadline, pt_br: pt_bri19postingDeadline }

export const i19postingIn = { en_us: en_usi19postingIn, pt_br: pt_bri19postingIn }

export const i19pressEnterToSave = { en_us: en_usi19pressEnterToSave, pt_br: pt_bri19pressEnterToSave }

export const i19previous = { en_us: en_usi19previous, pt_br: pt_bri19previous }

export const i19price = { en_us: en_usi19price, pt_br: pt_bri19price }

export const i19priceAlteration = { en_us: en_usi19priceAlteration, pt_br: pt_bri19priceAlteration }

export const i19priceEffectiveDate = { en_us: en_usi19priceEffectiveDate, pt_br: pt_bri19priceEffectiveDate }

export const i19priceEffectiveDateEnd = { en_us: en_usi19priceEffectiveDateEnd, pt_br: pt_bri19priceEffectiveDateEnd }

export const i19priceEffectiveDateStar = { en_us: en_usi19priceEffectiveDateStar, pt_br: pt_bri19priceEffectiveDateStar }

export const i19priceRange = { en_us: en_usi19priceRange, pt_br: pt_bri19priceRange }

export const i19priceTo = { en_us: en_usi19priceTo, pt_br: pt_bri19priceTo }

export const i19pricing = { en_us: en_usi19pricing, pt_br: pt_bri19pricing }

export const i19printBillet = { en_us: en_usi19printBillet, pt_br: pt_bri19printBillet }

export const i19privacy = { en_us: en_usi19privacy, pt_br: pt_bri19privacy }

export const i19privacyPolicy = { en_us: en_usi19privacyPolicy, pt_br: pt_bri19privacyPolicy }

export const i19private = { en_us: en_usi19private, pt_br: pt_bri19private }

export const i19privateMetafields = { en_us: en_usi19privateMetafields, pt_br: pt_bri19privateMetafields }

export const i19privateMetafieldsMsg = { en_us: en_usi19privateMetafieldsMsg, pt_br: pt_bri19privateMetafieldsMsg }

export const i19proceed = { en_us: en_usi19proceed, pt_br: pt_bri19proceed }

export const i19product = { en_us: en_usi19product, pt_br: pt_bri19product }

export const i19productDescription = { en_us: en_usi19productDescription, pt_br: pt_bri19productDescription }

export const i19productId = { en_us: en_usi19productId, pt_br: pt_bri19productId }

export const i19productImages = { en_us: en_usi19productImages, pt_br: pt_bri19productImages }

export const i19productSpecifications = { en_us: en_usi19productSpecifications, pt_br: pt_bri19productSpecifications }

export const i19productionDeadline = { en_us: en_usi19productionDeadline, pt_br: pt_bri19productionDeadline }

export const i19productionTime = { en_us: en_usi19productionTime, pt_br: pt_bri19productionTime }

export const i19productionTimeMsg = { en_us: en_usi19productionTimeMsg }

export const i19productionTimeCumulative = { en_us: en_usi19productionTimeCumulative, pt_br: pt_bri19productionTimeCumulative }

export const i19productionTimeDaysMsg = { en_us: en_usi19productionTimeDaysMsg, pt_br: pt_bri19productionTimeDaysMsg }

export const i19productionTimeWorkingDays = { en_us: en_usi19productionTimeWorkingDays, pt_br: pt_bri19productionTimeWorkingDays }

export const i19productName = { en_us: en_usi19productName, pt_br: pt_bri19productName }

export const i19products = { en_us: en_usi19products, pt_br: pt_bri19products }

export const i19productsAdded = { en_us: en_usi19productsAdded, pt_br: pt_bri19productsAdded }

export const i19productsAddedToCart = { en_us: en_usi19productsAddedToCart, pt_br: pt_bri19productsAddedToCart }

export const i19productsPurchased = { en_us: en_usi19productsPurchased, pt_br: pt_bri19productsPurchased }

export const i19profile = { en_us: en_usi19profile, pt_br: pt_bri19profile }

export const i19profileNotFound = { en_us: en_usi19profileNotFound, pt_br: pt_bri19profileNotFound }

export const i19province = { en_us: en_usi19province, pt_br: pt_bri19province }

export const i19provinceCode = { en_us: en_usi19provinceCode, pt_br: pt_bri19provinceCode }

export const i19put = { en_us: en_usi19put, pt_br: pt_bri19put }

export const i19quantity = { en_us: en_usi19quantity, pt_br: pt_bri19quantity }

export const i19quarterly = { en_us: en_usi19quarterly, pt_br: pt_bri19quarterly }

export const i19quickSetup = { en_us: en_usi19quickSetup, pt_br: pt_bri19quickSetup }

export const i19random = { en_us: en_usi19random, pt_br: pt_bri19random }

export const i19rating = { en_us: en_usi19rating, pt_br: pt_bri19rating }

export const i19read = { en_us: en_usi19read, pt_br: pt_bri19read }

export const i19receipt = { en_us: en_usi19receipt, pt_br: pt_bri19receipt }

export const i19receiptPrice = { en_us: en_usi19receiptPrice, pt_br: pt_bri19receiptPrice }

export const i19receivedOrder = { en_us: en_usi19receivedOrder, pt_br: pt_bri19receivedOrder }

export const i19receiveNewsletter = { en_us: en_usi19receiveNewsletter, pt_br: pt_bri19receiveNewsletter }

export const i19receiveToday = { en_us: en_usi19receiveToday, pt_br: pt_bri19receiveToday }

export const i19recipient = { en_us: en_usi19recipient, pt_br: pt_bri19recipient }

export const i19recommendations = { en_us: en_usi19recommendations, pt_br: pt_bri19recommendations }

export const i19recommendedForYou = { en_us: en_usi19recommendedForYou, pt_br: pt_bri19recommendedForYou }

export const i19recommendedProducts = { en_us: en_usi19recommendedProducts, pt_br: pt_bri19recommendedProducts }

export const i19recurrence = { en_us: en_usi19recurrence, pt_br: pt_bri19recurrence }

export const i19recurrent = { en_us: en_usi19recurrent, pt_br: pt_bri19recurrent }

export const i19redirectToPayment = { en_us: en_usi19redirectToPayment, pt_br: pt_bri19redirectToPayment }

export const i19reference = { en_us: en_usi19reference, pt_br: pt_bri19reference }

export const i19referenceCode = { en_us: en_usi19referenceCode, pt_br: pt_bri19referenceCode }

export const i19referral = { en_us: en_usi19referral, pt_br: pt_bri19referral }

export const i19referringSite = { en_us: en_usi19referringSite, pt_br: pt_bri19referringSite }

export const i19refine = { en_us: en_usi19refine, pt_br: pt_bri19refine }

export const i19refineSearch = { en_us: en_usi19refineSearch, pt_br: pt_bri19refineSearch }

export const i19reinstall = { en_us: en_usi19reinstall, pt_br: pt_bri19reinstall }

export const i19registerDate = { en_us: en_usi19registerDate, pt_br: pt_bri19registerDate }

export const i19registerProduct = { en_us: en_usi19registerProduct, pt_br: pt_bri19registerProduct }

export const i19registerToBuy = { en_us: en_usi19registerToBuy, pt_br: pt_bri19registerToBuy }

export const i19registerToBuyMsg = { en_us: en_usi19registerToBuyMsg, pt_br: pt_bri19registerToBuyMsg }

export const i19registration = { en_us: en_usi19registration, pt_br: pt_bri19registration }

export const i19relatedApps = { en_us: en_usi19relatedApps, pt_br: pt_bri19relatedApps }

export const i19relatedProduct = { en_us: en_usi19relatedProduct, pt_br: pt_bri19relatedProduct }

export const i19relatedSearch = { en_us: en_usi19relatedSearch, pt_br: pt_bri19relatedSearch }

export const i19releases = { en_us: en_usi19releases, pt_br: pt_bri19releases }

export const i19relevance = { en_us: en_usi19relevance, pt_br: pt_bri19relevance }

export const i19remove = { en_us: en_usi19remove, pt_br: pt_bri19remove }

export const i19removed = { en_us: en_usi19removed, pt_br: pt_bri19removed }

export const i19removeFromFavorites = { en_us: en_usi19removeFromFavorites, pt_br: pt_bri19removeFromFavorites }

export const i19reopenOrder = { en_us: en_usi19reopenOrder, pt_br: pt_bri19reopenOrder }

export const i19require = { en_us: en_usi19require, pt_br: pt_bri19require }

export const i19required = { en_us: en_usi19required, pt_br: pt_bri19required }

export const i19requiredEmail = { en_us: en_usi19requiredEmail, pt_br: pt_bri19requiredEmail }

export const i19requiredEmailMsg = { en_us: en_usi19requiredEmailMsg, pt_br: pt_bri19requiredEmailMsg }

export const i19requiredField = { en_us: en_usi19requiredField, pt_br: pt_bri19requiredField }

export const i19resource = { en_us: en_usi19resource, pt_br: pt_bri19resource }

export const i19resourceId = { en_us: en_usi19resourceId, pt_br: pt_bri19resourceId }

export const i19results = { en_us: en_usi19results, pt_br: pt_bri19results }

export const i19resultsFor = { en_us: en_usi19resultsFor, pt_br: pt_bri19resultsFor }

export const i19retail = { en_us: en_usi19retail, pt_br: pt_bri19retail }

export const i19retry = { en_us: en_usi19retry, pt_br: pt_bri19retry }

export const i19reviews = { en_us: en_usi19reviews, pt_br: pt_bri19reviews }

export const i19safeEnvMsg = { en_us: en_usi19safeEnvMsg, pt_br: pt_bri19safeEnvMsg }

export const i19sales = { en_us: en_usi19sales, pt_br: pt_bri19sales }

export const i19salesPrice = { en_us: en_usi19salesPrice, pt_br: pt_bri19salesPrice }

export const i19salesChannels = { en_us: en_usi19salesChannels, pt_br: pt_bri19salesChannels }

export const i19save = { en_us: en_usi19save, pt_br: pt_bri19save }

export const i19saveBrand = { en_us: en_usi19saveBrand, pt_br: pt_bri19saveBrand }

export const i19saveCard = { en_us: en_usi19saveCard, pt_br: pt_bri19saveCard }

export const i19saveCart = { en_us: en_usi19saveCart, pt_br: pt_bri19saveCart }

export const i19saveCategory = { en_us: en_usi19saveCategory, pt_br: pt_bri19saveCategory }

export const i19saveClient = { en_us: en_usi19saveClient, pt_br: pt_bri19saveClient }

export const i19saved = { en_us: en_usi19saved, pt_br: pt_bri19saved }

export const i19savedWithSuccess = { en_us: en_usi19savedWithSuccess, pt_br: pt_bri19savedWithSuccess }

export const i19saveCollection = { en_us: en_usi19saveCollection, pt_br: pt_bri19saveCollection }

export const i19saveGrid = { en_us: en_usi19saveGrid, pt_br: pt_bri19saveGrid }

export const i19saveProduct = { en_us: en_usi19saveProduct, pt_br: pt_bri19saveProduct }

export const i19saveText = { en_us: en_usi19saveText, pt_br: pt_bri19saveText }

export const i19scheduledDelivery = { en_us: en_usi19scheduledDelivery, pt_br: pt_bri19scheduledDelivery }

export const i19search = { en_us: en_usi19search, pt_br: pt_bri19search }

export const i19searchAgain = { en_us: en_usi19searchAgain, pt_br: pt_bri19searchAgain }

export const i19searchEngineListing = { en_us: en_usi19searchEngineListing, pt_br: pt_bri19searchEngineListing }

export const i19searchingFor = { en_us: en_usi19searchingFor, pt_br: pt_bri19searchingFor }

export const i19searchItems = { en_us: en_usi19searchItems, pt_br: pt_bri19searchItems }

export const i19searchOfflineErrorMsg = { en_us: en_usi19searchOfflineErrorMsg, pt_br: pt_bri19searchOfflineErrorMsg }

export const i19searchProducts = { en_us: en_usi19searchProducts, pt_br: pt_bri19searchProducts }

export const i19securityCode = { en_us: en_usi19securityCode, pt_br: pt_bri19securityCode }

export const i19seeAll = { en_us: en_usi19seeAll, pt_br: pt_bri19seeAll }

export const i19seeAllApps = { en_us: en_usi19seeAllApps, pt_br: pt_bri19seeAllApps }

export const i19seeAllThemes = { en_us: en_usi19seeAllThemes, pt_br: pt_bri19seeAllThemes }

export const i19seeAll$1Category = { en_us: en_usi19seeAll$1Category, pt_br: pt_bri19seeAll$1Category }

export const i19seeCart = { en_us: en_usi19seeCart, pt_br: pt_bri19seeCart }

export const i19seeMore = { en_us: en_usi19seeMore, pt_br: pt_bri19seeMore }

export const i19seeMoreCategories = { en_us: en_usi19seeMoreCategories }

export const i19seeMoreInfo = { en_us: en_usi19seeMoreInfo, pt_br: pt_bri19seeMoreInfo }

export const i19seeOrder = { en_us: en_usi19seeOrder, pt_br: pt_bri19seeOrder }

export const i19seeShoppingCart = { en_us: en_usi19seeShoppingCart, pt_br: pt_bri19seeShoppingCart }

export const i19select = { en_us: en_usi19select, pt_br: pt_bri19select }

export const i19selected = { en_us: en_usi19selected, pt_br: pt_bri19selected }

export const i19selectedOffers = { en_us: en_usi19selectedOffers, pt_br: pt_bri19selectedOffers }

export const i19selectedOptions = { en_us: en_usi19selectedOptions, pt_br: pt_bri19selectedOptions }

export const i19selectVariation = { en_us: en_usi19selectVariation, pt_br: pt_bri19selectVariation }

export const i19selectVariationMsg = { en_us: en_usi19selectVariationMsg, pt_br: pt_bri19selectVariationMsg }

export const i19seller = { en_us: en_usi19seller, pt_br: pt_bri19seller }

export const i19sellerRecommendations = { en_us: en_usi19sellerRecommendations, pt_br: pt_bri19sellerRecommendations }

export const i19sellerRecommendationsProducts = { en_us: en_usi19sellerRecommendationsProducts, pt_br: pt_bri19sellerRecommendationsProducts }

export const i19sellerRecommendationsTitle = { en_us: en_usi19sellerRecommendationsTitle, pt_br: pt_bri19sellerRecommendationsTitle }

export const i19sellerStatus = { en_us: en_usi19sellerStatus, pt_br: pt_bri19sellerStatus }

export const i19send = { en_us: en_usi19send, pt_br: pt_bri19send }

export const i19sender = { en_us: en_usi19sender, pt_br: pt_bri19sender }

export const i19senderFrom = { en_us: en_usi19senderFrom, pt_br: pt_bri19senderFrom }

export const i19sendLoginCodeByEmail = { en_us: en_usi19sendLoginCodeByEmail, pt_br: pt_bri19sendLoginCodeByEmail }

export const i19seo = { en_us: en_usi19seo, pt_br: pt_bri19seo }

export const i19setDomainMsg = { en_us: en_usi19setDomainMsg, pt_br: pt_bri19setDomainMsg }

export const i19setStoreDomain = { en_us: en_usi19setStoreDomain, pt_br: pt_bri19setStoreDomain }

export const i19settings = { en_us: en_usi19settings, pt_br: pt_bri19settings }

export const i19setUp = { en_us: en_usi19setUp, pt_br: pt_bri19setUp }

export const i19share = { en_us: en_usi19share, pt_br: pt_bri19share }

export const i19shareOnFacebook = { en_us: en_usi19shareOnFacebook, pt_br: pt_bri19shareOnFacebook }

export const i19shareOnWhatsapp = { en_us: en_usi19shareOnWhatsapp, pt_br: pt_bri19shareOnWhatsapp }

export const i19shipped = { en_us: en_usi19shipped, pt_br: pt_bri19shipped }

export const i19shippedBy = { en_us: en_usi19shippedBy, pt_br: pt_bri19shippedBy }

export const i19shipping = { en_us: en_usi19shipping, pt_br: pt_bri19shipping }

export const i19shippingAdditionalPrice = { en_us: en_usi19shippingAdditionalPrice, pt_br: pt_bri19shippingAdditionalPrice }

export const i19shippingAddress = { en_us: en_usi19shippingAddress, pt_br: pt_bri19shippingAddress }

export const i19shippingCustomFields = { en_us: en_usi19shippingCustomFields, pt_br: pt_bri19shippingCustomFields }

export const i19shippingDiscount = { en_us: en_usi19shippingDiscount, pt_br: pt_bri19shippingDiscount }

export const i19shippingInvoices = { en_us: en_usi19shippingInvoices, pt_br: pt_bri19shippingInvoices }

export const i19shippingMethod = { en_us: en_usi19shippingMethod, pt_br: pt_bri19shippingMethod }

export const i19shippingMethodLabel = { en_us: en_usi19shippingMethodLabel, pt_br: pt_bri19shippingMethodLabel }

export const i19shippingNotes = { en_us: en_usi19shippingNotes, pt_br: pt_bri19shippingNotes }

export const i19shippingNotesMsg = { en_us: en_usi19shippingNotesMsg, pt_br: pt_bri19shippingNotesMsg }

export const i19shippingStatus = { en_us: en_usi19shippingStatus, pt_br: pt_bri19shippingStatus }

export const i19shippingTag = { en_us: en_usi19shippingTag, pt_br: pt_bri19shippingTag }

export const i19shippingTags = { en_us: en_usi19shippingTags, pt_br: pt_bri19shippingTags }

export const i19shippingTaxes = { en_us: en_usi19shippingTaxes, pt_br: pt_bri19shippingTaxes }

export const i19shippingTaxesMsg = { en_us: en_usi19shippingTaxesMsg, pt_br: pt_bri19shippingTaxesMsg }

export const i19shippingTo = { en_us: en_usi19shippingTo, pt_br: pt_bri19shippingTo }

export const i19shippingTotalCost = { en_us: en_usi19shippingTotalCost, pt_br: pt_bri19shippingTotalCost }

export const i19shopByCategory = { en_us: en_usi19shopByCategory, pt_br: pt_bri19shopByCategory }

export const i19shopByFranchise = { en_us: en_usi19shopByFranchise, pt_br: pt_bri19shopByFranchise }

export const i19shopNow = { en_us: en_usi19shopNow, pt_br: pt_bri19shopNow }

export const i19shoppingCart = { en_us: en_usi19shoppingCart, pt_br: pt_bri19shoppingCart }

export const i19short = { en_us: en_usi19short, pt_br: pt_bri19short }

export const i19shortDescription = { en_us: en_usi19shortDescription, pt_br: pt_bri19shortDescription }

export const i19show = { en_us: en_usi19show, pt_br: pt_bri19show }

export const i19showDescription = { en_us: en_usi19showDescription, pt_br: pt_bri19showDescription }

export const i19showReview = { en_us: en_usi19showReview, pt_br: pt_bri19showReview }

export const i19signIn = { en_us: en_usi19signIn, pt_br: pt_bri19signIn }

export const i19signInWith = { en_us: en_usi19signInWith, pt_br: pt_bri19signInWith }

export const i19signInWithAnotherEmail = { en_us: en_usi19signInWithAnotherEmail, pt_br: pt_bri19signInWithAnotherEmail }

export const i19signUp = { en_us: en_usi19signUp, pt_br: pt_bri19signUp }

export const i19signUpWith = { en_us: en_usi19signUpWith, pt_br: pt_bri19signUpWith }

export const i19signature = { en_us: en_usi19signature, pt_br: pt_bri19signature }

export const i19size = { en_us: en_usi19size, pt_br: pt_bri19size }

export const i19sizeGuide = { en_us: en_usi19sizeGuide, pt_br: pt_bri19sizeGuide }

export const i19sku = { en_us: en_usi19sku, pt_br: pt_bri19sku }

export const i19slug = { en_us: en_usi19slug, pt_br: pt_bri19slug }

export const i19socialLogin = { en_us: en_usi19socialLogin, pt_br: pt_bri19socialLogin }

export const i19socialMedia = { en_us: en_usi19socialMedia, pt_br: pt_bri19socialMedia }

export const i19source = { en_us: en_usi19source, pt_br: pt_bri19source }

export const i19sourceName = { en_us: en_usi19sourceName, pt_br: pt_bri19sourceName }

export const i19sort = { en_us: en_usi19sort, pt_br: pt_bri19sort }

export const i19sortBy = { en_us: en_usi19sortBy, pt_br: pt_bri19sortBy }

export const i19subscribe = { en_us: en_usi19subscribe, pt_br: pt_bri19subscribe }

export const i19subscription = { en_us: en_usi19subscription, pt_br: pt_bri19subscription }

export const i19subscriptionInvoices = { en_us: en_usi19subscriptionInvoices, pt_br: pt_bri19subscriptionInvoices }

export const i19subscriptions = { en_us: en_usi19subscriptions, pt_br: pt_bri19subscriptions }

export const i19submit = { en_us: en_usi19submit, pt_br: pt_bri19submit }

export const i19suggestedProducts = { en_us: en_usi19suggestedProducts, pt_br: pt_bri19suggestedProducts }

export const i19specifications = { en_us: en_usi19specifications, pt_br: pt_bri19specifications }

export const i19staffNotes = { en_us: en_usi19staffNotes, pt_br: pt_bri19staffNotes }

export const i19staffSignature = { en_us: en_usi19staffSignature, pt_br: pt_bri19staffSignature }

export const i19star = { en_us: en_usi19star, pt_br: pt_bri19star }

export const i19startDate = { en_us: en_usi19startDate, pt_br: pt_bri19startDate }

export const i19state = { en_us: en_usi19state, pt_br: pt_bri19state }

export const i19status = { en_us: en_usi19status, pt_br: pt_bri19status }

export const i19statusLink = { en_us: en_usi19statusLink, pt_br: pt_bri19statusLink }

export const i19statusMobileLink = { en_us: en_usi19statusMobileLink, pt_br: pt_bri19statusMobileLink }

export const i19street = { en_us: en_usi19street, pt_br: pt_bri19street }

export const i19store = { en_us: en_usi19store, pt_br: pt_bri19store }

export const i19storefront = { en_us: en_usi19storefront, pt_br: pt_bri19storefront }

export const i19subresource = { en_us: en_usi19subresource, pt_br: pt_bri19subresource }

export const i19subresourceId = { en_us: en_usi19subresourceId, pt_br: pt_bri19subresourceId }

export const i19subtitle = { en_us: en_usi19subtitle, pt_br: pt_bri19subtitle }

export const i19subtotal = { en_us: en_usi19subtotal, pt_br: pt_bri19subtotal }

export const i19success = { en_us: en_usi19success, pt_br: pt_bri19success }

export const i19successfullyInstalled = { en_us: en_usi19successfullyInstalled, pt_br: pt_bri19successfullyInstalled }

export const i19successfullyUninstalled = { en_us: en_usi19successfullyUninstalled, pt_br: pt_bri19successfullyUninstalled }

export const i19summary = { en_us: en_usi19summary, pt_br: pt_bri19summary }

export const i19support = { en_us: en_usi19support, pt_br: pt_bri19support }

export const i19table = { en_us: en_usi19table, pt_br: pt_bri19table }

export const i19tax = { en_us: en_usi19tax, pt_br: pt_bri19tax }

export const i19taxExempt = { en_us: en_usi19taxExempt, pt_br: pt_bri19taxExempt }

export const i19termSearched = { en_us: en_usi19termSearched, pt_br: pt_bri19termSearched }

export const i19test = { en_us: en_usi19test, pt_br: pt_bri19test }

export const i19thanks = { en_us: en_usi19thanks, pt_br: pt_bri19thanks }

export const i19thanksForPurchase = { en_us: en_usi19thanksForPurchase, pt_br: pt_bri19thanksForPurchase }

export const i19theme = { en_us: en_usi19theme, pt_br: pt_bri19theme }

export const i19themes = { en_us: en_usi19themes, pt_br: pt_bri19themes }

export const i19ticketCode = { en_us: en_usi19ticketCode, pt_br: pt_bri19ticketCode }

export const i19title = { en_us: en_usi19title, pt_br: pt_bri19title }

export const i19titleTag = { en_us: en_usi19titleTag, pt_br: pt_bri19titleTag }

export const i19to = { en_us: en_usi19to, pt_br: pt_bri19to }

export const i19toEarn = { en_us: en_usi19toEarn, pt_br: pt_bri19toEarn }

export const i19toPay = { en_us: en_usi19toPay, pt_br: pt_bri19toPay }

export const i19today = { en_us: en_usi19today, pt_br: pt_bri19today }

export const i19token = { en_us: en_usi19token, pt_br: pt_bri19token }

export const i19total = { en_us: en_usi19total, pt_br: pt_bri19total }

export const i19totalAmount = { en_us: en_usi19totalAmount, pt_br: pt_bri19totalAmount }

export const i19totalCancelled = { en_us: en_usi19totalCancelled, pt_br: pt_bri19totalCancelled }

export const i19totalCancelledMsg = { en_us: en_usi19totalCancelledMsg, pt_br: pt_bri19totalCancelledMsg }

export const i19totalResultsFor = { en_us: en_usi19totalResultsFor, pt_br: pt_bri19totalResultsFor }

export const i19totalSpent = { en_us: en_usi19totalSpent, pt_br: pt_bri19totalSpent }

export const i19trackDelivery = { en_us: en_usi19trackDelivery, pt_br: pt_bri19trackDelivery }

export const i19trackingCodes = { en_us: en_usi19trackingCodes, pt_br: pt_bri19trackingCodes }

export const i19transactionCode = { en_us: en_usi19transactionCode, pt_br: pt_bri19transactionCode }

export const i19transactionId = { en_us: en_usi19transactionId, pt_br: pt_bri19transactionId }

export const i19transactionItems = { en_us: en_usi19transactionItems, pt_br: pt_bri19transactionItems }

export const i19transactionStatus = { en_us: en_usi19transactionStatus, pt_br: pt_bri19transactionStatus }

export const i19transactionStatusMsg = { en_us: en_usi19transactionStatusMsg, pt_br: pt_bri19transactionStatusMsg }

export const i19transactionType = { en_us: en_usi19transactionType, pt_br: pt_bri19transactionType }

export const i19trendingApps = { en_us: en_usi19trendingApps, pt_br: pt_bri19trendingApps }

export const i19triggers = { en_us: en_usi19triggers, pt_br: pt_bri19triggers }

export const i19triggersMsg = { en_us: en_usi19triggersMsg, pt_br: pt_bri19triggersMsg }

export const i19tryAgain = { en_us: en_usi19tryAgain, pt_br: pt_bri19tryAgain }

export const i19type = { en_us: en_usi19type, pt_br: pt_bri19type }

export const i19unable = { en_us: en_usi19unable, pt_br: pt_bri19unable }

export const i19unableToInstallApp = { en_us: en_usi19unableToInstallApp, pt_br: pt_bri19unableToInstallApp }

export const i19unableToUninstallApp = { en_us: en_usi19unableToUninstallApp, pt_br: pt_bri19unableToUninstallApp }

export const i19unavailable = { en_us: en_usi19unavailable, pt_br: pt_bri19unavailable }

export const i19uninstall = { en_us: en_usi19uninstall, pt_br: pt_bri19uninstall }

export const i19uninstallingApp = { en_us: en_usi19uninstallingApp, pt_br: pt_bri19uninstallingApp }

export const i19uninstallingAppWithSuccess = { en_us: en_usi19uninstallingAppWithSuccess, pt_br: pt_bri19uninstallingAppWithSuccess }

export const i19units = { en_us: en_usi19units, pt_br: pt_bri19units }

export const i19unitsInStock = { en_us: en_usi19unitsInStock, pt_br: pt_bri19unitsInStock }

export const i19unlimited = { en_us: en_usi19unlimited, pt_br: pt_bri19unlimited }

export const i19untilTomorrow = { en_us: en_usi19untilTomorrow, pt_br: pt_bri19untilTomorrow }

export const i19unsubscribe = { en_us: en_usi19unsubscribe, pt_br: pt_bri19unsubscribe }

export const i19update = { en_us: en_usi19update, pt_br: pt_bri19update }

export const i19updatedAt = { en_us: en_usi19updatedAt, pt_br: pt_bri19updatedAt }

export const i19upload = { en_us: en_usi19upload, pt_br: pt_bri19upload }

export const i19uploadLogo = { en_us: en_usi19uploadLogo, pt_br: pt_bri19uploadLogo }

export const i19uploadTable = { en_us: en_usi19uploadTable, pt_br: pt_bri19uploadTable }

export const i19upTo = { en_us: en_usi19upTo, pt_br: pt_bri19upTo }

export const i19user = { en_us: en_usi19user, pt_br: pt_bri19user }

export const i19userFound = { en_us: en_usi19userFound, pt_br: pt_bri19userFound }

export const i19username = { en_us: en_usi19username, pt_br: pt_bri19username }

export const i19usersFound = { en_us: en_usi19usersFound, pt_br: pt_bri19usersFound }

export const i19use$1LoyaltyPoints = { en_us: en_usi19use$1LoyaltyPoints, pt_br: pt_bri19use$1LoyaltyPoints }

export const i19utm = { en_us: en_usi19utm, pt_br: pt_bri19utm }

export const i19utmCampaign = { en_us: en_usi19utmCampaign, pt_br: pt_bri19utmCampaign }

export const i19utmContent = { en_us: en_usi19utmContent, pt_br: pt_bri19utmContent }

export const i19utmMedium = { en_us: en_usi19utmMedium, pt_br: pt_bri19utmMedium }

export const i19utmSource = { en_us: en_usi19utmSource, pt_br: pt_bri19utmSource }

export const i19utmTerm = { en_us: en_usi19utmTerm, pt_br: pt_bri19utmTerm }

export const i19url = { en_us: en_usi19url, pt_br: pt_bri19url }

export const i19valid = { en_us: en_usi19valid, pt_br: pt_bri19valid }

export const i19validate = { en_us: en_usi19validate, pt_br: pt_bri19validate }

export const i19validThru = { en_us: en_usi19validThru, pt_br: pt_bri19validThru }

export const i19value = { en_us: en_usi19value, pt_br: pt_bri19value }

export const i19variation = { en_us: en_usi19variation, pt_br: pt_bri19variation }

export const i19variationId = { en_us: en_usi19variationId, pt_br: pt_bri19variationId }

export const i19variationName = { en_us: en_usi19variationName, pt_br: pt_bri19variationName }

export const i19variations = { en_us: en_usi19variations, pt_br: pt_bri19variations }

export const i19verified = { en_us: en_usi19verified, pt_br: pt_bri19verified }

export const i19version = { en_us: en_usi19version, pt_br: pt_bri19version }

export const i19versionDate = { en_us: en_usi19versionDate, pt_br: pt_bri19versionDate }

export const i19video = { en_us: en_usi19video, pt_br: pt_bri19video }

export const i19videos = { en_us: en_usi19videos, pt_br: pt_bri19videos }

export const i19visible = { en_us: en_usi19visible, pt_br: pt_bri19visible }

export const i19visibleProducts = { en_us: en_usi19visibleProducts, pt_br: pt_bri19visibleProducts }

export const i19visitor = { en_us: en_usi19visitor, pt_br: pt_bri19visitor }

export const i19visitorCheckout = { en_us: en_usi19visitorCheckout, pt_br: pt_bri19visitorCheckout }

export const i19warning = { en_us: en_usi19warning, pt_br: pt_bri19warning }

export const i19warningToReinstallAppMsg = { en_us: en_usi19warningToReinstallAppMsg, pt_br: pt_bri19warningToReinstallAppMsg }

export const i19wasAnErrorOnLoginMsg = { en_us: en_usi19wasAnErrorOnLoginMsg }

export const i19webhooks = { en_us: en_usi19webhooks, pt_br: pt_bri19webhooks }

export const i19webhooksMsg = { en_us: en_usi19webhooksMsg, pt_br: pt_bri19webhooksMsg }

export const i19webhooksApiMsg = { en_us: en_usi19webhooksApiMsg, pt_br: pt_bri19webhooksApiMsg }

export const i19webhooksApiExternalApiMsg = { en_us: en_usi19webhooksApiExternalApiMsg, pt_br: pt_bri19webhooksApiExternalApiMsg }

export const i19webhooksApiStoreApiMsg = { en_us: en_usi19webhooksApiStoreApiMsg, pt_br: pt_bri19webhooksApiStoreApiMsg }

export const i19webhooksMapBodyMsg = { en_us: en_usi19webhooksMapBodyMsg, pt_br: pt_bri19webhooksMapBodyMsg }

export const i19webhooksSendBodyMsg = { en_us: en_usi19webhooksSendBodyMsg, pt_br: pt_bri19webhooksSendBodyMsg }

export const i19weekly = { en_us: en_usi19weekly, pt_br: pt_bri19weekly }

export const i19weight = { en_us: en_usi19weight, pt_br: pt_bri19weight }

export const i19weFrom = { en_us: en_usi19weFrom, pt_br: pt_bri19weFrom }

export const i19welcome = { en_us: en_usi19welcome, pt_br: pt_bri19welcome }

export const i19welcomeTextMsg = { en_us: en_usi19welcomeTextMsg, pt_br: pt_bri19welcomeTextMsg }

export const i19weRecommendToYou = { en_us: en_usi19weRecommendToYou, pt_br: pt_bri19weRecommendToYou }

export const i19weUseYourDataToMsg = { en_us: en_usi19weUseYourDataToMsg, pt_br: pt_bri19weUseYourDataToMsg }

export const i19widgets = { en_us: en_usi19widgets, pt_br: pt_bri19widgets }

export const i19width = { en_us: en_usi19width, pt_br: pt_bri19width }

export const i19willReceiveMsg = { en_us: en_usi19willReceiveMsg, pt_br: pt_bri19willReceiveMsg }

export const i19with = { en_us: en_usi19with, pt_br: pt_bri19with }

export const i19withoutInstallmentRates = { en_us: en_usi19withoutInstallmentRates, pt_br: pt_bri19withoutInstallmentRates }

export const i19write = { en_us: en_usi19write, pt_br: pt_bri19write }

export const i19writeReview = { en_us: en_usi19writeReview, pt_br: pt_bri19writeReview }

export const i19workingDays = { en_us: en_usi19workingDays, pt_br: pt_bri19workingDays }

export const i19year = { en_us: en_usi19year, pt_br: pt_bri19year }

export const i19yearly = { en_us: en_usi19yearly, pt_br: pt_bri19yearly }

export const i19years = { en_us: en_usi19years, pt_br: pt_bri19years }

export const i19yes = { en_us: en_usi19yes, pt_br: pt_bri19yes }

export const i19youEarn = { en_us: en_usi19youEarn, pt_br: pt_bri19youEarn }

export const i19yourInstalledApps = { en_us: en_usi19yourInstalledApps, pt_br: pt_bri19yourInstalledApps }

export const i19zipCode = { en_us: en_usi19zipCode, pt_br: pt_bri19zipCode }

export const i19zipCodeRange = { en_us: en_usi19zipCodeRange, pt_br: pt_bri19zipCodeRange }

export const i19CancelReason = { en_us: en_usi19CancelReason, pt_br: pt_bri19CancelReason }

export const i19ChannelType = { en_us: en_usi19ChannelType, pt_br: pt_bri19ChannelType }

export const i19CommodityType = { en_us: en_usi19CommodityType, pt_br: pt_bri19CommodityType }

export const i19ProductCondition = { en_us: en_usi19ProductCondition, pt_br: pt_bri19ProductCondition }

export const i19DiscountApplyAt = { en_us: en_usi19DiscountApplyAt, pt_br: pt_bri19DiscountApplyAt }

export const i19DiscountType = { en_us: en_usi19DiscountType, pt_br: pt_bri19DiscountType }

export const i19FinancialStatus = { en_us: en_usi19FinancialStatus, pt_br: pt_bri19FinancialStatus }

export const i19FinancialStatusMsg = { en_us: en_usi19FinancialStatusMsg, pt_br: pt_bri19FinancialStatusMsg }

export const i19FulfillmentStatus = { en_us: en_usi19FulfillmentStatus, pt_br: pt_bri19FulfillmentStatus }

export const i19FulfillmentStatusMsg = { en_us: en_usi19FulfillmentStatusMsg, pt_br: pt_bri19FulfillmentStatusMsg }

export const i19Gender = { en_us: en_usi19Gender, pt_br: pt_bri19Gender }

export const i19InscriptionType = { en_us: en_usi19InscriptionType, pt_br: pt_bri19InscriptionType }

export const i19OrderStatus = { en_us: en_usi19OrderStatus, pt_br: pt_bri19OrderStatus }

export const i19PaymentMethodCodes = { en_us: en_usi19PaymentMethodCodes, pt_br: pt_bri19PaymentMethodCodes }

export const i19PaymentsHistoryStatus = { en_us: en_usi19PaymentsHistoryStatus, pt_br: pt_bri19PaymentsHistoryStatus }

export const i19PhoneType = { en_us: en_usi19PhoneType, pt_br: pt_bri19PhoneType }

export const i19RegistryType = { en_us: en_usi19RegistryType, pt_br: pt_bri19RegistryType }

export const i19ShippingLinesStatus = { en_us: en_usi19ShippingLinesStatus, pt_br: pt_bri19ShippingLinesStatus }

export const i19StateRegister = { en_us: en_usi19StateRegister, pt_br: pt_bri19StateRegister }

export const i19TransactionsType = { en_us: en_usi19TransactionsType, pt_br: pt_bri19TransactionsType }

export const i19ApiActions = { en_us: en_usi19ApiActions, pt_br: pt_bri19ApiActions }

export const i19StoreApiResources = { en_us: en_usi19StoreApiResources, pt_br: pt_bri19StoreApiResources }

export const i19emailProfileNotFoundMsg = { pt_br: pt_bri19emailProfileNotFoundMsg }

export const i19idOfShippingMethod = { pt_br: pt_bri19idOfShippingMethod }

export const i19seeMoreCategory = { pt_br: pt_bri19seeMoreCategory }

export const i19sellerStatusMsg = { pt_br: pt_bri19sellerStatusMsg }

export const i19wasAnErrorOnLogin = { pt_br: pt_bri19wasAnErrorOnLogin }
